// source: singlegeneralorderhandling.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var session_pb = require('./session_pb.js');
goog.object.extend(proto, session_pb);
goog.exportSymbol('proto.SingleGeneralOrderHandling.AccountTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.AcctIDSourceEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.AffectedOrdGrp', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.BookingTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.BookingUnitEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CancellationRightsEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CashMarginEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CrossTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CustOrderCapacityEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CxlRejReasonEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.CxlRejResponseToEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.DKReasonEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.DayBookingInstEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.DontKnowTrade', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecAckStatusEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecInstEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecPriceTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionAcknowledgement', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.ExecRestatementReasonUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.OrdRejReasonUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.SettlTypeUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.TargetStrategyUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.FillLiquidityIndEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.FillsGrp', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.GTBookingInstEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.HandlInstEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.LastCapacityEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.LastLiquidityIndEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.LotTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.MatchTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.NewOrderSingle', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.NewOrderSingle.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.NewOrderSingle.SettlTypeUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.NewOrderSingle.TargetStrategyUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrdRejReasonEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrdStatusEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrdTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReject', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReject.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReject.CxlRejReasonUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.SettlTypeUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.TargetStrategyUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelRequest', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCancelRequest.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCapacityEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderCategoryEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderRestrictionsEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderStatusRequest', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.OrderStatusRequest.AcctIdSourceUnionCase', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.PositionEffectEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.PreallocMethodEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.PriceTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.PriorityIndicatorEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.ProcessCodeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.QtyTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.SettlTypeEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.SideEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.TargetStrategyEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.TimeInForceEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.TradingSessionIDEnum', null, global);
goog.exportSymbol('proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SingleGeneralOrderHandling.AffectedOrdGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.AffectedOrdGrp.displayName = 'proto.SingleGeneralOrderHandling.AffectedOrdGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.FillsGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.FillsGrp.repeatedFields_, null);
};
goog.inherits(proto.SingleGeneralOrderHandling.FillsGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.FillsGrp.displayName = 'proto.SingleGeneralOrderHandling.FillsGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.ExecutionReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.ExecutionReport.repeatedFields_, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.ExecutionReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.ExecutionReport.displayName = 'proto.SingleGeneralOrderHandling.ExecutionReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.OrderCancelReject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.OrderCancelReject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.OrderCancelReject.displayName = 'proto.SingleGeneralOrderHandling.OrderCancelReject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.NewOrderSingle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.NewOrderSingle.repeatedFields_, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.NewOrderSingle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.NewOrderSingle.displayName = 'proto.SingleGeneralOrderHandling.NewOrderSingle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.OrderCancelRequest.repeatedFields_, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.OrderCancelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.OrderCancelRequest.displayName = 'proto.SingleGeneralOrderHandling.OrderCancelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.repeatedFields_, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.displayName = 'proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.OrderStatusRequest.repeatedFields_, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_);
};
goog.inherits(proto.SingleGeneralOrderHandling.OrderStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.OrderStatusRequest.displayName = 'proto.SingleGeneralOrderHandling.OrderStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.DontKnowTrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.DontKnowTrade.repeatedFields_, null);
};
goog.inherits(proto.SingleGeneralOrderHandling.DontKnowTrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.DontKnowTrade.displayName = 'proto.SingleGeneralOrderHandling.DontKnowTrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.repeatedFields_, null);
};
goog.inherits(proto.SingleGeneralOrderHandling.ExecutionAcknowledgement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.displayName = 'proto.SingleGeneralOrderHandling.ExecutionAcknowledgement';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.AffectedOrdGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    affectedOrderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    affectedSecondaryOrderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    origClOrdId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.AffectedOrdGrp}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.AffectedOrdGrp;
  return proto.SingleGeneralOrderHandling.AffectedOrdGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.AffectedOrdGrp}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffectedOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffectedSecondaryOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigClOrdId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.AffectedOrdGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAffectedOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAffectedSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrigClOrdId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string affected_order_id = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.getAffectedOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} returns this
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.setAffectedOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string affected_secondary_order_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.getAffectedSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} returns this
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.setAffectedSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string orig_cl_ord_id = 3;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.getOrigClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.AffectedOrdGrp} returns this
 */
proto.SingleGeneralOrderHandling.AffectedOrdGrp.prototype.setOrigClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.FillsGrp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.FillsGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.FillsGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.FillsGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    fillExecId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fillPx: (f = msg.getFillPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    fillQty: (f = msg.getFillQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    nestedParties4List: jspb.Message.toObjectList(msg.getNestedParties4List(),
    common_pb.NestedParties4.toObject, includeInstance),
    fillLiquidityInd: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp}
 */
proto.SingleGeneralOrderHandling.FillsGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.FillsGrp;
  return proto.SingleGeneralOrderHandling.FillsGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.FillsGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp}
 */
proto.SingleGeneralOrderHandling.FillsGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFillExecId(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFillPx(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFillQty(value);
      break;
    case 4:
      var value = new common_pb.NestedParties4;
      reader.readMessage(value,common_pb.NestedParties4.deserializeBinaryFromReader);
      msg.addNestedParties4(value);
      break;
    case 5:
      var value = /** @type {!proto.SingleGeneralOrderHandling.FillLiquidityIndEnum} */ (reader.readEnum());
      msg.setFillLiquidityInd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.FillsGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.FillsGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.FillsGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFillExecId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFillPx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFillQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNestedParties4List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.NestedParties4.serializeBinaryToWriter
    );
  }
  f = message.getFillLiquidityInd();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string fill_exec_id = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.getFillExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.setFillExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional fix.Decimal64 fill_px = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.getFillPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
*/
proto.SingleGeneralOrderHandling.FillsGrp.prototype.setFillPx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.clearFillPx = function() {
  return this.setFillPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.hasFillPx = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 fill_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.getFillQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
*/
proto.SingleGeneralOrderHandling.FillsGrp.prototype.setFillQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.clearFillQty = function() {
  return this.setFillQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.hasFillQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Common.NestedParties4 nested_parties4 = 4;
 * @return {!Array<!proto.Common.NestedParties4>}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.getNestedParties4List = function() {
  return /** @type{!Array<!proto.Common.NestedParties4>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.NestedParties4, 4));
};


/**
 * @param {!Array<!proto.Common.NestedParties4>} value
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
*/
proto.SingleGeneralOrderHandling.FillsGrp.prototype.setNestedParties4List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.NestedParties4=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties4}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.addNestedParties4 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.NestedParties4, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.clearNestedParties4List = function() {
  return this.setNestedParties4List([]);
};


/**
 * optional FillLiquidityIndEnum fill_liquidity_ind = 5;
 * @return {!proto.SingleGeneralOrderHandling.FillLiquidityIndEnum}
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.getFillLiquidityInd = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.FillLiquidityIndEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.FillLiquidityIndEnum} value
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp} returns this
 */
proto.SingleGeneralOrderHandling.FillsGrp.prototype.setFillLiquidityInd = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.ExecutionReport.repeatedFields_ = [7,94,96,105,121,122,125,133,145,159,166,168,172,174,181];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_ = [[14,15],[21,22],[51,52],[65,66],[109,110],[116,117],[160,163]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.OrdRejReasonUnionCase = {
  ORD_REJ_REASON_UNION_NOT_SET: 0,
  ORD_REJ_REASON: 14,
  ORD_REJ_REASON_RESERVED100PLUS: 15
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.OrdRejReasonUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdRejReasonUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.OrdRejReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.SettlTypeUnionCase = {
  SETTL_TYPE_UNION_NOT_SET: 0,
  SETTL_TYPE: 21,
  SETTL_TYPE_TENOR: 22
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.SettlTypeUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlTypeUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.SettlTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.ExecRestatementReasonUnionCase = {
  EXEC_RESTATEMENT_REASON_UNION_NOT_SET: 0,
  EXEC_RESTATEMENT_REASON: 51,
  EXEC_RESTATEMENT_REASON_RESERVED100PLUS: 52
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.ExecRestatementReasonUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecRestatementReasonUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.ExecRestatementReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[2]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 65,
  TRADING_SESSION_ID_RESERVED100PLUS: 66
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionIdUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[3]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 109,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 110
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionSubIdUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[4]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 116,
  ACCT_ID_SOURCE_RESERVED100PLUS: 117
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[5]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.TargetStrategyUnionCase = {
  TARGET_STRATEGY_UNION_NOT_SET: 0,
  TARGET_STRATEGY: 160,
  TARGET_STRATEGY_RESERVED1000PLUS: 163
};

/**
 * @return {proto.SingleGeneralOrderHandling.ExecutionReport.TargetStrategyUnionCase}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTargetStrategyUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.ExecutionReport.TargetStrategyUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[6]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.ExecutionReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.ExecutionReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.ExecutionReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: jspb.Message.getFieldWithDefault(msg, 1, ""),
    avgPx: (f = msg.getAvgPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    clOrdId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cumQty: (f = msg.getCumQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
    execId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    execInstList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    execRefId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    lastCapacity: jspb.Message.getFieldWithDefault(msg, 9, 0),
    lastMkt: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lastPx: (f = msg.getLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastQty: (f = msg.getLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    listId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    ordRejReason: jspb.Message.getFieldWithDefault(msg, 14, 0),
    ordRejReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    ordStatus: jspb.Message.getFieldWithDefault(msg, 16, 0),
    ordType: jspb.Message.getFieldWithDefault(msg, 17, 0),
    orderId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    settlDate: jspb.Message.getFieldWithDefault(msg, 20, 0),
    settlType: jspb.Message.getFieldWithDefault(msg, 21, 0),
    settlTypeTenor: (f = msg.getSettlTypeTenor()) && fix_pb.Tenor.toObject(includeInstance, f),
    side: jspb.Message.getFieldWithDefault(msg, 23, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    stopPx: (f = msg.getStopPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 27, ""),
    timeInForce: jspb.Message.getFieldWithDefault(msg, 28, 0),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 29, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    reportToExch: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    expireTime: (f = msg.getExpireTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    netMoney: (f = msg.getNetMoney()) && fix_pb.Decimal64.toObject(includeInstance, f),
    settlCurrAmt: (f = msg.getSettlCurrAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    settlCurrency: jspb.Message.getFieldWithDefault(msg, 35, ""),
    execType: jspb.Message.getFieldWithDefault(msg, 36, 0),
    lastForwardPoints: (f = msg.getLastForwardPoints()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastSpotRate: (f = msg.getLastSpotRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    leavesQty: (f = msg.getLeavesQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    origClOrdId: jspb.Message.getFieldWithDefault(msg, 40, ""),
    secondaryOrderId: jspb.Message.getFieldWithDefault(msg, 41, ""),
    settlCurrFxRate: (f = msg.getSettlCurrFxRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    settlCurrFxRateCalc: jspb.Message.getFieldWithDefault(msg, 43, 0),
    complianceId: jspb.Message.getFieldWithDefault(msg, 44, ""),
    dayAvgPx: (f = msg.getDayAvgPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    dayCumQty: (f = msg.getDayCumQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    dayOrderQty: (f = msg.getDayOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    effectiveTime: (f = msg.getEffectiveTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    encodedText: jspb.Message.getFieldWithDefault(msg, 49, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 50, 0),
    execRestatementReason: jspb.Message.getFieldWithDefault(msg, 51, 0),
    execRestatementReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 52, 0),
    expireDate: jspb.Message.getFieldWithDefault(msg, 53, 0),
    grossTradeAmt: (f = msg.getGrossTradeAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    gtBookingInst: jspb.Message.getFieldWithDefault(msg, 55, 0),
    handlInst: jspb.Message.getFieldWithDefault(msg, 56, 0),
    maxFloor: (f = msg.getMaxFloor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxShow: (f = msg.getMaxShow()) && fix_pb.Decimal64.toObject(includeInstance, f),
    minQty: (f = msg.getMinQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    multiLegReportingType: jspb.Message.getFieldWithDefault(msg, 60, 0),
    orderQty2: (f = msg.getOrderQty2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    positionEffect: jspb.Message.getFieldWithDefault(msg, 62, 0),
    settlDate2: jspb.Message.getFieldWithDefault(msg, 63, 0),
    solicitedFlag: jspb.Message.getBooleanFieldWithDefault(msg, 64, false),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 65, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 66, 0),
    accountType: jspb.Message.getFieldWithDefault(msg, 67, 0),
    accruedInterestAmt: (f = msg.getAccruedInterestAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    accruedInterestRate: (f = msg.getAccruedInterestRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    basisFeatureDate: jspb.Message.getFieldWithDefault(msg, 70, 0),
    basisFeaturePrice: (f = msg.getBasisFeaturePrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    bookingUnit: jspb.Message.getFieldWithDefault(msg, 72, 0),
    cancellationRights: jspb.Message.getFieldWithDefault(msg, 73, 0),
    cashMargin: jspb.Message.getFieldWithDefault(msg, 74, 0),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 75, ""),
    clearingFeeIndicator: jspb.Message.getFieldWithDefault(msg, 76, 0),
    commissionData: (f = msg.getCommissionData()) && common_pb.CommissionData.toObject(includeInstance, f),
    concession: (f = msg.getConcession()) && fix_pb.Decimal64.toObject(includeInstance, f),
    crossId: jspb.Message.getFieldWithDefault(msg, 79, ""),
    crossType: jspb.Message.getFieldWithDefault(msg, 80, 0),
    custOrderCapacity: jspb.Message.getFieldWithDefault(msg, 81, 0),
    dayBookingInst: jspb.Message.getFieldWithDefault(msg, 82, 0),
    designation: jspb.Message.getFieldWithDefault(msg, 83, ""),
    exDate: jspb.Message.getFieldWithDefault(msg, 84, 0),
    execPriceAdjustment: (f = msg.getExecPriceAdjustment()) && fix_pb.Decimal64.toObject(includeInstance, f),
    execPriceType: jspb.Message.getFieldWithDefault(msg, 86, 0),
    execValuationPoint: (f = msg.getExecValuationPoint()) && fix_pb.Timestamp.toObject(includeInstance, f),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    lastForwardPoints2: (f = msg.getLastForwardPoints2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    moneyLaunderingStatus: jspb.Message.getFieldWithDefault(msg, 90, 0),
    numDaysInterest: jspb.Message.getFieldWithDefault(msg, 91, 0),
    orderCapacity: jspb.Message.getFieldWithDefault(msg, 92, 0),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    orderRestrictionsList: (f = jspb.Message.getRepeatedField(msg, 94)) == null ? undefined : f,
    origCrossId: jspb.Message.getFieldWithDefault(msg, 95, ""),
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    preallocMethod: jspb.Message.getFieldWithDefault(msg, 97, 0),
    priceImprovement: (f = msg.getPriceImprovement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 99, 0),
    priorityIndicator: jspb.Message.getFieldWithDefault(msg, 100, 0),
    registId: jspb.Message.getFieldWithDefault(msg, 101, ""),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 102, ""),
    secondaryExecId: jspb.Message.getFieldWithDefault(msg, 103, ""),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    totalTakedown: (f = msg.getTotalTakedown()) && fix_pb.Decimal64.toObject(includeInstance, f),
    tradeOriginationDate: jspb.Message.getFieldWithDefault(msg, 107, 0),
    tradedFlatSwitch: jspb.Message.getBooleanFieldWithDefault(msg, 108, false),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 109, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 110, 0),
    transBkdTime: (f = msg.getTransBkdTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    underlyingLastPx: (f = msg.getUnderlyingLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingLastQty: (f = msg.getUnderlyingLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    workingIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 114, false),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 116, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 117, 0),
    aggressorIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 118, false),
    bookingType: jspb.Message.getFieldWithDefault(msg, 119, 0),
    calculatedCcyLastQty: (f = msg.getCalculatedCcyLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    contAmtGrpList: jspb.Message.toObjectList(msg.getContAmtGrpList(),
    common_pb.ContAmtGrp.toObject, includeInstance),
    contraGrpList: jspb.Message.toObjectList(msg.getContraGrpList(),
    common_pb.ContraGrp.toObject, includeInstance),
    copyMsgIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 123, false),
    custDirectedOrder: jspb.Message.getBooleanFieldWithDefault(msg, 124, false),
    custOrderHandlingInstList: (f = jspb.Message.getRepeatedField(msg, 125)) == null ? undefined : f,
    discretionInstructions: (f = msg.getDiscretionInstructions()) && common_pb.DiscretionInstructions.toObject(includeInstance, f),
    discretionPrice: (f = msg.getDiscretionPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    displayInstruction: (f = msg.getDisplayInstruction()) && common_pb.DisplayInstruction.toObject(includeInstance, f),
    endAccruedInterestAmt: (f = msg.getEndAccruedInterestAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    endCash: (f = msg.getEndCash()) && fix_pb.Decimal64.toObject(includeInstance, f),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    hostCrossId: jspb.Message.getFieldWithDefault(msg, 132, ""),
    instrmtLegExecGrpList: jspb.Message.toObjectList(msg.getInstrmtLegExecGrpList(),
    common_pb.InstrmtLegExecGrp.toObject, includeInstance),
    interestAtMaturity: (f = msg.getInterestAtMaturity()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastLiquidityInd: jspb.Message.getFieldWithDefault(msg, 135, 0),
    lastParPx: (f = msg.getLastParPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastRptRequested: jspb.Message.getBooleanFieldWithDefault(msg, 137, false),
    lastSwapPoints: (f = msg.getLastSwapPoints()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lotType: jspb.Message.getFieldWithDefault(msg, 139, 0),
    manualOrderIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 140, false),
    massStatusReqId: jspb.Message.getFieldWithDefault(msg, 141, ""),
    matchIncrement: (f = msg.getMatchIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    matchType: jspb.Message.getFieldWithDefault(msg, 143, 0),
    maxPriceLevels: jspb.Message.getFieldWithDefault(msg, 144, 0),
    miscFeesGrpList: jspb.Message.toObjectList(msg.getMiscFeesGrpList(),
    common_pb.MiscFeesGrp.toObject, includeInstance),
    ordStatusReqId: jspb.Message.getFieldWithDefault(msg, 146, ""),
    orderCategory: jspb.Message.getFieldWithDefault(msg, 147, 0),
    orderHandlingInstSource: jspb.Message.getFieldWithDefault(msg, 148, 0),
    participationRate: (f = msg.getParticipationRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    pegInstructions: (f = msg.getPegInstructions()) && common_pb.PegInstructions.toObject(includeInstance, f),
    peggedPrice: (f = msg.getPeggedPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    peggedRefPrice: (f = msg.getPeggedRefPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    preTradeAnonymity: jspb.Message.getBooleanFieldWithDefault(msg, 153, false),
    priceProtectionScope: jspb.Message.getFieldWithDefault(msg, 154, 0),
    qtyType: jspb.Message.getFieldWithDefault(msg, 155, 0),
    quoteRespId: jspb.Message.getFieldWithDefault(msg, 156, ""),
    receivedDeptId: jspb.Message.getFieldWithDefault(msg, 157, ""),
    startCash: (f = msg.getStartCash()) && fix_pb.Decimal64.toObject(includeInstance, f),
    strategyParametersGrpList: jspb.Message.toObjectList(msg.getStrategyParametersGrpList(),
    common_pb.StrategyParametersGrp.toObject, includeInstance),
    targetStrategy: jspb.Message.getFieldWithDefault(msg, 160, 0),
    targetStrategyReserved1000plus: jspb.Message.getFieldWithDefault(msg, 163, 0),
    targetStrategyParameters: jspb.Message.getFieldWithDefault(msg, 161, ""),
    targetStrategyPerformance: (f = msg.getTargetStrategyPerformance()) && fix_pb.Decimal64.toObject(includeInstance, f),
    timeBracket: jspb.Message.getFieldWithDefault(msg, 164, ""),
    totNumReports: jspb.Message.getFieldWithDefault(msg, 165, 0),
    trdRegTimestampsList: jspb.Message.toObjectList(msg.getTrdRegTimestampsList(),
    common_pb.TrdRegTimestamps.toObject, includeInstance),
    triggeringInstruction: (f = msg.getTriggeringInstruction()) && common_pb.TriggeringInstruction.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance),
    allocId: jspb.Message.getFieldWithDefault(msg, 169, ""),
    applicationSequenceControl: (f = msg.getApplicationSequenceControl()) && common_pb.ApplicationSequenceControl.toObject(includeInstance, f),
    dividendYield: (f = msg.getDividendYield()) && fix_pb.Decimal64.toObject(includeInstance, f),
    fillsGrpList: jspb.Message.toObjectList(msg.getFillsGrpList(),
    proto.SingleGeneralOrderHandling.FillsGrp.toObject, includeInstance),
    lastFragment: jspb.Message.getBooleanFieldWithDefault(msg, 173, false),
    preAllocGrpList: jspb.Message.toObjectList(msg.getPreAllocGrpList(),
    common_pb.PreAllocGrp.toObject, includeInstance),
    priceDelta: (f = msg.getPriceDelta()) && fix_pb.Decimal64.toObject(includeInstance, f),
    riskFreeRate: (f = msg.getRiskFreeRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    timeToExpiration: (f = msg.getTimeToExpiration()) && fix_pb.Decimal64.toObject(includeInstance, f),
    totNoFills: jspb.Message.getFieldWithDefault(msg, 178, 0),
    trdMatchId: jspb.Message.getFieldWithDefault(msg, 179, ""),
    volatility: (f = msg.getVolatility()) && fix_pb.Decimal64.toObject(includeInstance, f),
    rateSourceList: jspb.Message.toObjectList(msg.getRateSourceList(),
    common_pb.RateSource.toObject, includeInstance),
    isAllocated: jspb.Message.getBooleanFieldWithDefault(msg, 182, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.ExecutionReport;
  return proto.SingleGeneralOrderHandling.ExecutionReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.ExecutionReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAvgPx(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCumQty(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecId(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addExecInst(values[i]);
      }
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecRefId(value);
      break;
    case 9:
      var value = /** @type {!proto.SingleGeneralOrderHandling.LastCapacityEnum} */ (reader.readEnum());
      msg.setLastCapacity(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastMkt(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastPx(value);
      break;
    case 12:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastQty(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setListId(value);
      break;
    case 14:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} */ (reader.readEnum());
      msg.setOrdRejReason(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setOrdRejReasonReserved100plus(value);
      break;
    case 16:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (reader.readEnum());
      msg.setOrdStatus(value);
      break;
    case 17:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (reader.readEnum());
      msg.setOrdType(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 19:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate(value);
      break;
    case 21:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (reader.readEnum());
      msg.setSettlType(value);
      break;
    case 22:
      var value = new fix_pb.Tenor;
      reader.readMessage(value,fix_pb.Tenor.deserializeBinaryFromReader);
      msg.setSettlTypeTenor(value);
      break;
    case 23:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 24:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 25:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 26:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStopPx(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 28:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (reader.readEnum());
      msg.setTimeInForce(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeDate(value);
      break;
    case 30:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReportToExch(value);
      break;
    case 32:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpireTime(value);
      break;
    case 33:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setNetMoney(value);
      break;
    case 34:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSettlCurrAmt(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlCurrency(value);
      break;
    case 36:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExecTypeEnum} */ (reader.readEnum());
      msg.setExecType(value);
      break;
    case 37:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastForwardPoints(value);
      break;
    case 38:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastSpotRate(value);
      break;
    case 39:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLeavesQty(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigClOrdId(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrderId(value);
      break;
    case 42:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSettlCurrFxRate(value);
      break;
    case 43:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum} */ (reader.readEnum());
      msg.setSettlCurrFxRateCalc(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceId(value);
      break;
    case 45:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDayAvgPx(value);
      break;
    case 46:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDayCumQty(value);
      break;
    case 47:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDayOrderQty(value);
      break;
    case 48:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveTime(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 51:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum} */ (reader.readEnum());
      msg.setExecRestatementReason(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setExecRestatementReasonReserved100plus(value);
      break;
    case 53:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExpireDate(value);
      break;
    case 54:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setGrossTradeAmt(value);
      break;
    case 55:
      var value = /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (reader.readEnum());
      msg.setGtBookingInst(value);
      break;
    case 56:
      var value = /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (reader.readEnum());
      msg.setHandlInst(value);
      break;
    case 57:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxFloor(value);
      break;
    case 58:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxShow(value);
      break;
    case 59:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinQty(value);
      break;
    case 60:
      var value = /** @type {!proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum} */ (reader.readEnum());
      msg.setMultiLegReportingType(value);
      break;
    case 61:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty2(value);
      break;
    case 62:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (reader.readEnum());
      msg.setPositionEffect(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate2(value);
      break;
    case 64:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSolicitedFlag(value);
      break;
    case 65:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 67:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 68:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAccruedInterestAmt(value);
      break;
    case 69:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAccruedInterestRate(value);
      break;
    case 70:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setBasisFeatureDate(value);
      break;
    case 71:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setBasisFeaturePrice(value);
      break;
    case 72:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (reader.readEnum());
      msg.setBookingUnit(value);
      break;
    case 73:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (reader.readEnum());
      msg.setCancellationRights(value);
      break;
    case 74:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (reader.readEnum());
      msg.setCashMargin(value);
      break;
    case 75:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 76:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (reader.readEnum());
      msg.setClearingFeeIndicator(value);
      break;
    case 77:
      var value = new common_pb.CommissionData;
      reader.readMessage(value,common_pb.CommissionData.deserializeBinaryFromReader);
      msg.setCommissionData(value);
      break;
    case 78:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setConcession(value);
      break;
    case 79:
      var value = /** @type {string} */ (reader.readString());
      msg.setCrossId(value);
      break;
    case 80:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CrossTypeEnum} */ (reader.readEnum());
      msg.setCrossType(value);
      break;
    case 81:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (reader.readEnum());
      msg.setCustOrderCapacity(value);
      break;
    case 82:
      var value = /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (reader.readEnum());
      msg.setDayBookingInst(value);
      break;
    case 83:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesignation(value);
      break;
    case 84:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExDate(value);
      break;
    case 85:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setExecPriceAdjustment(value);
      break;
    case 86:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExecPriceTypeEnum} */ (reader.readEnum());
      msg.setExecPriceType(value);
      break;
    case 87:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExecValuationPoint(value);
      break;
    case 88:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 89:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastForwardPoints2(value);
      break;
    case 90:
      var value = /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (reader.readEnum());
      msg.setMoneyLaunderingStatus(value);
      break;
    case 91:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setNumDaysInterest(value);
      break;
    case 92:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (reader.readEnum());
      msg.setOrderCapacity(value);
      break;
    case 93:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 94:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderRestrictions(values[i]);
      }
      break;
    case 95:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigCrossId(value);
      break;
    case 96:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 97:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (reader.readEnum());
      msg.setPreallocMethod(value);
      break;
    case 98:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPriceImprovement(value);
      break;
    case 99:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 100:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriorityIndicatorEnum} */ (reader.readEnum());
      msg.setPriorityIndicator(value);
      break;
    case 101:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistId(value);
      break;
    case 102:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 103:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryExecId(value);
      break;
    case 104:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 105:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 106:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTotalTakedown(value);
      break;
    case 107:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeOriginationDate(value);
      break;
    case 108:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTradedFlatSwitch(value);
      break;
    case 109:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 110:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 111:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransBkdTime(value);
      break;
    case 112:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingLastPx(value);
      break;
    case 113:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingLastQty(value);
      break;
    case 114:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWorkingIndicator(value);
      break;
    case 115:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 116:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 117:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 118:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAggressorIndicator(value);
      break;
    case 119:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (reader.readEnum());
      msg.setBookingType(value);
      break;
    case 120:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCalculatedCcyLastQty(value);
      break;
    case 121:
      var value = new common_pb.ContAmtGrp;
      reader.readMessage(value,common_pb.ContAmtGrp.deserializeBinaryFromReader);
      msg.addContAmtGrp(value);
      break;
    case 122:
      var value = new common_pb.ContraGrp;
      reader.readMessage(value,common_pb.ContraGrp.deserializeBinaryFromReader);
      msg.addContraGrp(value);
      break;
    case 123:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCopyMsgIndicator(value);
      break;
    case 124:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustDirectedOrder(value);
      break;
    case 125:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCustOrderHandlingInst(values[i]);
      }
      break;
    case 126:
      var value = new common_pb.DiscretionInstructions;
      reader.readMessage(value,common_pb.DiscretionInstructions.deserializeBinaryFromReader);
      msg.setDiscretionInstructions(value);
      break;
    case 127:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDiscretionPrice(value);
      break;
    case 128:
      var value = new common_pb.DisplayInstruction;
      reader.readMessage(value,common_pb.DisplayInstruction.deserializeBinaryFromReader);
      msg.setDisplayInstruction(value);
      break;
    case 129:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setEndAccruedInterestAmt(value);
      break;
    case 130:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setEndCash(value);
      break;
    case 131:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 132:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostCrossId(value);
      break;
    case 133:
      var value = new common_pb.InstrmtLegExecGrp;
      reader.readMessage(value,common_pb.InstrmtLegExecGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegExecGrp(value);
      break;
    case 134:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setInterestAtMaturity(value);
      break;
    case 135:
      var value = /** @type {!proto.SingleGeneralOrderHandling.LastLiquidityIndEnum} */ (reader.readEnum());
      msg.setLastLiquidityInd(value);
      break;
    case 136:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastParPx(value);
      break;
    case 137:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastRptRequested(value);
      break;
    case 138:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastSwapPoints(value);
      break;
    case 139:
      var value = /** @type {!proto.SingleGeneralOrderHandling.LotTypeEnum} */ (reader.readEnum());
      msg.setLotType(value);
      break;
    case 140:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManualOrderIndicator(value);
      break;
    case 141:
      var value = /** @type {string} */ (reader.readString());
      msg.setMassStatusReqId(value);
      break;
    case 142:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMatchIncrement(value);
      break;
    case 143:
      var value = /** @type {!proto.SingleGeneralOrderHandling.MatchTypeEnum} */ (reader.readEnum());
      msg.setMatchType(value);
      break;
    case 144:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaxPriceLevels(value);
      break;
    case 145:
      var value = new common_pb.MiscFeesGrp;
      reader.readMessage(value,common_pb.MiscFeesGrp.deserializeBinaryFromReader);
      msg.addMiscFeesGrp(value);
      break;
    case 146:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdStatusReqId(value);
      break;
    case 147:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderCategoryEnum} */ (reader.readEnum());
      msg.setOrderCategory(value);
      break;
    case 148:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (reader.readEnum());
      msg.setOrderHandlingInstSource(value);
      break;
    case 149:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setParticipationRate(value);
      break;
    case 150:
      var value = new common_pb.PegInstructions;
      reader.readMessage(value,common_pb.PegInstructions.deserializeBinaryFromReader);
      msg.setPegInstructions(value);
      break;
    case 151:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPeggedPrice(value);
      break;
    case 152:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPeggedRefPrice(value);
      break;
    case 153:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreTradeAnonymity(value);
      break;
    case 154:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (reader.readEnum());
      msg.setPriceProtectionScope(value);
      break;
    case 155:
      var value = /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (reader.readEnum());
      msg.setQtyType(value);
      break;
    case 156:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuoteRespId(value);
      break;
    case 157:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivedDeptId(value);
      break;
    case 158:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStartCash(value);
      break;
    case 159:
      var value = new common_pb.StrategyParametersGrp;
      reader.readMessage(value,common_pb.StrategyParametersGrp.deserializeBinaryFromReader);
      msg.addStrategyParametersGrp(value);
      break;
    case 160:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (reader.readEnum());
      msg.setTargetStrategy(value);
      break;
    case 163:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTargetStrategyReserved1000plus(value);
      break;
    case 161:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetStrategyParameters(value);
      break;
    case 162:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTargetStrategyPerformance(value);
      break;
    case 164:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeBracket(value);
      break;
    case 165:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNumReports(value);
      break;
    case 166:
      var value = new common_pb.TrdRegTimestamps;
      reader.readMessage(value,common_pb.TrdRegTimestamps.deserializeBinaryFromReader);
      msg.addTrdRegTimestamps(value);
      break;
    case 167:
      var value = new common_pb.TriggeringInstruction;
      reader.readMessage(value,common_pb.TriggeringInstruction.deserializeBinaryFromReader);
      msg.setTriggeringInstruction(value);
      break;
    case 168:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 169:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocId(value);
      break;
    case 170:
      var value = new common_pb.ApplicationSequenceControl;
      reader.readMessage(value,common_pb.ApplicationSequenceControl.deserializeBinaryFromReader);
      msg.setApplicationSequenceControl(value);
      break;
    case 171:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDividendYield(value);
      break;
    case 172:
      var value = new proto.SingleGeneralOrderHandling.FillsGrp;
      reader.readMessage(value,proto.SingleGeneralOrderHandling.FillsGrp.deserializeBinaryFromReader);
      msg.addFillsGrp(value);
      break;
    case 173:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLastFragment(value);
      break;
    case 174:
      var value = new common_pb.PreAllocGrp;
      reader.readMessage(value,common_pb.PreAllocGrp.deserializeBinaryFromReader);
      msg.addPreAllocGrp(value);
      break;
    case 175:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPriceDelta(value);
      break;
    case 176:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRiskFreeRate(value);
      break;
    case 177:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTimeToExpiration(value);
      break;
    case 178:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setTotNoFills(value);
      break;
    case 179:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrdMatchId(value);
      break;
    case 180:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setVolatility(value);
      break;
    case 181:
      var value = new common_pb.RateSource;
      reader.readMessage(value,common_pb.RateSource.deserializeBinaryFromReader);
      msg.addRateSource(value);
      break;
    case 182:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAllocated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.ExecutionReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.ExecutionReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.ExecutionReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvgPx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCumQty();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExecId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExecInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getExecRefId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLastCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getLastMkt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLastPx();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastQty();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getListId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFixed32(
      15,
      f
    );
  }
  f = message.getOrdStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getOrdType();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSettlDate();
  if (f !== 0) {
    writer.writeSfixed32(
      20,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getSettlTypeTenor();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Tenor.serializeBinaryToWriter
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getStopPx();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getTimeInForce();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getTradeDate();
  if (f !== 0) {
    writer.writeSfixed32(
      29,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReportToExch();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getExpireTime();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNetMoney();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSettlCurrAmt();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getExecType();
  if (f !== 0.0) {
    writer.writeEnum(
      36,
      f
    );
  }
  f = message.getLastForwardPoints();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastSpotRate();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLeavesQty();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrigClOrdId();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getSettlCurrFxRate();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSettlCurrFxRateCalc();
  if (f !== 0.0) {
    writer.writeEnum(
      43,
      f
    );
  }
  f = message.getComplianceId();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getDayAvgPx();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDayCumQty();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDayOrderQty();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveTime();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      50,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeEnum(
      51,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeFixed32(
      52,
      f
    );
  }
  f = message.getExpireDate();
  if (f !== 0) {
    writer.writeSfixed32(
      53,
      f
    );
  }
  f = message.getGrossTradeAmt();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getGtBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      55,
      f
    );
  }
  f = message.getHandlInst();
  if (f !== 0.0) {
    writer.writeEnum(
      56,
      f
    );
  }
  f = message.getMaxFloor();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxShow();
  if (f != null) {
    writer.writeMessage(
      58,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMinQty();
  if (f != null) {
    writer.writeMessage(
      59,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMultiLegReportingType();
  if (f !== 0.0) {
    writer.writeEnum(
      60,
      f
    );
  }
  f = message.getOrderQty2();
  if (f != null) {
    writer.writeMessage(
      61,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPositionEffect();
  if (f !== 0.0) {
    writer.writeEnum(
      62,
      f
    );
  }
  f = message.getSettlDate2();
  if (f !== 0) {
    writer.writeSfixed32(
      63,
      f
    );
  }
  f = message.getSolicitedFlag();
  if (f) {
    writer.writeBool(
      64,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.TradingSessionIDEnum} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeEnum(
      65,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeFixed32(
      66,
      f
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      67,
      f
    );
  }
  f = message.getAccruedInterestAmt();
  if (f != null) {
    writer.writeMessage(
      68,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getAccruedInterestRate();
  if (f != null) {
    writer.writeMessage(
      69,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getBasisFeatureDate();
  if (f !== 0) {
    writer.writeSfixed32(
      70,
      f
    );
  }
  f = message.getBasisFeaturePrice();
  if (f != null) {
    writer.writeMessage(
      71,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getBookingUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      72,
      f
    );
  }
  f = message.getCancellationRights();
  if (f !== 0.0) {
    writer.writeEnum(
      73,
      f
    );
  }
  f = message.getCashMargin();
  if (f !== 0.0) {
    writer.writeEnum(
      74,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      75,
      f
    );
  }
  f = message.getClearingFeeIndicator();
  if (f !== 0.0) {
    writer.writeEnum(
      76,
      f
    );
  }
  f = message.getCommissionData();
  if (f != null) {
    writer.writeMessage(
      77,
      f,
      common_pb.CommissionData.serializeBinaryToWriter
    );
  }
  f = message.getConcession();
  if (f != null) {
    writer.writeMessage(
      78,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCrossId();
  if (f.length > 0) {
    writer.writeString(
      79,
      f
    );
  }
  f = message.getCrossType();
  if (f !== 0.0) {
    writer.writeEnum(
      80,
      f
    );
  }
  f = message.getCustOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      81,
      f
    );
  }
  f = message.getDayBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      82,
      f
    );
  }
  f = message.getDesignation();
  if (f.length > 0) {
    writer.writeString(
      83,
      f
    );
  }
  f = message.getExDate();
  if (f !== 0) {
    writer.writeSfixed32(
      84,
      f
    );
  }
  f = message.getExecPriceAdjustment();
  if (f != null) {
    writer.writeMessage(
      85,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getExecPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      86,
      f
    );
  }
  f = message.getExecValuationPoint();
  if (f != null) {
    writer.writeMessage(
      87,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      88,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getLastForwardPoints2();
  if (f != null) {
    writer.writeMessage(
      89,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMoneyLaunderingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      90,
      f
    );
  }
  f = message.getNumDaysInterest();
  if (f !== 0) {
    writer.writeSfixed64(
      91,
      f
    );
  }
  f = message.getOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      92,
      f
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      93,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getOrderRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      94,
      f
    );
  }
  f = message.getOrigCrossId();
  if (f.length > 0) {
    writer.writeString(
      95,
      f
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      96,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getPreallocMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      97,
      f
    );
  }
  f = message.getPriceImprovement();
  if (f != null) {
    writer.writeMessage(
      98,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      99,
      f
    );
  }
  f = message.getPriorityIndicator();
  if (f !== 0.0) {
    writer.writeEnum(
      100,
      f
    );
  }
  f = message.getRegistId();
  if (f.length > 0) {
    writer.writeString(
      101,
      f
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      102,
      f
    );
  }
  f = message.getSecondaryExecId();
  if (f.length > 0) {
    writer.writeString(
      103,
      f
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      104,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      105,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getTotalTakedown();
  if (f != null) {
    writer.writeMessage(
      106,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTradeOriginationDate();
  if (f !== 0) {
    writer.writeSfixed32(
      107,
      f
    );
  }
  f = message.getTradedFlatSwitch();
  if (f) {
    writer.writeBool(
      108,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 109));
  if (f != null) {
    writer.writeEnum(
      109,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 110));
  if (f != null) {
    writer.writeFixed32(
      110,
      f
    );
  }
  f = message.getTransBkdTime();
  if (f != null) {
    writer.writeMessage(
      111,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingLastPx();
  if (f != null) {
    writer.writeMessage(
      112,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingLastQty();
  if (f != null) {
    writer.writeMessage(
      113,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getWorkingIndicator();
  if (f) {
    writer.writeBool(
      114,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      115,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 116));
  if (f != null) {
    writer.writeEnum(
      116,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 117));
  if (f != null) {
    writer.writeFixed32(
      117,
      f
    );
  }
  f = message.getAggressorIndicator();
  if (f) {
    writer.writeBool(
      118,
      f
    );
  }
  f = message.getBookingType();
  if (f !== 0.0) {
    writer.writeEnum(
      119,
      f
    );
  }
  f = message.getCalculatedCcyLastQty();
  if (f != null) {
    writer.writeMessage(
      120,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getContAmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      121,
      f,
      common_pb.ContAmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getContraGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      122,
      f,
      common_pb.ContraGrp.serializeBinaryToWriter
    );
  }
  f = message.getCopyMsgIndicator();
  if (f) {
    writer.writeBool(
      123,
      f
    );
  }
  f = message.getCustDirectedOrder();
  if (f) {
    writer.writeBool(
      124,
      f
    );
  }
  f = message.getCustOrderHandlingInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      125,
      f
    );
  }
  f = message.getDiscretionInstructions();
  if (f != null) {
    writer.writeMessage(
      126,
      f,
      common_pb.DiscretionInstructions.serializeBinaryToWriter
    );
  }
  f = message.getDiscretionPrice();
  if (f != null) {
    writer.writeMessage(
      127,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDisplayInstruction();
  if (f != null) {
    writer.writeMessage(
      128,
      f,
      common_pb.DisplayInstruction.serializeBinaryToWriter
    );
  }
  f = message.getEndAccruedInterestAmt();
  if (f != null) {
    writer.writeMessage(
      129,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getEndCash();
  if (f != null) {
    writer.writeMessage(
      130,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      131,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getHostCrossId();
  if (f.length > 0) {
    writer.writeString(
      132,
      f
    );
  }
  f = message.getInstrmtLegExecGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      133,
      f,
      common_pb.InstrmtLegExecGrp.serializeBinaryToWriter
    );
  }
  f = message.getInterestAtMaturity();
  if (f != null) {
    writer.writeMessage(
      134,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastLiquidityInd();
  if (f !== 0.0) {
    writer.writeEnum(
      135,
      f
    );
  }
  f = message.getLastParPx();
  if (f != null) {
    writer.writeMessage(
      136,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastRptRequested();
  if (f) {
    writer.writeBool(
      137,
      f
    );
  }
  f = message.getLastSwapPoints();
  if (f != null) {
    writer.writeMessage(
      138,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLotType();
  if (f !== 0.0) {
    writer.writeEnum(
      139,
      f
    );
  }
  f = message.getManualOrderIndicator();
  if (f) {
    writer.writeBool(
      140,
      f
    );
  }
  f = message.getMassStatusReqId();
  if (f.length > 0) {
    writer.writeString(
      141,
      f
    );
  }
  f = message.getMatchIncrement();
  if (f != null) {
    writer.writeMessage(
      142,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMatchType();
  if (f !== 0.0) {
    writer.writeEnum(
      143,
      f
    );
  }
  f = message.getMaxPriceLevels();
  if (f !== 0) {
    writer.writeSfixed64(
      144,
      f
    );
  }
  f = message.getMiscFeesGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      145,
      f,
      common_pb.MiscFeesGrp.serializeBinaryToWriter
    );
  }
  f = message.getOrdStatusReqId();
  if (f.length > 0) {
    writer.writeString(
      146,
      f
    );
  }
  f = message.getOrderCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      147,
      f
    );
  }
  f = message.getOrderHandlingInstSource();
  if (f !== 0.0) {
    writer.writeEnum(
      148,
      f
    );
  }
  f = message.getParticipationRate();
  if (f != null) {
    writer.writeMessage(
      149,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPegInstructions();
  if (f != null) {
    writer.writeMessage(
      150,
      f,
      common_pb.PegInstructions.serializeBinaryToWriter
    );
  }
  f = message.getPeggedPrice();
  if (f != null) {
    writer.writeMessage(
      151,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPeggedRefPrice();
  if (f != null) {
    writer.writeMessage(
      152,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPreTradeAnonymity();
  if (f) {
    writer.writeBool(
      153,
      f
    );
  }
  f = message.getPriceProtectionScope();
  if (f !== 0.0) {
    writer.writeEnum(
      154,
      f
    );
  }
  f = message.getQtyType();
  if (f !== 0.0) {
    writer.writeEnum(
      155,
      f
    );
  }
  f = message.getQuoteRespId();
  if (f.length > 0) {
    writer.writeString(
      156,
      f
    );
  }
  f = message.getReceivedDeptId();
  if (f.length > 0) {
    writer.writeString(
      157,
      f
    );
  }
  f = message.getStartCash();
  if (f != null) {
    writer.writeMessage(
      158,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStrategyParametersGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      159,
      f,
      common_pb.StrategyParametersGrp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getField(message, 160));
  if (f != null) {
    writer.writeEnum(
      160,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 163));
  if (f != null) {
    writer.writeFixed32(
      163,
      f
    );
  }
  f = message.getTargetStrategyParameters();
  if (f.length > 0) {
    writer.writeString(
      161,
      f
    );
  }
  f = message.getTargetStrategyPerformance();
  if (f != null) {
    writer.writeMessage(
      162,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTimeBracket();
  if (f.length > 0) {
    writer.writeString(
      164,
      f
    );
  }
  f = message.getTotNumReports();
  if (f !== 0) {
    writer.writeSfixed64(
      165,
      f
    );
  }
  f = message.getTrdRegTimestampsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      166,
      f,
      common_pb.TrdRegTimestamps.serializeBinaryToWriter
    );
  }
  f = message.getTriggeringInstruction();
  if (f != null) {
    writer.writeMessage(
      167,
      f,
      common_pb.TriggeringInstruction.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      168,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getAllocId();
  if (f.length > 0) {
    writer.writeString(
      169,
      f
    );
  }
  f = message.getApplicationSequenceControl();
  if (f != null) {
    writer.writeMessage(
      170,
      f,
      common_pb.ApplicationSequenceControl.serializeBinaryToWriter
    );
  }
  f = message.getDividendYield();
  if (f != null) {
    writer.writeMessage(
      171,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFillsGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      172,
      f,
      proto.SingleGeneralOrderHandling.FillsGrp.serializeBinaryToWriter
    );
  }
  f = message.getLastFragment();
  if (f) {
    writer.writeBool(
      173,
      f
    );
  }
  f = message.getPreAllocGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      174,
      f,
      common_pb.PreAllocGrp.serializeBinaryToWriter
    );
  }
  f = message.getPriceDelta();
  if (f != null) {
    writer.writeMessage(
      175,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getRiskFreeRate();
  if (f != null) {
    writer.writeMessage(
      176,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTimeToExpiration();
  if (f != null) {
    writer.writeMessage(
      177,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTotNoFills();
  if (f !== 0) {
    writer.writeSfixed64(
      178,
      f
    );
  }
  f = message.getTrdMatchId();
  if (f.length > 0) {
    writer.writeString(
      179,
      f
    );
  }
  f = message.getVolatility();
  if (f != null) {
    writer.writeMessage(
      180,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getRateSourceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      181,
      f,
      common_pb.RateSource.serializeBinaryToWriter
    );
  }
  f = message.getIsAllocated();
  if (f) {
    writer.writeBool(
      182,
      f
    );
  }
};


/**
 * optional string account = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional fix.Decimal64 avg_px = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAvgPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAvgPx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearAvgPx = function() {
  return this.setAvgPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasAvgPx = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string cl_ord_id = 3;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fix.Decimal64 cum_qty = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCumQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCumQty = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearCumQty = function() {
  return this.setCumQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasCumQty = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string exec_id = 6;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated ExecInstEnum exec_inst = 7;
 * @return {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecInstList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addExecInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExecInstList = function() {
  return this.setExecInstList([]);
};


/**
 * optional string exec_ref_id = 8;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecRefId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecRefId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional LastCapacityEnum last_capacity = 9;
 * @return {!proto.SingleGeneralOrderHandling.LastCapacityEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.LastCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.LastCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string last_mkt = 10;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastMkt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastMkt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional fix.Decimal64 last_px = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastPx = function() {
  return this.setLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastPx = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fix.Decimal64 last_qty = 12;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 12));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastQty = function() {
  return this.setLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastQty = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string list_id = 13;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setListId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional OrdRejReasonEnum ord_rej_reason = 14;
 * @return {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdRejReason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrdRejReason = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearOrdRejReason = function() {
  return jspb.Message.setOneofField(this, 14, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasOrdRejReason = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional fixed32 ord_rej_reason_reserved100plus = 15;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdRejReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrdRejReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 15, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearOrdRejReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 15, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasOrdRejReasonReserved100plus = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional OrdStatusEnum ord_status = 16;
 * @return {!proto.SingleGeneralOrderHandling.OrdStatusEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrdStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional OrdTypeEnum ord_type = 17;
 * @return {!proto.SingleGeneralOrderHandling.OrdTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string order_id = 18;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional fix.Decimal64 price = 19;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 19));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional sfixed32 settl_date = 20;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlDate = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional SettlTypeEnum settl_type = 21;
 * @return {!proto.SingleGeneralOrderHandling.SettlTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SettlTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlType = function(value) {
  return jspb.Message.setOneofField(this, 21, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearSettlType = function() {
  return jspb.Message.setOneofField(this, 21, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasSettlType = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fix.Tenor settl_type_tenor = 22;
 * @return {?proto.fix.Tenor}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlTypeTenor = function() {
  return /** @type{?proto.fix.Tenor} */ (
    jspb.Message.getWrapperField(this, fix_pb.Tenor, 22));
};


/**
 * @param {?proto.fix.Tenor|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlTypeTenor = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearSettlTypeTenor = function() {
  return this.setSettlTypeTenor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasSettlTypeTenor = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional SideEnum side = 23;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional Session.StandardHeader standard_header = 24;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 24));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 25;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 25));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional fix.Decimal64 stop_px = 26;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStopPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 26));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStopPx = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStopPx = function() {
  return this.setStopPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasStopPx = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional string text = 27;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional TimeInForceEnum time_in_force = 28;
 * @return {!proto.SingleGeneralOrderHandling.TimeInForceEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTimeInForce = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TimeInForceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTimeInForce = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional sfixed32 trade_date = 29;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradeDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional fix.Timestamp transact_time = 30;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 30));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional bool report_to_exch = 31;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getReportToExch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setReportToExch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional fix.Timestamp expire_time = 32;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExpireTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 32));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExpireTime = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExpireTime = function() {
  return this.setExpireTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasExpireTime = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional fix.Decimal64 net_money = 33;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getNetMoney = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 33));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setNetMoney = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearNetMoney = function() {
  return this.setNetMoney(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasNetMoney = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional fix.Decimal64 settl_curr_amt = 34;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlCurrAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 34));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlCurrAmt = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearSettlCurrAmt = function() {
  return this.setSettlCurrAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasSettlCurrAmt = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional string settl_currency = 35;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional ExecTypeEnum exec_type = 36;
 * @return {!proto.SingleGeneralOrderHandling.ExecTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExecTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecType = function(value) {
  return jspb.Message.setProto3EnumField(this, 36, value);
};


/**
 * optional fix.Decimal64 last_forward_points = 37;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastForwardPoints = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 37));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastForwardPoints = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastForwardPoints = function() {
  return this.setLastForwardPoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastForwardPoints = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional fix.Decimal64 last_spot_rate = 38;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastSpotRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 38));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastSpotRate = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastSpotRate = function() {
  return this.setLastSpotRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastSpotRate = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional fix.Decimal64 leaves_qty = 39;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLeavesQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 39));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLeavesQty = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLeavesQty = function() {
  return this.setLeavesQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLeavesQty = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional string orig_cl_ord_id = 40;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrigClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrigClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string secondary_order_id = 41;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional fix.Decimal64 settl_curr_fx_rate = 42;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlCurrFxRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 42));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlCurrFxRate = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearSettlCurrFxRate = function() {
  return this.setSettlCurrFxRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasSettlCurrFxRate = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional SettlCurrFxRateCalcEnum settl_curr_fx_rate_calc = 43;
 * @return {!proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlCurrFxRateCalc = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlCurrFxRateCalc = function(value) {
  return jspb.Message.setProto3EnumField(this, 43, value);
};


/**
 * optional string compliance_id = 44;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getComplianceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setComplianceId = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional fix.Decimal64 day_avg_px = 45;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDayAvgPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 45));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDayAvgPx = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDayAvgPx = function() {
  return this.setDayAvgPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDayAvgPx = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional fix.Decimal64 day_cum_qty = 46;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDayCumQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 46));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDayCumQty = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDayCumQty = function() {
  return this.setDayCumQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDayCumQty = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional fix.Decimal64 day_order_qty = 47;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDayOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 47));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDayOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDayOrderQty = function() {
  return this.setDayOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDayOrderQty = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional fix.Timestamp effective_time = 48;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getEffectiveTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 48));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setEffectiveTime = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearEffectiveTime = function() {
  return this.setEffectiveTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasEffectiveTime = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional string encoded_text = 49;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional sfixed64 encoded_text_len = 50;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional ExecRestatementReasonEnum exec_restatement_reason = 51;
 * @return {!proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecRestatementReason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecRestatementReason = function(value) {
  return jspb.Message.setOneofField(this, 51, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExecRestatementReason = function() {
  return jspb.Message.setOneofField(this, 51, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasExecRestatementReason = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional fixed32 exec_restatement_reason_reserved100plus = 52;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecRestatementReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecRestatementReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 52, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExecRestatementReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 52, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasExecRestatementReasonReserved100plus = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional sfixed32 expire_date = 53;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExpireDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3IntField(this, 53, value);
};


/**
 * optional fix.Decimal64 gross_trade_amt = 54;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getGrossTradeAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 54));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setGrossTradeAmt = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearGrossTradeAmt = function() {
  return this.setGrossTradeAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasGrossTradeAmt = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional GTBookingInstEnum gt_booking_inst = 55;
 * @return {!proto.SingleGeneralOrderHandling.GTBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getGtBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setGtBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 55, value);
};


/**
 * optional HandlInstEnum handl_inst = 56;
 * @return {!proto.SingleGeneralOrderHandling.HandlInstEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getHandlInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.HandlInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setHandlInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 56, value);
};


/**
 * optional fix.Decimal64 max_floor = 57;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMaxFloor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 57));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMaxFloor = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearMaxFloor = function() {
  return this.setMaxFloor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasMaxFloor = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional fix.Decimal64 max_show = 58;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMaxShow = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 58));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMaxShow = function(value) {
  return jspb.Message.setWrapperField(this, 58, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearMaxShow = function() {
  return this.setMaxShow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasMaxShow = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional fix.Decimal64 min_qty = 59;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMinQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 59));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMinQty = function(value) {
  return jspb.Message.setWrapperField(this, 59, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearMinQty = function() {
  return this.setMinQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasMinQty = function() {
  return jspb.Message.getField(this, 59) != null;
};


/**
 * optional MultiLegReportingTypeEnum multi_leg_reporting_type = 60;
 * @return {!proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMultiLegReportingType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMultiLegReportingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 60, value);
};


/**
 * optional fix.Decimal64 order_qty2 = 61;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderQty2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 61));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderQty2 = function(value) {
  return jspb.Message.setWrapperField(this, 61, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearOrderQty2 = function() {
  return this.setOrderQty2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasOrderQty2 = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional PositionEffectEnum position_effect = 62;
 * @return {!proto.SingleGeneralOrderHandling.PositionEffectEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPositionEffect = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PositionEffectEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPositionEffect = function(value) {
  return jspb.Message.setProto3EnumField(this, 62, value);
};


/**
 * optional sfixed32 settl_date2 = 63;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSettlDate2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSettlDate2 = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional bool solicited_flag = 64;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSolicitedFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 64, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSolicitedFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 64, value);
};


/**
 * optional TradingSessionIDEnum trading_session_id = 65;
 * @return {!proto.SingleGeneralOrderHandling.TradingSessionIDEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionId = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TradingSessionIDEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 65, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 65, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 66;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional AccountTypeEnum account_type = 67;
 * @return {!proto.SingleGeneralOrderHandling.AccountTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAccountType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 67, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AccountTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 67, value);
};


/**
 * optional fix.Decimal64 accrued_interest_amt = 68;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAccruedInterestAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 68));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAccruedInterestAmt = function(value) {
  return jspb.Message.setWrapperField(this, 68, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearAccruedInterestAmt = function() {
  return this.setAccruedInterestAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasAccruedInterestAmt = function() {
  return jspb.Message.getField(this, 68) != null;
};


/**
 * optional fix.Decimal64 accrued_interest_rate = 69;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAccruedInterestRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 69));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAccruedInterestRate = function(value) {
  return jspb.Message.setWrapperField(this, 69, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearAccruedInterestRate = function() {
  return this.setAccruedInterestRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasAccruedInterestRate = function() {
  return jspb.Message.getField(this, 69) != null;
};


/**
 * optional sfixed32 basis_feature_date = 70;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getBasisFeatureDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 70, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setBasisFeatureDate = function(value) {
  return jspb.Message.setProto3IntField(this, 70, value);
};


/**
 * optional fix.Decimal64 basis_feature_price = 71;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getBasisFeaturePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 71));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setBasisFeaturePrice = function(value) {
  return jspb.Message.setWrapperField(this, 71, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearBasisFeaturePrice = function() {
  return this.setBasisFeaturePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasBasisFeaturePrice = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional BookingUnitEnum booking_unit = 72;
 * @return {!proto.SingleGeneralOrderHandling.BookingUnitEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getBookingUnit = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 72, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingUnitEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setBookingUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 72, value);
};


/**
 * optional CancellationRightsEnum cancellation_rights = 73;
 * @return {!proto.SingleGeneralOrderHandling.CancellationRightsEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCancellationRights = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (jspb.Message.getFieldWithDefault(this, 73, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCancellationRights = function(value) {
  return jspb.Message.setProto3EnumField(this, 73, value);
};


/**
 * optional CashMarginEnum cash_margin = 74;
 * @return {!proto.SingleGeneralOrderHandling.CashMarginEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCashMargin = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (jspb.Message.getFieldWithDefault(this, 74, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CashMarginEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCashMargin = function(value) {
  return jspb.Message.setProto3EnumField(this, 74, value);
};


/**
 * optional string cl_ord_link_id = 75;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 75, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 75, value);
};


/**
 * optional ClearingFeeIndicatorEnum clearing_fee_indicator = 76;
 * @return {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getClearingFeeIndicator = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (jspb.Message.getFieldWithDefault(this, 76, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setClearingFeeIndicator = function(value) {
  return jspb.Message.setProto3EnumField(this, 76, value);
};


/**
 * optional Common.CommissionData commission_data = 77;
 * @return {?proto.Common.CommissionData}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCommissionData = function() {
  return /** @type{?proto.Common.CommissionData} */ (
    jspb.Message.getWrapperField(this, common_pb.CommissionData, 77));
};


/**
 * @param {?proto.Common.CommissionData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCommissionData = function(value) {
  return jspb.Message.setWrapperField(this, 77, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearCommissionData = function() {
  return this.setCommissionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasCommissionData = function() {
  return jspb.Message.getField(this, 77) != null;
};


/**
 * optional fix.Decimal64 concession = 78;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getConcession = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 78));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setConcession = function(value) {
  return jspb.Message.setWrapperField(this, 78, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearConcession = function() {
  return this.setConcession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasConcession = function() {
  return jspb.Message.getField(this, 78) != null;
};


/**
 * optional string cross_id = 79;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCrossId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 79, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCrossId = function(value) {
  return jspb.Message.setProto3StringField(this, 79, value);
};


/**
 * optional CrossTypeEnum cross_type = 80;
 * @return {!proto.SingleGeneralOrderHandling.CrossTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCrossType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CrossTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 80, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CrossTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCrossType = function(value) {
  return jspb.Message.setProto3EnumField(this, 80, value);
};


/**
 * optional CustOrderCapacityEnum cust_order_capacity = 81;
 * @return {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCustOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 81, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCustOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 81, value);
};


/**
 * optional DayBookingInstEnum day_booking_inst = 82;
 * @return {!proto.SingleGeneralOrderHandling.DayBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDayBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 82, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDayBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 82, value);
};


/**
 * optional string designation = 83;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDesignation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 83, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDesignation = function(value) {
  return jspb.Message.setProto3StringField(this, 83, value);
};


/**
 * optional sfixed32 ex_date = 84;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 84, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExDate = function(value) {
  return jspb.Message.setProto3IntField(this, 84, value);
};


/**
 * optional fix.Decimal64 exec_price_adjustment = 85;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecPriceAdjustment = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 85));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecPriceAdjustment = function(value) {
  return jspb.Message.setWrapperField(this, 85, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExecPriceAdjustment = function() {
  return this.setExecPriceAdjustment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasExecPriceAdjustment = function() {
  return jspb.Message.getField(this, 85) != null;
};


/**
 * optional ExecPriceTypeEnum exec_price_type = 86;
 * @return {!proto.SingleGeneralOrderHandling.ExecPriceTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExecPriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 86, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecPriceTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 86, value);
};


/**
 * optional fix.Timestamp exec_valuation_point = 87;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getExecValuationPoint = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 87));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setExecValuationPoint = function(value) {
  return jspb.Message.setWrapperField(this, 87, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearExecValuationPoint = function() {
  return this.setExecValuationPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasExecValuationPoint = function() {
  return jspb.Message.getField(this, 87) != null;
};


/**
 * optional Common.Instrument instrument = 88;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 88));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 88, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 88) != null;
};


/**
 * optional fix.Decimal64 last_forward_points2 = 89;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastForwardPoints2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 89));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastForwardPoints2 = function(value) {
  return jspb.Message.setWrapperField(this, 89, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastForwardPoints2 = function() {
  return this.setLastForwardPoints2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastForwardPoints2 = function() {
  return jspb.Message.getField(this, 89) != null;
};


/**
 * optional MoneyLaunderingStatusEnum money_laundering_status = 90;
 * @return {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMoneyLaunderingStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 90, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMoneyLaunderingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 90, value);
};


/**
 * optional sfixed64 num_days_interest = 91;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getNumDaysInterest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 91, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setNumDaysInterest = function(value) {
  return jspb.Message.setProto3IntField(this, 91, value);
};


/**
 * optional OrderCapacityEnum order_capacity = 92;
 * @return {!proto.SingleGeneralOrderHandling.OrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 92, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 92, value);
};


/**
 * optional Common.OrderQtyData order_qty_data = 93;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 93));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 93, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 93) != null;
};


/**
 * repeated OrderRestrictionsEnum order_restrictions = 94;
 * @return {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderRestrictionsList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (jspb.Message.getRepeatedField(this, 94));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderRestrictionsList = function(value) {
  return jspb.Message.setField(this, 94, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addOrderRestrictions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 94, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearOrderRestrictionsList = function() {
  return this.setOrderRestrictionsList([]);
};


/**
 * optional string orig_cross_id = 95;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrigCrossId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 95, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrigCrossId = function(value) {
  return jspb.Message.setProto3StringField(this, 95, value);
};


/**
 * repeated Common.Parties parties = 96;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 96));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 96, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 96, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional PreallocMethodEnum prealloc_method = 97;
 * @return {!proto.SingleGeneralOrderHandling.PreallocMethodEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPreallocMethod = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 97, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPreallocMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 97, value);
};


/**
 * optional fix.Decimal64 price_improvement = 98;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPriceImprovement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 98));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPriceImprovement = function(value) {
  return jspb.Message.setWrapperField(this, 98, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPriceImprovement = function() {
  return this.setPriceImprovement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPriceImprovement = function() {
  return jspb.Message.getField(this, 98) != null;
};


/**
 * optional PriceTypeEnum price_type = 99;
 * @return {!proto.SingleGeneralOrderHandling.PriceTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 99, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 99, value);
};


/**
 * optional PriorityIndicatorEnum priority_indicator = 100;
 * @return {!proto.SingleGeneralOrderHandling.PriorityIndicatorEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPriorityIndicator = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriorityIndicatorEnum} */ (jspb.Message.getFieldWithDefault(this, 100, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriorityIndicatorEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPriorityIndicator = function(value) {
  return jspb.Message.setProto3EnumField(this, 100, value);
};


/**
 * optional string regist_id = 101;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getRegistId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 101, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setRegistId = function(value) {
  return jspb.Message.setProto3StringField(this, 101, value);
};


/**
 * optional string secondary_cl_ord_id = 102;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 102, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 102, value);
};


/**
 * optional string secondary_exec_id = 103;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSecondaryExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 103, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSecondaryExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 103, value);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 104;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 104));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 104, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 104) != null;
};


/**
 * repeated Common.Stipulations stipulations = 105;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 105));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 105, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 105, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional fix.Decimal64 total_takedown = 106;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTotalTakedown = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 106));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTotalTakedown = function(value) {
  return jspb.Message.setWrapperField(this, 106, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTotalTakedown = function() {
  return this.setTotalTakedown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTotalTakedown = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional sfixed32 trade_origination_date = 107;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradeOriginationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 107, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradeOriginationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 107, value);
};


/**
 * optional bool traded_flat_switch = 108;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradedFlatSwitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 108, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradedFlatSwitch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 108, value);
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 109;
 * @return {!proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 109, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 109, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 109, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 109) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 110;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 110, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 110, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 110, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 110) != null;
};


/**
 * optional fix.Timestamp trans_bkd_time = 111;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTransBkdTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 111));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTransBkdTime = function(value) {
  return jspb.Message.setWrapperField(this, 111, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTransBkdTime = function() {
  return this.setTransBkdTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTransBkdTime = function() {
  return jspb.Message.getField(this, 111) != null;
};


/**
 * optional fix.Decimal64 underlying_last_px = 112;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getUnderlyingLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 112));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setUnderlyingLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 112, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearUnderlyingLastPx = function() {
  return this.setUnderlyingLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasUnderlyingLastPx = function() {
  return jspb.Message.getField(this, 112) != null;
};


/**
 * optional fix.Decimal64 underlying_last_qty = 113;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getUnderlyingLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 113));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setUnderlyingLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 113, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearUnderlyingLastQty = function() {
  return this.setUnderlyingLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasUnderlyingLastQty = function() {
  return jspb.Message.getField(this, 113) != null;
};


/**
 * optional bool working_indicator = 114;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getWorkingIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 114, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setWorkingIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 114, value);
};


/**
 * optional Common.YieldData yield_data = 115;
 * @return {?proto.Common.YieldData}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 115));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 115, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 115) != null;
};


/**
 * optional AcctIDSourceEnum acct_id_source = 116;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 116, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 116, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[5], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 116, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[5], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 116) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 117;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 117, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 117, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[5], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 117, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[5], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 117) != null;
};


/**
 * optional bool aggressor_indicator = 118;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAggressorIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 118, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAggressorIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 118, value);
};


/**
 * optional BookingTypeEnum booking_type = 119;
 * @return {!proto.SingleGeneralOrderHandling.BookingTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getBookingType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 119, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setBookingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 119, value);
};


/**
 * optional fix.Decimal64 calculated_ccy_last_qty = 120;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCalculatedCcyLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 120));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCalculatedCcyLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 120, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearCalculatedCcyLastQty = function() {
  return this.setCalculatedCcyLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasCalculatedCcyLastQty = function() {
  return jspb.Message.getField(this, 120) != null;
};


/**
 * repeated Common.ContAmtGrp cont_amt_grp = 121;
 * @return {!Array<!proto.Common.ContAmtGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getContAmtGrpList = function() {
  return /** @type{!Array<!proto.Common.ContAmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.ContAmtGrp, 121));
};


/**
 * @param {!Array<!proto.Common.ContAmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setContAmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 121, value);
};


/**
 * @param {!proto.Common.ContAmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ContAmtGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addContAmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 121, opt_value, proto.Common.ContAmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearContAmtGrpList = function() {
  return this.setContAmtGrpList([]);
};


/**
 * repeated Common.ContraGrp contra_grp = 122;
 * @return {!Array<!proto.Common.ContraGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getContraGrpList = function() {
  return /** @type{!Array<!proto.Common.ContraGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.ContraGrp, 122));
};


/**
 * @param {!Array<!proto.Common.ContraGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setContraGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 122, value);
};


/**
 * @param {!proto.Common.ContraGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ContraGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addContraGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 122, opt_value, proto.Common.ContraGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearContraGrpList = function() {
  return this.setContraGrpList([]);
};


/**
 * optional bool copy_msg_indicator = 123;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCopyMsgIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 123, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCopyMsgIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 123, value);
};


/**
 * optional bool cust_directed_order = 124;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCustDirectedOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 124, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCustDirectedOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 124, value);
};


/**
 * repeated CustOrderHandlingInstEnum cust_order_handling_inst = 125;
 * @return {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getCustOrderHandlingInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (jspb.Message.getRepeatedField(this, 125));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setCustOrderHandlingInstList = function(value) {
  return jspb.Message.setField(this, 125, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addCustOrderHandlingInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 125, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearCustOrderHandlingInstList = function() {
  return this.setCustOrderHandlingInstList([]);
};


/**
 * optional Common.DiscretionInstructions discretion_instructions = 126;
 * @return {?proto.Common.DiscretionInstructions}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDiscretionInstructions = function() {
  return /** @type{?proto.Common.DiscretionInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.DiscretionInstructions, 126));
};


/**
 * @param {?proto.Common.DiscretionInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDiscretionInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 126, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDiscretionInstructions = function() {
  return this.setDiscretionInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDiscretionInstructions = function() {
  return jspb.Message.getField(this, 126) != null;
};


/**
 * optional fix.Decimal64 discretion_price = 127;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDiscretionPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 127));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDiscretionPrice = function(value) {
  return jspb.Message.setWrapperField(this, 127, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDiscretionPrice = function() {
  return this.setDiscretionPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDiscretionPrice = function() {
  return jspb.Message.getField(this, 127) != null;
};


/**
 * optional Common.DisplayInstruction display_instruction = 128;
 * @return {?proto.Common.DisplayInstruction}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDisplayInstruction = function() {
  return /** @type{?proto.Common.DisplayInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.DisplayInstruction, 128));
};


/**
 * @param {?proto.Common.DisplayInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDisplayInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 128, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDisplayInstruction = function() {
  return this.setDisplayInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDisplayInstruction = function() {
  return jspb.Message.getField(this, 128) != null;
};


/**
 * optional fix.Decimal64 end_accrued_interest_amt = 129;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getEndAccruedInterestAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 129));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setEndAccruedInterestAmt = function(value) {
  return jspb.Message.setWrapperField(this, 129, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearEndAccruedInterestAmt = function() {
  return this.setEndAccruedInterestAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasEndAccruedInterestAmt = function() {
  return jspb.Message.getField(this, 129) != null;
};


/**
 * optional fix.Decimal64 end_cash = 130;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getEndCash = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 130));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setEndCash = function(value) {
  return jspb.Message.setWrapperField(this, 130, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearEndCash = function() {
  return this.setEndCash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasEndCash = function() {
  return jspb.Message.getField(this, 130) != null;
};


/**
 * optional Common.FinancingDetails financing_details = 131;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 131));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 131, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 131) != null;
};


/**
 * optional string host_cross_id = 132;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getHostCrossId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 132, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setHostCrossId = function(value) {
  return jspb.Message.setProto3StringField(this, 132, value);
};


/**
 * repeated Common.InstrmtLegExecGrp instrmt_leg_exec_grp = 133;
 * @return {!Array<!proto.Common.InstrmtLegExecGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getInstrmtLegExecGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegExecGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegExecGrp, 133));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegExecGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setInstrmtLegExecGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 133, value);
};


/**
 * @param {!proto.Common.InstrmtLegExecGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegExecGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addInstrmtLegExecGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 133, opt_value, proto.Common.InstrmtLegExecGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearInstrmtLegExecGrpList = function() {
  return this.setInstrmtLegExecGrpList([]);
};


/**
 * optional fix.Decimal64 interest_at_maturity = 134;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getInterestAtMaturity = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 134));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setInterestAtMaturity = function(value) {
  return jspb.Message.setWrapperField(this, 134, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearInterestAtMaturity = function() {
  return this.setInterestAtMaturity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasInterestAtMaturity = function() {
  return jspb.Message.getField(this, 134) != null;
};


/**
 * optional LastLiquidityIndEnum last_liquidity_ind = 135;
 * @return {!proto.SingleGeneralOrderHandling.LastLiquidityIndEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastLiquidityInd = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.LastLiquidityIndEnum} */ (jspb.Message.getFieldWithDefault(this, 135, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.LastLiquidityIndEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastLiquidityInd = function(value) {
  return jspb.Message.setProto3EnumField(this, 135, value);
};


/**
 * optional fix.Decimal64 last_par_px = 136;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastParPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 136));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastParPx = function(value) {
  return jspb.Message.setWrapperField(this, 136, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastParPx = function() {
  return this.setLastParPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastParPx = function() {
  return jspb.Message.getField(this, 136) != null;
};


/**
 * optional bool last_rpt_requested = 137;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastRptRequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 137, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastRptRequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 137, value);
};


/**
 * optional fix.Decimal64 last_swap_points = 138;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastSwapPoints = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 138));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastSwapPoints = function(value) {
  return jspb.Message.setWrapperField(this, 138, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearLastSwapPoints = function() {
  return this.setLastSwapPoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasLastSwapPoints = function() {
  return jspb.Message.getField(this, 138) != null;
};


/**
 * optional LotTypeEnum lot_type = 139;
 * @return {!proto.SingleGeneralOrderHandling.LotTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLotType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.LotTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 139, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.LotTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLotType = function(value) {
  return jspb.Message.setProto3EnumField(this, 139, value);
};


/**
 * optional bool manual_order_indicator = 140;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getManualOrderIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 140, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setManualOrderIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 140, value);
};


/**
 * optional string mass_status_req_id = 141;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMassStatusReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 141, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMassStatusReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 141, value);
};


/**
 * optional fix.Decimal64 match_increment = 142;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMatchIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 142));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMatchIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 142, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearMatchIncrement = function() {
  return this.setMatchIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasMatchIncrement = function() {
  return jspb.Message.getField(this, 142) != null;
};


/**
 * optional MatchTypeEnum match_type = 143;
 * @return {!proto.SingleGeneralOrderHandling.MatchTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMatchType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.MatchTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 143, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.MatchTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMatchType = function(value) {
  return jspb.Message.setProto3EnumField(this, 143, value);
};


/**
 * optional sfixed64 max_price_levels = 144;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMaxPriceLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 144, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMaxPriceLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 144, value);
};


/**
 * repeated Common.MiscFeesGrp misc_fees_grp = 145;
 * @return {!Array<!proto.Common.MiscFeesGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getMiscFeesGrpList = function() {
  return /** @type{!Array<!proto.Common.MiscFeesGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.MiscFeesGrp, 145));
};


/**
 * @param {!Array<!proto.Common.MiscFeesGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setMiscFeesGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 145, value);
};


/**
 * @param {!proto.Common.MiscFeesGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MiscFeesGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addMiscFeesGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 145, opt_value, proto.Common.MiscFeesGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearMiscFeesGrpList = function() {
  return this.setMiscFeesGrpList([]);
};


/**
 * optional string ord_status_req_id = 146;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrdStatusReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 146, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrdStatusReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 146, value);
};


/**
 * optional OrderCategoryEnum order_category = 147;
 * @return {!proto.SingleGeneralOrderHandling.OrderCategoryEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderCategory = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderCategoryEnum} */ (jspb.Message.getFieldWithDefault(this, 147, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderCategoryEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 147, value);
};


/**
 * optional OrderHandlingInstSourceEnum order_handling_inst_source = 148;
 * @return {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getOrderHandlingInstSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 148, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setOrderHandlingInstSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 148, value);
};


/**
 * optional fix.Decimal64 participation_rate = 149;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getParticipationRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 149));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setParticipationRate = function(value) {
  return jspb.Message.setWrapperField(this, 149, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearParticipationRate = function() {
  return this.setParticipationRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasParticipationRate = function() {
  return jspb.Message.getField(this, 149) != null;
};


/**
 * optional Common.PegInstructions peg_instructions = 150;
 * @return {?proto.Common.PegInstructions}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPegInstructions = function() {
  return /** @type{?proto.Common.PegInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.PegInstructions, 150));
};


/**
 * @param {?proto.Common.PegInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPegInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 150, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPegInstructions = function() {
  return this.setPegInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPegInstructions = function() {
  return jspb.Message.getField(this, 150) != null;
};


/**
 * optional fix.Decimal64 pegged_price = 151;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPeggedPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 151));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPeggedPrice = function(value) {
  return jspb.Message.setWrapperField(this, 151, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPeggedPrice = function() {
  return this.setPeggedPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPeggedPrice = function() {
  return jspb.Message.getField(this, 151) != null;
};


/**
 * optional fix.Decimal64 pegged_ref_price = 152;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPeggedRefPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 152));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPeggedRefPrice = function(value) {
  return jspb.Message.setWrapperField(this, 152, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPeggedRefPrice = function() {
  return this.setPeggedRefPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPeggedRefPrice = function() {
  return jspb.Message.getField(this, 152) != null;
};


/**
 * optional bool pre_trade_anonymity = 153;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPreTradeAnonymity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 153, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPreTradeAnonymity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 153, value);
};


/**
 * optional PriceProtectionScopeEnum price_protection_scope = 154;
 * @return {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPriceProtectionScope = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 154, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPriceProtectionScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 154, value);
};


/**
 * optional QtyTypeEnum qty_type = 155;
 * @return {!proto.SingleGeneralOrderHandling.QtyTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getQtyType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 155, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.QtyTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setQtyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 155, value);
};


/**
 * optional string quote_resp_id = 156;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getQuoteRespId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 156, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setQuoteRespId = function(value) {
  return jspb.Message.setProto3StringField(this, 156, value);
};


/**
 * optional string received_dept_id = 157;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getReceivedDeptId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 157, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setReceivedDeptId = function(value) {
  return jspb.Message.setProto3StringField(this, 157, value);
};


/**
 * optional fix.Decimal64 start_cash = 158;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStartCash = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 158));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStartCash = function(value) {
  return jspb.Message.setWrapperField(this, 158, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStartCash = function() {
  return this.setStartCash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasStartCash = function() {
  return jspb.Message.getField(this, 158) != null;
};


/**
 * repeated Common.StrategyParametersGrp strategy_parameters_grp = 159;
 * @return {!Array<!proto.Common.StrategyParametersGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getStrategyParametersGrpList = function() {
  return /** @type{!Array<!proto.Common.StrategyParametersGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.StrategyParametersGrp, 159));
};


/**
 * @param {!Array<!proto.Common.StrategyParametersGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setStrategyParametersGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 159, value);
};


/**
 * @param {!proto.Common.StrategyParametersGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrategyParametersGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addStrategyParametersGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 159, opt_value, proto.Common.StrategyParametersGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearStrategyParametersGrpList = function() {
  return this.setStrategyParametersGrpList([]);
};


/**
 * optional TargetStrategyEnum target_strategy = 160;
 * @return {!proto.SingleGeneralOrderHandling.TargetStrategyEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTargetStrategy = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getFieldWithDefault(this, 160, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTargetStrategy = function(value) {
  return jspb.Message.setOneofField(this, 160, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[6], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTargetStrategy = function() {
  return jspb.Message.setOneofField(this, 160, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[6], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTargetStrategy = function() {
  return jspb.Message.getField(this, 160) != null;
};


/**
 * optional fixed32 target_strategy_reserved1000plus = 163;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTargetStrategyReserved1000plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 163, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTargetStrategyReserved1000plus = function(value) {
  return jspb.Message.setOneofField(this, 163, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[6], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTargetStrategyReserved1000plus = function() {
  return jspb.Message.setOneofField(this, 163, proto.SingleGeneralOrderHandling.ExecutionReport.oneofGroups_[6], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTargetStrategyReserved1000plus = function() {
  return jspb.Message.getField(this, 163) != null;
};


/**
 * optional string target_strategy_parameters = 161;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTargetStrategyParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 161, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTargetStrategyParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 161, value);
};


/**
 * optional fix.Decimal64 target_strategy_performance = 162;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTargetStrategyPerformance = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 162));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTargetStrategyPerformance = function(value) {
  return jspb.Message.setWrapperField(this, 162, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTargetStrategyPerformance = function() {
  return this.setTargetStrategyPerformance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTargetStrategyPerformance = function() {
  return jspb.Message.getField(this, 162) != null;
};


/**
 * optional string time_bracket = 164;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTimeBracket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 164, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTimeBracket = function(value) {
  return jspb.Message.setProto3StringField(this, 164, value);
};


/**
 * optional sfixed64 tot_num_reports = 165;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTotNumReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 165, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTotNumReports = function(value) {
  return jspb.Message.setProto3IntField(this, 165, value);
};


/**
 * repeated Common.TrdRegTimestamps trd_reg_timestamps = 166;
 * @return {!Array<!proto.Common.TrdRegTimestamps>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTrdRegTimestampsList = function() {
  return /** @type{!Array<!proto.Common.TrdRegTimestamps>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.TrdRegTimestamps, 166));
};


/**
 * @param {!Array<!proto.Common.TrdRegTimestamps>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTrdRegTimestampsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 166, value);
};


/**
 * @param {!proto.Common.TrdRegTimestamps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdRegTimestamps}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addTrdRegTimestamps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 166, opt_value, proto.Common.TrdRegTimestamps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTrdRegTimestampsList = function() {
  return this.setTrdRegTimestampsList([]);
};


/**
 * optional Common.TriggeringInstruction triggering_instruction = 167;
 * @return {?proto.Common.TriggeringInstruction}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTriggeringInstruction = function() {
  return /** @type{?proto.Common.TriggeringInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.TriggeringInstruction, 167));
};


/**
 * @param {?proto.Common.TriggeringInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTriggeringInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 167, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTriggeringInstruction = function() {
  return this.setTriggeringInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTriggeringInstruction = function() {
  return jspb.Message.getField(this, 167) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 168;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 168));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 168, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 168, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional string alloc_id = 169;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 169, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 169, value);
};


/**
 * optional Common.ApplicationSequenceControl application_sequence_control = 170;
 * @return {?proto.Common.ApplicationSequenceControl}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getApplicationSequenceControl = function() {
  return /** @type{?proto.Common.ApplicationSequenceControl} */ (
    jspb.Message.getWrapperField(this, common_pb.ApplicationSequenceControl, 170));
};


/**
 * @param {?proto.Common.ApplicationSequenceControl|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setApplicationSequenceControl = function(value) {
  return jspb.Message.setWrapperField(this, 170, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearApplicationSequenceControl = function() {
  return this.setApplicationSequenceControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasApplicationSequenceControl = function() {
  return jspb.Message.getField(this, 170) != null;
};


/**
 * optional fix.Decimal64 dividend_yield = 171;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getDividendYield = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 171));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setDividendYield = function(value) {
  return jspb.Message.setWrapperField(this, 171, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearDividendYield = function() {
  return this.setDividendYield(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasDividendYield = function() {
  return jspb.Message.getField(this, 171) != null;
};


/**
 * repeated FillsGrp fills_grp = 172;
 * @return {!Array<!proto.SingleGeneralOrderHandling.FillsGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getFillsGrpList = function() {
  return /** @type{!Array<!proto.SingleGeneralOrderHandling.FillsGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SingleGeneralOrderHandling.FillsGrp, 172));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.FillsGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setFillsGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 172, value);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.FillsGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.FillsGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addFillsGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 172, opt_value, proto.SingleGeneralOrderHandling.FillsGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearFillsGrpList = function() {
  return this.setFillsGrpList([]);
};


/**
 * optional bool last_fragment = 173;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getLastFragment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 173, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setLastFragment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 173, value);
};


/**
 * repeated Common.PreAllocGrp pre_alloc_grp = 174;
 * @return {!Array<!proto.Common.PreAllocGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPreAllocGrpList = function() {
  return /** @type{!Array<!proto.Common.PreAllocGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.PreAllocGrp, 174));
};


/**
 * @param {!Array<!proto.Common.PreAllocGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPreAllocGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 174, value);
};


/**
 * @param {!proto.Common.PreAllocGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.PreAllocGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addPreAllocGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 174, opt_value, proto.Common.PreAllocGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPreAllocGrpList = function() {
  return this.setPreAllocGrpList([]);
};


/**
 * optional fix.Decimal64 price_delta = 175;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getPriceDelta = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 175));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setPriceDelta = function(value) {
  return jspb.Message.setWrapperField(this, 175, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearPriceDelta = function() {
  return this.setPriceDelta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasPriceDelta = function() {
  return jspb.Message.getField(this, 175) != null;
};


/**
 * optional fix.Decimal64 risk_free_rate = 176;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getRiskFreeRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 176));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setRiskFreeRate = function(value) {
  return jspb.Message.setWrapperField(this, 176, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearRiskFreeRate = function() {
  return this.setRiskFreeRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasRiskFreeRate = function() {
  return jspb.Message.getField(this, 176) != null;
};


/**
 * optional fix.Decimal64 time_to_expiration = 177;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTimeToExpiration = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 177));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTimeToExpiration = function(value) {
  return jspb.Message.setWrapperField(this, 177, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearTimeToExpiration = function() {
  return this.setTimeToExpiration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasTimeToExpiration = function() {
  return jspb.Message.getField(this, 177) != null;
};


/**
 * optional sfixed64 tot_no_fills = 178;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTotNoFills = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 178, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTotNoFills = function(value) {
  return jspb.Message.setProto3IntField(this, 178, value);
};


/**
 * optional string trd_match_id = 179;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getTrdMatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 179, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setTrdMatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 179, value);
};


/**
 * optional fix.Decimal64 volatility = 180;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getVolatility = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 180));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setVolatility = function(value) {
  return jspb.Message.setWrapperField(this, 180, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearVolatility = function() {
  return this.setVolatility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.hasVolatility = function() {
  return jspb.Message.getField(this, 180) != null;
};


/**
 * repeated Common.RateSource rate_source = 181;
 * @return {!Array<!proto.Common.RateSource>}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getRateSourceList = function() {
  return /** @type{!Array<!proto.Common.RateSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.RateSource, 181));
};


/**
 * @param {!Array<!proto.Common.RateSource>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setRateSourceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 181, value);
};


/**
 * @param {!proto.Common.RateSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.RateSource}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.addRateSource = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 181, opt_value, proto.Common.RateSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.clearRateSourceList = function() {
  return this.setRateSourceList([]);
};


/**
 * optional bool is_allocated = 182;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.getIsAllocated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 182, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionReport} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionReport.prototype.setIsAllocated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 182, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_ = [[2,3],[23,24]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.CxlRejReasonUnionCase = {
  CXL_REJ_REASON_UNION_NOT_SET: 0,
  CXL_REJ_REASON: 2,
  CXL_REJ_REASON_RESERVED100PLUS: 3
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelReject.CxlRejReasonUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getCxlRejReasonUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelReject.CxlRejReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 23,
  ACCT_ID_SOURCE_RESERVED100PLUS: 24
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelReject.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelReject.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.OrderCancelReject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.toObject = function(includeInstance, msg) {
  var f, obj = {
    clOrdId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cxlRejReason: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cxlRejReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    listId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 8, ""),
    ordStatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    origClOrdId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    secondaryOrderId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    account: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cxlRejResponseTo: jspb.Message.getFieldWithDefault(msg, 13, 0),
    encodedText: jspb.Message.getFieldWithDefault(msg, 14, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 15, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    accountType: jspb.Message.getFieldWithDefault(msg, 17, 0),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    origOrdModTime: (f = msg.getOrigOrdModTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    tradeOriginationDate: jspb.Message.getFieldWithDefault(msg, 21, 0),
    workingIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 23, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 24, 0),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.OrderCancelReject;
  return proto.SingleGeneralOrderHandling.OrderCancelReject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 2:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CxlRejReasonEnum} */ (reader.readEnum());
      msg.setCxlRejReason(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setCxlRejReasonReserved100plus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setListId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 6:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 7:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 9:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (reader.readEnum());
      msg.setOrdStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigClOrdId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrderId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 13:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CxlRejResponseToEnum} */ (reader.readEnum());
      msg.setCxlRejResponseTo(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 16:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 17:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 19:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrigOrdModTime(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeOriginationDate(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWorkingIndicator(value);
      break;
    case 23:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.OrderCancelReject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.CxlRejReasonEnum} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFixed32(
      3,
      f
    );
  }
  f = message.getListId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrdStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getOrigClOrdId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCxlRejResponseTo();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      15,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOrigOrdModTime();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getTradeOriginationDate();
  if (f !== 0) {
    writer.writeSfixed32(
      21,
      f
    );
  }
  f = message.getWorkingIndicator();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeFixed32(
      24,
      f
    );
  }
  f = message.getTradeDate();
  if (f !== 0) {
    writer.writeSfixed32(
      25,
      f
    );
  }
};


/**
 * optional string cl_ord_id = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CxlRejReasonEnum cxl_rej_reason = 2;
 * @return {!proto.SingleGeneralOrderHandling.CxlRejReasonEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getCxlRejReason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CxlRejReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CxlRejReasonEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setCxlRejReason = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearCxlRejReason = function() {
  return jspb.Message.setOneofField(this, 2, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasCxlRejReason = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fixed32 cxl_rej_reason_reserved100plus = 3;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getCxlRejReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setCxlRejReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearCxlRejReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 3, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasCxlRejReasonReserved100plus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string list_id = 4;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setListId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string order_id = 5;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Session.StandardHeader standard_header = 6;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 6));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 7;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 7));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string text = 8;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional OrdStatusEnum ord_status = 9;
 * @return {!proto.SingleGeneralOrderHandling.OrdStatusEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getOrdStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setOrdStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string orig_cl_ord_id = 10;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getOrigClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setOrigClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string secondary_order_id = 11;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string account = 12;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional CxlRejResponseToEnum cxl_rej_response_to = 13;
 * @return {!proto.SingleGeneralOrderHandling.CxlRejResponseToEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getCxlRejResponseTo = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CxlRejResponseToEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CxlRejResponseToEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setCxlRejResponseTo = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string encoded_text = 14;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional sfixed64 encoded_text_len = 15;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional fix.Timestamp transact_time = 16;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 16));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional AccountTypeEnum account_type = 17;
 * @return {!proto.SingleGeneralOrderHandling.AccountTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getAccountType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AccountTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string cl_ord_link_id = 18;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional fix.Timestamp orig_ord_mod_time = 19;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getOrigOrdModTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 19));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setOrigOrdModTime = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearOrigOrdModTime = function() {
  return this.setOrigOrdModTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasOrigOrdModTime = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string secondary_cl_ord_id = 20;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional sfixed32 trade_origination_date = 21;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getTradeOriginationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setTradeOriginationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional bool working_indicator = 22;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getWorkingIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setWorkingIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional AcctIDSourceEnum acct_id_source = 23;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 23, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 23, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 24;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 24, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 24, proto.SingleGeneralOrderHandling.OrderCancelReject.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional sfixed32 trade_date = 25;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.getTradeDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReject} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReject.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.repeatedFields_ = [5,55,56,63,71,82,89,94,95,97];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_ = [[14,15],[66,67],[90,92]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.SettlTypeUnionCase = {
  SETTL_TYPE_UNION_NOT_SET: 0,
  SETTL_TYPE: 14,
  SETTL_TYPE_TENOR: 15
};

/**
 * @return {proto.SingleGeneralOrderHandling.NewOrderSingle.SettlTypeUnionCase}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlTypeUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.NewOrderSingle.SettlTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 66,
  ACCT_ID_SOURCE_RESERVED100PLUS: 67
};

/**
 * @return {proto.SingleGeneralOrderHandling.NewOrderSingle.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.NewOrderSingle.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.TargetStrategyUnionCase = {
  TARGET_STRATEGY_UNION_NOT_SET: 0,
  TARGET_STRATEGY: 90,
  TARGET_STRATEGY_RESERVED1000PLUS: 92
};

/**
 * @return {proto.SingleGeneralOrderHandling.NewOrderSingle.TargetStrategyUnionCase}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTargetStrategyUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.NewOrderSingle.TargetStrategyUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[2]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.NewOrderSingle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.NewOrderSingle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clOrdId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
    exDestination: jspb.Message.getFieldWithDefault(msg, 4, ""),
    execInstList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    handlInst: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ioiId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    maxFloor: (f = msg.getMaxFloor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    minQty: (f = msg.getMinQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    ordType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    processCode: jspb.Message.getFieldWithDefault(msg, 12, 0),
    settlDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    settlType: jspb.Message.getFieldWithDefault(msg, 14, 0),
    settlTypeTenor: (f = msg.getSettlTypeTenor()) && fix_pb.Tenor.toObject(includeInstance, f),
    side: jspb.Message.getFieldWithDefault(msg, 16, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    stopPx: (f = msg.getStopPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 20, ""),
    timeInForce: jspb.Message.getFieldWithDefault(msg, 21, 0),
    expireTime: (f = msg.getExpireTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    forexReq: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    locateReqd: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    prevClosePx: (f = msg.getPrevClosePx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    quoteId: jspb.Message.getFieldWithDefault(msg, 26, ""),
    settlCurrency: jspb.Message.getFieldWithDefault(msg, 27, ""),
    coveredOrUncovered: jspb.Message.getFieldWithDefault(msg, 28, 0),
    maxShow: (f = msg.getMaxShow()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty2: (f = msg.getOrderQty2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    positionEffect: jspb.Message.getFieldWithDefault(msg, 31, 0),
    settlDate2: jspb.Message.getFieldWithDefault(msg, 32, 0),
    complianceId: jspb.Message.getFieldWithDefault(msg, 33, ""),
    effectiveTime: (f = msg.getEffectiveTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    encodedText: jspb.Message.getFieldWithDefault(msg, 35, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 36, 0),
    expireDate: jspb.Message.getFieldWithDefault(msg, 37, 0),
    gtBookingInst: jspb.Message.getFieldWithDefault(msg, 38, 0),
    solicitedFlag: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    accountType: jspb.Message.getFieldWithDefault(msg, 41, 0),
    bookingUnit: jspb.Message.getFieldWithDefault(msg, 42, 0),
    cancellationRights: jspb.Message.getFieldWithDefault(msg, 43, 0),
    cashMargin: jspb.Message.getFieldWithDefault(msg, 44, 0),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 45, ""),
    clearingFeeIndicator: jspb.Message.getFieldWithDefault(msg, 46, 0),
    commissionData: (f = msg.getCommissionData()) && common_pb.CommissionData.toObject(includeInstance, f),
    custOrderCapacity: jspb.Message.getFieldWithDefault(msg, 48, 0),
    dayBookingInst: jspb.Message.getFieldWithDefault(msg, 49, 0),
    designation: jspb.Message.getFieldWithDefault(msg, 50, ""),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    moneyLaunderingStatus: jspb.Message.getFieldWithDefault(msg, 52, 0),
    orderCapacity: jspb.Message.getFieldWithDefault(msg, 53, 0),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    orderRestrictionsList: (f = jspb.Message.getRepeatedField(msg, 55)) == null ? undefined : f,
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    preallocMethod: jspb.Message.getFieldWithDefault(msg, 57, 0),
    price2: (f = msg.getPrice2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 59, 0),
    registId: jspb.Message.getFieldWithDefault(msg, 60, ""),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 61, ""),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    stipulationsList: jspb.Message.toObjectList(msg.getStipulationsList(),
    common_pb.Stipulations.toObject, includeInstance),
    tradeOriginationDate: jspb.Message.getFieldWithDefault(msg, 64, 0),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 66, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 67, 0),
    allocId: jspb.Message.getFieldWithDefault(msg, 68, ""),
    bookingType: jspb.Message.getFieldWithDefault(msg, 69, 0),
    custDirectedOrder: jspb.Message.getBooleanFieldWithDefault(msg, 70, false),
    custOrderHandlingInstList: (f = jspb.Message.getRepeatedField(msg, 71)) == null ? undefined : f,
    discretionInstructions: (f = msg.getDiscretionInstructions()) && common_pb.DiscretionInstructions.toObject(includeInstance, f),
    displayInstruction: (f = msg.getDisplayInstruction()) && common_pb.DisplayInstruction.toObject(includeInstance, f),
    exDestinationIdSource: jspb.Message.getFieldWithDefault(msg, 74, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    manualOrderIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 76, false),
    matchIncrement: (f = msg.getMatchIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxPriceLevels: jspb.Message.getFieldWithDefault(msg, 78, 0),
    orderHandlingInstSource: jspb.Message.getFieldWithDefault(msg, 79, 0),
    participationRate: (f = msg.getParticipationRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    pegInstructions: (f = msg.getPegInstructions()) && common_pb.PegInstructions.toObject(includeInstance, f),
    preAllocGrpList: jspb.Message.toObjectList(msg.getPreAllocGrpList(),
    common_pb.PreAllocGrp.toObject, includeInstance),
    preTradeAnonymity: jspb.Message.getBooleanFieldWithDefault(msg, 83, false),
    priceProtectionScope: jspb.Message.getFieldWithDefault(msg, 84, 0),
    qtyType: jspb.Message.getFieldWithDefault(msg, 85, 0),
    receivedDeptId: jspb.Message.getFieldWithDefault(msg, 86, ""),
    refOrderId: jspb.Message.getFieldWithDefault(msg, 87, ""),
    refOrderIdSource: jspb.Message.getFieldWithDefault(msg, 88, 0),
    strategyParametersGrpList: jspb.Message.toObjectList(msg.getStrategyParametersGrpList(),
    common_pb.StrategyParametersGrp.toObject, includeInstance),
    targetStrategy: jspb.Message.getFieldWithDefault(msg, 90, 0),
    targetStrategyReserved1000plus: jspb.Message.getFieldWithDefault(msg, 92, 0),
    targetStrategyParameters: jspb.Message.getFieldWithDefault(msg, 91, ""),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 93, 0),
    trdRegTimestampsList: jspb.Message.toObjectList(msg.getTrdRegTimestampsList(),
    common_pb.TrdRegTimestamps.toObject, includeInstance),
    trdgSesGrpList: jspb.Message.toObjectList(msg.getTrdgSesGrpList(),
    common_pb.TrdgSesGrp.toObject, includeInstance),
    triggeringInstruction: (f = msg.getTriggeringInstruction()) && common_pb.TriggeringInstruction.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.NewOrderSingle;
  return proto.SingleGeneralOrderHandling.NewOrderSingle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.NewOrderSingle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExDestination(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addExecInst(values[i]);
      }
      break;
    case 6:
      var value = /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (reader.readEnum());
      msg.setHandlInst(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIoiId(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxFloor(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinQty(value);
      break;
    case 10:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (reader.readEnum());
      msg.setOrdType(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 12:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ProcessCodeEnum} */ (reader.readEnum());
      msg.setProcessCode(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate(value);
      break;
    case 14:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (reader.readEnum());
      msg.setSettlType(value);
      break;
    case 15:
      var value = new fix_pb.Tenor;
      reader.readMessage(value,fix_pb.Tenor.deserializeBinaryFromReader);
      msg.setSettlTypeTenor(value);
      break;
    case 16:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 17:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 18:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 19:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStopPx(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 21:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (reader.readEnum());
      msg.setTimeInForce(value);
      break;
    case 22:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpireTime(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForexReq(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLocateReqd(value);
      break;
    case 25:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrevClosePx(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuoteId(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlCurrency(value);
      break;
    case 28:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} */ (reader.readEnum());
      msg.setCoveredOrUncovered(value);
      break;
    case 29:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxShow(value);
      break;
    case 30:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty2(value);
      break;
    case 31:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (reader.readEnum());
      msg.setPositionEffect(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate2(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceId(value);
      break;
    case 34:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveTime(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExpireDate(value);
      break;
    case 38:
      var value = /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (reader.readEnum());
      msg.setGtBookingInst(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSolicitedFlag(value);
      break;
    case 40:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 41:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 42:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (reader.readEnum());
      msg.setBookingUnit(value);
      break;
    case 43:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (reader.readEnum());
      msg.setCancellationRights(value);
      break;
    case 44:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (reader.readEnum());
      msg.setCashMargin(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 46:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (reader.readEnum());
      msg.setClearingFeeIndicator(value);
      break;
    case 47:
      var value = new common_pb.CommissionData;
      reader.readMessage(value,common_pb.CommissionData.deserializeBinaryFromReader);
      msg.setCommissionData(value);
      break;
    case 48:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (reader.readEnum());
      msg.setCustOrderCapacity(value);
      break;
    case 49:
      var value = /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (reader.readEnum());
      msg.setDayBookingInst(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesignation(value);
      break;
    case 51:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 52:
      var value = /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (reader.readEnum());
      msg.setMoneyLaunderingStatus(value);
      break;
    case 53:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (reader.readEnum());
      msg.setOrderCapacity(value);
      break;
    case 54:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 55:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderRestrictions(values[i]);
      }
      break;
    case 56:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 57:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (reader.readEnum());
      msg.setPreallocMethod(value);
      break;
    case 58:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice2(value);
      break;
    case 59:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistId(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 62:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 63:
      var value = new common_pb.Stipulations;
      reader.readMessage(value,common_pb.Stipulations.deserializeBinaryFromReader);
      msg.addStipulations(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeOriginationDate(value);
      break;
    case 65:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 66:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 68:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocId(value);
      break;
    case 69:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (reader.readEnum());
      msg.setBookingType(value);
      break;
    case 70:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustDirectedOrder(value);
      break;
    case 71:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCustOrderHandlingInst(values[i]);
      }
      break;
    case 72:
      var value = new common_pb.DiscretionInstructions;
      reader.readMessage(value,common_pb.DiscretionInstructions.deserializeBinaryFromReader);
      msg.setDiscretionInstructions(value);
      break;
    case 73:
      var value = new common_pb.DisplayInstruction;
      reader.readMessage(value,common_pb.DisplayInstruction.deserializeBinaryFromReader);
      msg.setDisplayInstruction(value);
      break;
    case 74:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} */ (reader.readEnum());
      msg.setExDestinationIdSource(value);
      break;
    case 75:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 76:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManualOrderIndicator(value);
      break;
    case 77:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMatchIncrement(value);
      break;
    case 78:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaxPriceLevels(value);
      break;
    case 79:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (reader.readEnum());
      msg.setOrderHandlingInstSource(value);
      break;
    case 80:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setParticipationRate(value);
      break;
    case 81:
      var value = new common_pb.PegInstructions;
      reader.readMessage(value,common_pb.PegInstructions.deserializeBinaryFromReader);
      msg.setPegInstructions(value);
      break;
    case 82:
      var value = new common_pb.PreAllocGrp;
      reader.readMessage(value,common_pb.PreAllocGrp.deserializeBinaryFromReader);
      msg.addPreAllocGrp(value);
      break;
    case 83:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreTradeAnonymity(value);
      break;
    case 84:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (reader.readEnum());
      msg.setPriceProtectionScope(value);
      break;
    case 85:
      var value = /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (reader.readEnum());
      msg.setQtyType(value);
      break;
    case 86:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivedDeptId(value);
      break;
    case 87:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefOrderId(value);
      break;
    case 88:
      var value = /** @type {!proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum} */ (reader.readEnum());
      msg.setRefOrderIdSource(value);
      break;
    case 89:
      var value = new common_pb.StrategyParametersGrp;
      reader.readMessage(value,common_pb.StrategyParametersGrp.deserializeBinaryFromReader);
      msg.addStrategyParametersGrp(value);
      break;
    case 90:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (reader.readEnum());
      msg.setTargetStrategy(value);
      break;
    case 92:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTargetStrategyReserved1000plus(value);
      break;
    case 91:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetStrategyParameters(value);
      break;
    case 93:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeDate(value);
      break;
    case 94:
      var value = new common_pb.TrdRegTimestamps;
      reader.readMessage(value,common_pb.TrdRegTimestamps.deserializeBinaryFromReader);
      msg.addTrdRegTimestamps(value);
      break;
    case 95:
      var value = new common_pb.TrdgSesGrp;
      reader.readMessage(value,common_pb.TrdgSesGrp.deserializeBinaryFromReader);
      msg.addTrdgSesGrp(value);
      break;
    case 96:
      var value = new common_pb.TriggeringInstruction;
      reader.readMessage(value,common_pb.TriggeringInstruction.deserializeBinaryFromReader);
      msg.setTriggeringInstruction(value);
      break;
    case 97:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.NewOrderSingle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.NewOrderSingle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExDestination();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExecInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getHandlInst();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getIoiId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMaxFloor();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMinQty();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrdType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getProcessCode();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getSettlDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSettlTypeTenor();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      fix_pb.Tenor.serializeBinaryToWriter
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getStopPx();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getTimeInForce();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getExpireTime();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getForexReq();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getLocateReqd();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getPrevClosePx();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getQuoteId();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getCoveredOrUncovered();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getMaxShow();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty2();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPositionEffect();
  if (f !== 0.0) {
    writer.writeEnum(
      31,
      f
    );
  }
  f = message.getSettlDate2();
  if (f !== 0) {
    writer.writeSfixed32(
      32,
      f
    );
  }
  f = message.getComplianceId();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getEffectiveTime();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      36,
      f
    );
  }
  f = message.getExpireDate();
  if (f !== 0) {
    writer.writeSfixed32(
      37,
      f
    );
  }
  f = message.getGtBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      38,
      f
    );
  }
  f = message.getSolicitedFlag();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      41,
      f
    );
  }
  f = message.getBookingUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      42,
      f
    );
  }
  f = message.getCancellationRights();
  if (f !== 0.0) {
    writer.writeEnum(
      43,
      f
    );
  }
  f = message.getCashMargin();
  if (f !== 0.0) {
    writer.writeEnum(
      44,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getClearingFeeIndicator();
  if (f !== 0.0) {
    writer.writeEnum(
      46,
      f
    );
  }
  f = message.getCommissionData();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      common_pb.CommissionData.serializeBinaryToWriter
    );
  }
  f = message.getCustOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      48,
      f
    );
  }
  f = message.getDayBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      49,
      f
    );
  }
  f = message.getDesignation();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getMoneyLaunderingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      52,
      f
    );
  }
  f = message.getOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getOrderRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      55,
      f
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      56,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getPreallocMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      57,
      f
    );
  }
  f = message.getPrice2();
  if (f != null) {
    writer.writeMessage(
      58,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      59,
      f
    );
  }
  f = message.getRegistId();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      62,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      63,
      f,
      common_pb.Stipulations.serializeBinaryToWriter
    );
  }
  f = message.getTradeOriginationDate();
  if (f !== 0) {
    writer.writeSfixed32(
      64,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeEnum(
      66,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 67));
  if (f != null) {
    writer.writeFixed32(
      67,
      f
    );
  }
  f = message.getAllocId();
  if (f.length > 0) {
    writer.writeString(
      68,
      f
    );
  }
  f = message.getBookingType();
  if (f !== 0.0) {
    writer.writeEnum(
      69,
      f
    );
  }
  f = message.getCustDirectedOrder();
  if (f) {
    writer.writeBool(
      70,
      f
    );
  }
  f = message.getCustOrderHandlingInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      71,
      f
    );
  }
  f = message.getDiscretionInstructions();
  if (f != null) {
    writer.writeMessage(
      72,
      f,
      common_pb.DiscretionInstructions.serializeBinaryToWriter
    );
  }
  f = message.getDisplayInstruction();
  if (f != null) {
    writer.writeMessage(
      73,
      f,
      common_pb.DisplayInstruction.serializeBinaryToWriter
    );
  }
  f = message.getExDestinationIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      74,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      75,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getManualOrderIndicator();
  if (f) {
    writer.writeBool(
      76,
      f
    );
  }
  f = message.getMatchIncrement();
  if (f != null) {
    writer.writeMessage(
      77,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxPriceLevels();
  if (f !== 0) {
    writer.writeSfixed64(
      78,
      f
    );
  }
  f = message.getOrderHandlingInstSource();
  if (f !== 0.0) {
    writer.writeEnum(
      79,
      f
    );
  }
  f = message.getParticipationRate();
  if (f != null) {
    writer.writeMessage(
      80,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPegInstructions();
  if (f != null) {
    writer.writeMessage(
      81,
      f,
      common_pb.PegInstructions.serializeBinaryToWriter
    );
  }
  f = message.getPreAllocGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      82,
      f,
      common_pb.PreAllocGrp.serializeBinaryToWriter
    );
  }
  f = message.getPreTradeAnonymity();
  if (f) {
    writer.writeBool(
      83,
      f
    );
  }
  f = message.getPriceProtectionScope();
  if (f !== 0.0) {
    writer.writeEnum(
      84,
      f
    );
  }
  f = message.getQtyType();
  if (f !== 0.0) {
    writer.writeEnum(
      85,
      f
    );
  }
  f = message.getReceivedDeptId();
  if (f.length > 0) {
    writer.writeString(
      86,
      f
    );
  }
  f = message.getRefOrderId();
  if (f.length > 0) {
    writer.writeString(
      87,
      f
    );
  }
  f = message.getRefOrderIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      88,
      f
    );
  }
  f = message.getStrategyParametersGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      89,
      f,
      common_pb.StrategyParametersGrp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getField(message, 90));
  if (f != null) {
    writer.writeEnum(
      90,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 92));
  if (f != null) {
    writer.writeFixed32(
      92,
      f
    );
  }
  f = message.getTargetStrategyParameters();
  if (f.length > 0) {
    writer.writeString(
      91,
      f
    );
  }
  f = message.getTradeDate();
  if (f !== 0) {
    writer.writeSfixed32(
      93,
      f
    );
  }
  f = message.getTrdRegTimestampsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      94,
      f,
      common_pb.TrdRegTimestamps.serializeBinaryToWriter
    );
  }
  f = message.getTrdgSesGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      95,
      f,
      common_pb.TrdgSesGrp.serializeBinaryToWriter
    );
  }
  f = message.getTriggeringInstruction();
  if (f != null) {
    writer.writeMessage(
      96,
      f,
      common_pb.TriggeringInstruction.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      97,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cl_ord_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ex_destination = 4;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getExDestination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setExDestination = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated ExecInstEnum exec_inst = 5;
 * @return {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getExecInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setExecInstList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addExecInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearExecInstList = function() {
  return this.setExecInstList([]);
};


/**
 * optional HandlInstEnum handl_inst = 6;
 * @return {!proto.SingleGeneralOrderHandling.HandlInstEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getHandlInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.HandlInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setHandlInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string ioi_id = 7;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getIoiId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setIoiId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional fix.Decimal64 max_floor = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMaxFloor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMaxFloor = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearMaxFloor = function() {
  return this.setMaxFloor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasMaxFloor = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional fix.Decimal64 min_qty = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMinQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMinQty = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearMinQty = function() {
  return this.setMinQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasMinQty = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional OrdTypeEnum ord_type = 10;
 * @return {!proto.SingleGeneralOrderHandling.OrdTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrdType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional fix.Decimal64 price = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ProcessCodeEnum process_code = 12;
 * @return {!proto.SingleGeneralOrderHandling.ProcessCodeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getProcessCode = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ProcessCodeEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ProcessCodeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setProcessCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional sfixed32 settl_date = 13;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSettlDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional SettlTypeEnum settl_type = 14;
 * @return {!proto.SingleGeneralOrderHandling.SettlTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SettlTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSettlType = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearSettlType = function() {
  return jspb.Message.setOneofField(this, 14, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasSettlType = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional fix.Tenor settl_type_tenor = 15;
 * @return {?proto.fix.Tenor}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlTypeTenor = function() {
  return /** @type{?proto.fix.Tenor} */ (
    jspb.Message.getWrapperField(this, fix_pb.Tenor, 15));
};


/**
 * @param {?proto.fix.Tenor|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSettlTypeTenor = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearSettlTypeTenor = function() {
  return this.setSettlTypeTenor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasSettlTypeTenor = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional SideEnum side = 16;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional Session.StandardHeader standard_header = 17;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 17));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 18;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 18));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional fix.Decimal64 stop_px = 19;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getStopPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 19));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setStopPx = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearStopPx = function() {
  return this.setStopPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasStopPx = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string text = 20;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional TimeInForceEnum time_in_force = 21;
 * @return {!proto.SingleGeneralOrderHandling.TimeInForceEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTimeInForce = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TimeInForceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTimeInForce = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional fix.Timestamp expire_time = 22;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getExpireTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 22));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setExpireTime = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearExpireTime = function() {
  return this.setExpireTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasExpireTime = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool forex_req = 23;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getForexReq = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setForexReq = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool locate_reqd = 24;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getLocateReqd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setLocateReqd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional fix.Decimal64 prev_close_px = 25;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPrevClosePx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 25));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPrevClosePx = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPrevClosePx = function() {
  return this.setPrevClosePx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasPrevClosePx = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional string quote_id = 26;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getQuoteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setQuoteId = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string settl_currency = 27;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional CoveredOrUncoveredEnum covered_or_uncovered = 28;
 * @return {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCoveredOrUncovered = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCoveredOrUncovered = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional fix.Decimal64 max_show = 29;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMaxShow = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 29));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMaxShow = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearMaxShow = function() {
  return this.setMaxShow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasMaxShow = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional fix.Decimal64 order_qty2 = 30;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrderQty2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 30));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrderQty2 = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearOrderQty2 = function() {
  return this.setOrderQty2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasOrderQty2 = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional PositionEffectEnum position_effect = 31;
 * @return {!proto.SingleGeneralOrderHandling.PositionEffectEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPositionEffect = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PositionEffectEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPositionEffect = function(value) {
  return jspb.Message.setProto3EnumField(this, 31, value);
};


/**
 * optional sfixed32 settl_date2 = 32;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSettlDate2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSettlDate2 = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional string compliance_id = 33;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getComplianceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setComplianceId = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional fix.Timestamp effective_time = 34;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getEffectiveTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 34));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setEffectiveTime = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearEffectiveTime = function() {
  return this.setEffectiveTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasEffectiveTime = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional string encoded_text = 35;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional sfixed64 encoded_text_len = 36;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional sfixed32 expire_date = 37;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getExpireDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional GTBookingInstEnum gt_booking_inst = 38;
 * @return {!proto.SingleGeneralOrderHandling.GTBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getGtBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setGtBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 38, value);
};


/**
 * optional bool solicited_flag = 39;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSolicitedFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSolicitedFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional fix.Timestamp transact_time = 40;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 40));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional AccountTypeEnum account_type = 41;
 * @return {!proto.SingleGeneralOrderHandling.AccountTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAccountType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AccountTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 41, value);
};


/**
 * optional BookingUnitEnum booking_unit = 42;
 * @return {!proto.SingleGeneralOrderHandling.BookingUnitEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getBookingUnit = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingUnitEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setBookingUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 42, value);
};


/**
 * optional CancellationRightsEnum cancellation_rights = 43;
 * @return {!proto.SingleGeneralOrderHandling.CancellationRightsEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCancellationRights = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCancellationRights = function(value) {
  return jspb.Message.setProto3EnumField(this, 43, value);
};


/**
 * optional CashMarginEnum cash_margin = 44;
 * @return {!proto.SingleGeneralOrderHandling.CashMarginEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCashMargin = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CashMarginEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCashMargin = function(value) {
  return jspb.Message.setProto3EnumField(this, 44, value);
};


/**
 * optional string cl_ord_link_id = 45;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional ClearingFeeIndicatorEnum clearing_fee_indicator = 46;
 * @return {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getClearingFeeIndicator = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setClearingFeeIndicator = function(value) {
  return jspb.Message.setProto3EnumField(this, 46, value);
};


/**
 * optional Common.CommissionData commission_data = 47;
 * @return {?proto.Common.CommissionData}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCommissionData = function() {
  return /** @type{?proto.Common.CommissionData} */ (
    jspb.Message.getWrapperField(this, common_pb.CommissionData, 47));
};


/**
 * @param {?proto.Common.CommissionData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCommissionData = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearCommissionData = function() {
  return this.setCommissionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasCommissionData = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional CustOrderCapacityEnum cust_order_capacity = 48;
 * @return {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCustOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCustOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 48, value);
};


/**
 * optional DayBookingInstEnum day_booking_inst = 49;
 * @return {!proto.SingleGeneralOrderHandling.DayBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getDayBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setDayBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 49, value);
};


/**
 * optional string designation = 50;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getDesignation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setDesignation = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional Common.Instrument instrument = 51;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 51));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 51, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional MoneyLaunderingStatusEnum money_laundering_status = 52;
 * @return {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMoneyLaunderingStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMoneyLaunderingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 52, value);
};


/**
 * optional OrderCapacityEnum order_capacity = 53;
 * @return {!proto.SingleGeneralOrderHandling.OrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 53, value);
};


/**
 * optional Common.OrderQtyData order_qty_data = 54;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 54));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * repeated OrderRestrictionsEnum order_restrictions = 55;
 * @return {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrderRestrictionsList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (jspb.Message.getRepeatedField(this, 55));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrderRestrictionsList = function(value) {
  return jspb.Message.setField(this, 55, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addOrderRestrictions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 55, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearOrderRestrictionsList = function() {
  return this.setOrderRestrictionsList([]);
};


/**
 * repeated Common.Parties parties = 56;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 56));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 56, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 56, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional PreallocMethodEnum prealloc_method = 57;
 * @return {!proto.SingleGeneralOrderHandling.PreallocMethodEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPreallocMethod = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 57, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPreallocMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 57, value);
};


/**
 * optional fix.Decimal64 price2 = 58;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPrice2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 58));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPrice2 = function(value) {
  return jspb.Message.setWrapperField(this, 58, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPrice2 = function() {
  return this.setPrice2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasPrice2 = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional PriceTypeEnum price_type = 59;
 * @return {!proto.SingleGeneralOrderHandling.PriceTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 59, value);
};


/**
 * optional string regist_id = 60;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getRegistId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setRegistId = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional string secondary_cl_ord_id = 61;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 62;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 62));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 62, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 62) != null;
};


/**
 * repeated Common.Stipulations stipulations = 63;
 * @return {!Array<!proto.Common.Stipulations>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getStipulationsList = function() {
  return /** @type{!Array<!proto.Common.Stipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Stipulations, 63));
};


/**
 * @param {!Array<!proto.Common.Stipulations>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 63, value);
};


/**
 * @param {!proto.Common.Stipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Stipulations}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 63, opt_value, proto.Common.Stipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearStipulationsList = function() {
  return this.setStipulationsList([]);
};


/**
 * optional sfixed32 trade_origination_date = 64;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTradeOriginationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTradeOriginationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 64, value);
};


/**
 * optional Common.YieldData yield_data = 65;
 * @return {?proto.Common.YieldData}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 65));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional AcctIDSourceEnum acct_id_source = 66;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 67;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 67, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 67, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 67, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 67) != null;
};


/**
 * optional string alloc_id = 68;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 68, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 68, value);
};


/**
 * optional BookingTypeEnum booking_type = 69;
 * @return {!proto.SingleGeneralOrderHandling.BookingTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getBookingType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 69, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setBookingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 69, value);
};


/**
 * optional bool cust_directed_order = 70;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCustDirectedOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 70, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCustDirectedOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 70, value);
};


/**
 * repeated CustOrderHandlingInstEnum cust_order_handling_inst = 71;
 * @return {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getCustOrderHandlingInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (jspb.Message.getRepeatedField(this, 71));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setCustOrderHandlingInstList = function(value) {
  return jspb.Message.setField(this, 71, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addCustOrderHandlingInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 71, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearCustOrderHandlingInstList = function() {
  return this.setCustOrderHandlingInstList([]);
};


/**
 * optional Common.DiscretionInstructions discretion_instructions = 72;
 * @return {?proto.Common.DiscretionInstructions}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getDiscretionInstructions = function() {
  return /** @type{?proto.Common.DiscretionInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.DiscretionInstructions, 72));
};


/**
 * @param {?proto.Common.DiscretionInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setDiscretionInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 72, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearDiscretionInstructions = function() {
  return this.setDiscretionInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasDiscretionInstructions = function() {
  return jspb.Message.getField(this, 72) != null;
};


/**
 * optional Common.DisplayInstruction display_instruction = 73;
 * @return {?proto.Common.DisplayInstruction}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getDisplayInstruction = function() {
  return /** @type{?proto.Common.DisplayInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.DisplayInstruction, 73));
};


/**
 * @param {?proto.Common.DisplayInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setDisplayInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 73, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearDisplayInstruction = function() {
  return this.setDisplayInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasDisplayInstruction = function() {
  return jspb.Message.getField(this, 73) != null;
};


/**
 * optional ExDestinationIDSourceEnum ex_destination_id_source = 74;
 * @return {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getExDestinationIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 74, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setExDestinationIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 74, value);
};


/**
 * optional Common.FinancingDetails financing_details = 75;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 75));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 75, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 75) != null;
};


/**
 * optional bool manual_order_indicator = 76;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getManualOrderIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 76, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setManualOrderIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 76, value);
};


/**
 * optional fix.Decimal64 match_increment = 77;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMatchIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 77));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMatchIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 77, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearMatchIncrement = function() {
  return this.setMatchIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasMatchIncrement = function() {
  return jspb.Message.getField(this, 77) != null;
};


/**
 * optional sfixed64 max_price_levels = 78;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getMaxPriceLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 78, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setMaxPriceLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 78, value);
};


/**
 * optional OrderHandlingInstSourceEnum order_handling_inst_source = 79;
 * @return {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getOrderHandlingInstSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 79, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setOrderHandlingInstSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 79, value);
};


/**
 * optional fix.Decimal64 participation_rate = 80;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getParticipationRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 80));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setParticipationRate = function(value) {
  return jspb.Message.setWrapperField(this, 80, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearParticipationRate = function() {
  return this.setParticipationRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasParticipationRate = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * optional Common.PegInstructions peg_instructions = 81;
 * @return {?proto.Common.PegInstructions}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPegInstructions = function() {
  return /** @type{?proto.Common.PegInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.PegInstructions, 81));
};


/**
 * @param {?proto.Common.PegInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPegInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 81, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPegInstructions = function() {
  return this.setPegInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasPegInstructions = function() {
  return jspb.Message.getField(this, 81) != null;
};


/**
 * repeated Common.PreAllocGrp pre_alloc_grp = 82;
 * @return {!Array<!proto.Common.PreAllocGrp>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPreAllocGrpList = function() {
  return /** @type{!Array<!proto.Common.PreAllocGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.PreAllocGrp, 82));
};


/**
 * @param {!Array<!proto.Common.PreAllocGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPreAllocGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 82, value);
};


/**
 * @param {!proto.Common.PreAllocGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.PreAllocGrp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addPreAllocGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 82, opt_value, proto.Common.PreAllocGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearPreAllocGrpList = function() {
  return this.setPreAllocGrpList([]);
};


/**
 * optional bool pre_trade_anonymity = 83;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPreTradeAnonymity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 83, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPreTradeAnonymity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 83, value);
};


/**
 * optional PriceProtectionScopeEnum price_protection_scope = 84;
 * @return {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getPriceProtectionScope = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 84, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setPriceProtectionScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 84, value);
};


/**
 * optional QtyTypeEnum qty_type = 85;
 * @return {!proto.SingleGeneralOrderHandling.QtyTypeEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getQtyType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 85, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.QtyTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setQtyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 85, value);
};


/**
 * optional string received_dept_id = 86;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getReceivedDeptId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 86, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setReceivedDeptId = function(value) {
  return jspb.Message.setProto3StringField(this, 86, value);
};


/**
 * optional string ref_order_id = 87;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getRefOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 87, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setRefOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 87, value);
};


/**
 * optional RefOrderIDSourceEnum ref_order_id_source = 88;
 * @return {!proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getRefOrderIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 88, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setRefOrderIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 88, value);
};


/**
 * repeated Common.StrategyParametersGrp strategy_parameters_grp = 89;
 * @return {!Array<!proto.Common.StrategyParametersGrp>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getStrategyParametersGrpList = function() {
  return /** @type{!Array<!proto.Common.StrategyParametersGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.StrategyParametersGrp, 89));
};


/**
 * @param {!Array<!proto.Common.StrategyParametersGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setStrategyParametersGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 89, value);
};


/**
 * @param {!proto.Common.StrategyParametersGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrategyParametersGrp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addStrategyParametersGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 89, opt_value, proto.Common.StrategyParametersGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearStrategyParametersGrpList = function() {
  return this.setStrategyParametersGrpList([]);
};


/**
 * optional TargetStrategyEnum target_strategy = 90;
 * @return {!proto.SingleGeneralOrderHandling.TargetStrategyEnum}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTargetStrategy = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getFieldWithDefault(this, 90, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTargetStrategy = function(value) {
  return jspb.Message.setOneofField(this, 90, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTargetStrategy = function() {
  return jspb.Message.setOneofField(this, 90, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasTargetStrategy = function() {
  return jspb.Message.getField(this, 90) != null;
};


/**
 * optional fixed32 target_strategy_reserved1000plus = 92;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTargetStrategyReserved1000plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 92, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTargetStrategyReserved1000plus = function(value) {
  return jspb.Message.setOneofField(this, 92, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTargetStrategyReserved1000plus = function() {
  return jspb.Message.setOneofField(this, 92, proto.SingleGeneralOrderHandling.NewOrderSingle.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasTargetStrategyReserved1000plus = function() {
  return jspb.Message.getField(this, 92) != null;
};


/**
 * optional string target_strategy_parameters = 91;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTargetStrategyParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 91, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTargetStrategyParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 91, value);
};


/**
 * optional sfixed32 trade_date = 93;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTradeDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 93, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3IntField(this, 93, value);
};


/**
 * repeated Common.TrdRegTimestamps trd_reg_timestamps = 94;
 * @return {!Array<!proto.Common.TrdRegTimestamps>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTrdRegTimestampsList = function() {
  return /** @type{!Array<!proto.Common.TrdRegTimestamps>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.TrdRegTimestamps, 94));
};


/**
 * @param {!Array<!proto.Common.TrdRegTimestamps>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTrdRegTimestampsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 94, value);
};


/**
 * @param {!proto.Common.TrdRegTimestamps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdRegTimestamps}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addTrdRegTimestamps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 94, opt_value, proto.Common.TrdRegTimestamps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTrdRegTimestampsList = function() {
  return this.setTrdRegTimestampsList([]);
};


/**
 * repeated Common.TrdgSesGrp trdg_ses_grp = 95;
 * @return {!Array<!proto.Common.TrdgSesGrp>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTrdgSesGrpList = function() {
  return /** @type{!Array<!proto.Common.TrdgSesGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.TrdgSesGrp, 95));
};


/**
 * @param {!Array<!proto.Common.TrdgSesGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTrdgSesGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 95, value);
};


/**
 * @param {!proto.Common.TrdgSesGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdgSesGrp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addTrdgSesGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 95, opt_value, proto.Common.TrdgSesGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTrdgSesGrpList = function() {
  return this.setTrdgSesGrpList([]);
};


/**
 * optional Common.TriggeringInstruction triggering_instruction = 96;
 * @return {?proto.Common.TriggeringInstruction}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getTriggeringInstruction = function() {
  return /** @type{?proto.Common.TriggeringInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.TriggeringInstruction, 96));
};


/**
 * @param {?proto.Common.TriggeringInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setTriggeringInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 96, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearTriggeringInstruction = function() {
  return this.setTriggeringInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.hasTriggeringInstruction = function() {
  return jspb.Message.getField(this, 96) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 97;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 97));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
*/
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 97, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 97, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.NewOrderSingle} returns this
 */
proto.SingleGeneralOrderHandling.NewOrderSingle.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.repeatedFields_ = [19,24];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_ = [[21,22]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 21,
  ACCT_ID_SOURCE_RESERVED100PLUS: 22
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelRequest.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelRequest.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.OrderCancelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    clOrdId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    listId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    origClOrdId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    side: jspb.Message.getFieldWithDefault(msg, 5, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 8, ""),
    account: jspb.Message.getFieldWithDefault(msg, 9, ""),
    complianceId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 11, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 12, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    accountType: jspb.Message.getFieldWithDefault(msg, 14, 0),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    origOrdModTime: (f = msg.getOrigOrdModTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 20, ""),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 21, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 22, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.OrderCancelRequest;
  return proto.SingleGeneralOrderHandling.OrderCancelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setListId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigClOrdId(value);
      break;
    case 5:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 6:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 7:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 13:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 14:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 16:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 17:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 18:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrigOrdModTime(value);
      break;
    case 19:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 21:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 23:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 24:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.OrderCancelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getListId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrigClOrdId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getComplianceId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      12,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getOrigOrdModTime();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeFixed32(
      22,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string cl_ord_id = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string list_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setListId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_id = 3;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string orig_cl_ord_id = 4;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getOrigClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setOrigClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SideEnum side = 5;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional Session.StandardHeader standard_header = 6;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 6));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 7;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 7));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string text = 8;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string account = 9;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string compliance_id = 10;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getComplianceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setComplianceId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string encoded_text = 11;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional sfixed64 encoded_text_len = 12;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional fix.Timestamp transact_time = 13;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 13));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional AccountTypeEnum account_type = 14;
 * @return {!proto.SingleGeneralOrderHandling.AccountTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getAccountType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AccountTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string cl_ord_link_id = 15;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional Common.Instrument instrument = 16;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 16));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Common.OrderQtyData order_qty_data = 17;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 17));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional fix.Timestamp orig_ord_mod_time = 18;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getOrigOrdModTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 18));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setOrigOrdModTime = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearOrigOrdModTime = function() {
  return this.setOrigOrdModTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasOrigOrdModTime = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated Common.Parties parties = 19;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 19));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional string secondary_cl_ord_id = 20;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional AcctIDSourceEnum acct_id_source = 21;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 21, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 21, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 22;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 22, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 22, proto.SingleGeneralOrderHandling.OrderCancelRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional Common.FinancingDetails financing_details = 23;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 23));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 24;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 24));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.repeatedFields_ = [4,54,56,70,81,86,91,92,94];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_ = [[12,13],[65,66],[87,89]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.SettlTypeUnionCase = {
  SETTL_TYPE_UNION_NOT_SET: 0,
  SETTL_TYPE: 12,
  SETTL_TYPE_TENOR: 13
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.SettlTypeUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlTypeUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.SettlTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 65,
  ACCT_ID_SOURCE_RESERVED100PLUS: 66
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.TargetStrategyUnionCase = {
  TARGET_STRATEGY_UNION_NOT_SET: 0,
  TARGET_STRATEGY: 87,
  TARGET_STRATEGY_RESERVED1000PLUS: 89
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.TargetStrategyUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTargetStrategyUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.TargetStrategyUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[2]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clOrdId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
    execInstList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    handlInst: jspb.Message.getFieldWithDefault(msg, 5, 0),
    listId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    ordType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    orderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    origClOrdId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    settlDate: jspb.Message.getFieldWithDefault(msg, 11, 0),
    settlType: jspb.Message.getFieldWithDefault(msg, 12, 0),
    settlTypeTenor: (f = msg.getSettlTypeTenor()) && fix_pb.Tenor.toObject(includeInstance, f),
    side: jspb.Message.getFieldWithDefault(msg, 14, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    stopPx: (f = msg.getStopPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 18, ""),
    timeInForce: jspb.Message.getFieldWithDefault(msg, 19, 0),
    exDestination: jspb.Message.getFieldWithDefault(msg, 20, ""),
    maxFloor: (f = msg.getMaxFloor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    minQty: (f = msg.getMinQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    expireTime: (f = msg.getExpireTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    forexReq: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    settlCurrency: jspb.Message.getFieldWithDefault(msg, 25, ""),
    coveredOrUncovered: jspb.Message.getFieldWithDefault(msg, 26, 0),
    locateReqd: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    maxShow: (f = msg.getMaxShow()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty2: (f = msg.getOrderQty2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    positionEffect: jspb.Message.getFieldWithDefault(msg, 30, 0),
    settlDate2: jspb.Message.getFieldWithDefault(msg, 31, 0),
    complianceId: jspb.Message.getFieldWithDefault(msg, 32, ""),
    effectiveTime: (f = msg.getEffectiveTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    encodedText: jspb.Message.getFieldWithDefault(msg, 34, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 35, 0),
    expireDate: jspb.Message.getFieldWithDefault(msg, 36, 0),
    gtBookingInst: jspb.Message.getFieldWithDefault(msg, 37, 0),
    solicitedFlag: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    accountType: jspb.Message.getFieldWithDefault(msg, 40, 0),
    bookingUnit: jspb.Message.getFieldWithDefault(msg, 41, 0),
    cancellationRights: jspb.Message.getFieldWithDefault(msg, 42, 0),
    cashMargin: jspb.Message.getFieldWithDefault(msg, 43, 0),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 44, ""),
    clearingFeeIndicator: jspb.Message.getFieldWithDefault(msg, 45, 0),
    commissionData: (f = msg.getCommissionData()) && common_pb.CommissionData.toObject(includeInstance, f),
    custOrderCapacity: jspb.Message.getFieldWithDefault(msg, 47, 0),
    dayBookingInst: jspb.Message.getFieldWithDefault(msg, 48, 0),
    designation: jspb.Message.getFieldWithDefault(msg, 49, ""),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    moneyLaunderingStatus: jspb.Message.getFieldWithDefault(msg, 51, 0),
    orderCapacity: jspb.Message.getFieldWithDefault(msg, 52, 0),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    orderRestrictionsList: (f = jspb.Message.getRepeatedField(msg, 54)) == null ? undefined : f,
    origOrdModTime: (f = msg.getOrigOrdModTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    preallocMethod: jspb.Message.getFieldWithDefault(msg, 57, 0),
    price2: (f = msg.getPrice2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 59, 0),
    registId: jspb.Message.getFieldWithDefault(msg, 60, ""),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 61, ""),
    spreadOrBenchmarkCurveData: (f = msg.getSpreadOrBenchmarkCurveData()) && common_pb.SpreadOrBenchmarkCurveData.toObject(includeInstance, f),
    tradeOriginationDate: jspb.Message.getFieldWithDefault(msg, 63, 0),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 65, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 66, 0),
    allocId: jspb.Message.getFieldWithDefault(msg, 67, ""),
    bookingType: jspb.Message.getFieldWithDefault(msg, 68, 0),
    custDirectedOrder: jspb.Message.getBooleanFieldWithDefault(msg, 69, false),
    custOrderHandlingInstList: (f = jspb.Message.getRepeatedField(msg, 70)) == null ? undefined : f,
    discretionInstructions: (f = msg.getDiscretionInstructions()) && common_pb.DiscretionInstructions.toObject(includeInstance, f),
    displayInstruction: (f = msg.getDisplayInstruction()) && common_pb.DisplayInstruction.toObject(includeInstance, f),
    exDestinationIdSource: jspb.Message.getFieldWithDefault(msg, 73, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    manualOrderIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 75, false),
    matchIncrement: (f = msg.getMatchIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxPriceLevels: jspb.Message.getFieldWithDefault(msg, 77, 0),
    orderHandlingInstSource: jspb.Message.getFieldWithDefault(msg, 78, 0),
    participationRate: (f = msg.getParticipationRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    pegInstructions: (f = msg.getPegInstructions()) && common_pb.PegInstructions.toObject(includeInstance, f),
    preAllocGrpList: jspb.Message.toObjectList(msg.getPreAllocGrpList(),
    common_pb.PreAllocGrp.toObject, includeInstance),
    preTradeAnonymity: jspb.Message.getBooleanFieldWithDefault(msg, 82, false),
    priceProtectionScope: jspb.Message.getFieldWithDefault(msg, 83, 0),
    qtyType: jspb.Message.getFieldWithDefault(msg, 84, 0),
    receivedDeptId: jspb.Message.getFieldWithDefault(msg, 85, ""),
    strategyParametersGrpList: jspb.Message.toObjectList(msg.getStrategyParametersGrpList(),
    common_pb.StrategyParametersGrp.toObject, includeInstance),
    targetStrategy: jspb.Message.getFieldWithDefault(msg, 87, 0),
    targetStrategyReserved1000plus: jspb.Message.getFieldWithDefault(msg, 89, 0),
    targetStrategyParameters: jspb.Message.getFieldWithDefault(msg, 88, ""),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 90, 0),
    trdRegTimestampsList: jspb.Message.toObjectList(msg.getTrdRegTimestampsList(),
    common_pb.TrdRegTimestamps.toObject, includeInstance),
    trdgSesGrpList: jspb.Message.toObjectList(msg.getTrdgSesGrpList(),
    common_pb.TrdgSesGrp.toObject, includeInstance),
    triggeringInstruction: (f = msg.getTriggeringInstruction()) && common_pb.TriggeringInstruction.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest;
  return proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addExecInst(values[i]);
      }
      break;
    case 5:
      var value = /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (reader.readEnum());
      msg.setHandlInst(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setListId(value);
      break;
    case 7:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (reader.readEnum());
      msg.setOrdType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigClOrdId(value);
      break;
    case 10:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate(value);
      break;
    case 12:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (reader.readEnum());
      msg.setSettlType(value);
      break;
    case 13:
      var value = new fix_pb.Tenor;
      reader.readMessage(value,fix_pb.Tenor.deserializeBinaryFromReader);
      msg.setSettlTypeTenor(value);
      break;
    case 14:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 15:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 16:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 17:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStopPx(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 19:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (reader.readEnum());
      msg.setTimeInForce(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setExDestination(value);
      break;
    case 21:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxFloor(value);
      break;
    case 22:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinQty(value);
      break;
    case 23:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpireTime(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForexReq(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlCurrency(value);
      break;
    case 26:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} */ (reader.readEnum());
      msg.setCoveredOrUncovered(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLocateReqd(value);
      break;
    case 28:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxShow(value);
      break;
    case 29:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty2(value);
      break;
    case 30:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (reader.readEnum());
      msg.setPositionEffect(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate2(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplianceId(value);
      break;
    case 33:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveTime(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setExpireDate(value);
      break;
    case 37:
      var value = /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (reader.readEnum());
      msg.setGtBookingInst(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSolicitedFlag(value);
      break;
    case 39:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 40:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 41:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (reader.readEnum());
      msg.setBookingUnit(value);
      break;
    case 42:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (reader.readEnum());
      msg.setCancellationRights(value);
      break;
    case 43:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (reader.readEnum());
      msg.setCashMargin(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 45:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (reader.readEnum());
      msg.setClearingFeeIndicator(value);
      break;
    case 46:
      var value = new common_pb.CommissionData;
      reader.readMessage(value,common_pb.CommissionData.deserializeBinaryFromReader);
      msg.setCommissionData(value);
      break;
    case 47:
      var value = /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (reader.readEnum());
      msg.setCustOrderCapacity(value);
      break;
    case 48:
      var value = /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (reader.readEnum());
      msg.setDayBookingInst(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesignation(value);
      break;
    case 50:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 51:
      var value = /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (reader.readEnum());
      msg.setMoneyLaunderingStatus(value);
      break;
    case 52:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (reader.readEnum());
      msg.setOrderCapacity(value);
      break;
    case 53:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 54:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderRestrictions(values[i]);
      }
      break;
    case 55:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrigOrdModTime(value);
      break;
    case 56:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 57:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (reader.readEnum());
      msg.setPreallocMethod(value);
      break;
    case 58:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice2(value);
      break;
    case 59:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistId(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 62:
      var value = new common_pb.SpreadOrBenchmarkCurveData;
      reader.readMessage(value,common_pb.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setSpreadOrBenchmarkCurveData(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeOriginationDate(value);
      break;
    case 64:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 65:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocId(value);
      break;
    case 68:
      var value = /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (reader.readEnum());
      msg.setBookingType(value);
      break;
    case 69:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustDirectedOrder(value);
      break;
    case 70:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCustOrderHandlingInst(values[i]);
      }
      break;
    case 71:
      var value = new common_pb.DiscretionInstructions;
      reader.readMessage(value,common_pb.DiscretionInstructions.deserializeBinaryFromReader);
      msg.setDiscretionInstructions(value);
      break;
    case 72:
      var value = new common_pb.DisplayInstruction;
      reader.readMessage(value,common_pb.DisplayInstruction.deserializeBinaryFromReader);
      msg.setDisplayInstruction(value);
      break;
    case 73:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} */ (reader.readEnum());
      msg.setExDestinationIdSource(value);
      break;
    case 74:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 75:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManualOrderIndicator(value);
      break;
    case 76:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMatchIncrement(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaxPriceLevels(value);
      break;
    case 78:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (reader.readEnum());
      msg.setOrderHandlingInstSource(value);
      break;
    case 79:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setParticipationRate(value);
      break;
    case 80:
      var value = new common_pb.PegInstructions;
      reader.readMessage(value,common_pb.PegInstructions.deserializeBinaryFromReader);
      msg.setPegInstructions(value);
      break;
    case 81:
      var value = new common_pb.PreAllocGrp;
      reader.readMessage(value,common_pb.PreAllocGrp.deserializeBinaryFromReader);
      msg.addPreAllocGrp(value);
      break;
    case 82:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreTradeAnonymity(value);
      break;
    case 83:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (reader.readEnum());
      msg.setPriceProtectionScope(value);
      break;
    case 84:
      var value = /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (reader.readEnum());
      msg.setQtyType(value);
      break;
    case 85:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivedDeptId(value);
      break;
    case 86:
      var value = new common_pb.StrategyParametersGrp;
      reader.readMessage(value,common_pb.StrategyParametersGrp.deserializeBinaryFromReader);
      msg.addStrategyParametersGrp(value);
      break;
    case 87:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (reader.readEnum());
      msg.setTargetStrategy(value);
      break;
    case 89:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTargetStrategyReserved1000plus(value);
      break;
    case 88:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetStrategyParameters(value);
      break;
    case 90:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setTradeDate(value);
      break;
    case 91:
      var value = new common_pb.TrdRegTimestamps;
      reader.readMessage(value,common_pb.TrdRegTimestamps.deserializeBinaryFromReader);
      msg.addTrdRegTimestamps(value);
      break;
    case 92:
      var value = new common_pb.TrdgSesGrp;
      reader.readMessage(value,common_pb.TrdgSesGrp.deserializeBinaryFromReader);
      msg.addTrdgSesGrp(value);
      break;
    case 93:
      var value = new common_pb.TriggeringInstruction;
      reader.readMessage(value,common_pb.TriggeringInstruction.deserializeBinaryFromReader);
      msg.setTriggeringInstruction(value);
      break;
    case 94:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExecInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
  f = message.getHandlInst();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getListId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrdType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrigClOrdId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSettlDate();
  if (f !== 0) {
    writer.writeSfixed32(
      11,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getSettlTypeTenor();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      fix_pb.Tenor.serializeBinaryToWriter
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getStopPx();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTimeInForce();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getExDestination();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMaxFloor();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMinQty();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getExpireTime();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getForexReq();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getCoveredOrUncovered();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getLocateReqd();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getMaxShow();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty2();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPositionEffect();
  if (f !== 0.0) {
    writer.writeEnum(
      30,
      f
    );
  }
  f = message.getSettlDate2();
  if (f !== 0) {
    writer.writeSfixed32(
      31,
      f
    );
  }
  f = message.getComplianceId();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getEffectiveTime();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      35,
      f
    );
  }
  f = message.getExpireDate();
  if (f !== 0) {
    writer.writeSfixed32(
      36,
      f
    );
  }
  f = message.getGtBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      37,
      f
    );
  }
  f = message.getSolicitedFlag();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      40,
      f
    );
  }
  f = message.getBookingUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      41,
      f
    );
  }
  f = message.getCancellationRights();
  if (f !== 0.0) {
    writer.writeEnum(
      42,
      f
    );
  }
  f = message.getCashMargin();
  if (f !== 0.0) {
    writer.writeEnum(
      43,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getClearingFeeIndicator();
  if (f !== 0.0) {
    writer.writeEnum(
      45,
      f
    );
  }
  f = message.getCommissionData();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      common_pb.CommissionData.serializeBinaryToWriter
    );
  }
  f = message.getCustOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      47,
      f
    );
  }
  f = message.getDayBookingInst();
  if (f !== 0.0) {
    writer.writeEnum(
      48,
      f
    );
  }
  f = message.getDesignation();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getMoneyLaunderingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      51,
      f
    );
  }
  f = message.getOrderCapacity();
  if (f !== 0.0) {
    writer.writeEnum(
      52,
      f
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getOrderRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      54,
      f
    );
  }
  f = message.getOrigOrdModTime();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      56,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getPreallocMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      57,
      f
    );
  }
  f = message.getPrice2();
  if (f != null) {
    writer.writeMessage(
      58,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      59,
      f
    );
  }
  f = message.getRegistId();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getSpreadOrBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      62,
      f,
      common_pb.SpreadOrBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getTradeOriginationDate();
  if (f !== 0) {
    writer.writeSfixed32(
      63,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 65));
  if (f != null) {
    writer.writeEnum(
      65,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeFixed32(
      66,
      f
    );
  }
  f = message.getAllocId();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getBookingType();
  if (f !== 0.0) {
    writer.writeEnum(
      68,
      f
    );
  }
  f = message.getCustDirectedOrder();
  if (f) {
    writer.writeBool(
      69,
      f
    );
  }
  f = message.getCustOrderHandlingInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      70,
      f
    );
  }
  f = message.getDiscretionInstructions();
  if (f != null) {
    writer.writeMessage(
      71,
      f,
      common_pb.DiscretionInstructions.serializeBinaryToWriter
    );
  }
  f = message.getDisplayInstruction();
  if (f != null) {
    writer.writeMessage(
      72,
      f,
      common_pb.DisplayInstruction.serializeBinaryToWriter
    );
  }
  f = message.getExDestinationIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      73,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      74,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getManualOrderIndicator();
  if (f) {
    writer.writeBool(
      75,
      f
    );
  }
  f = message.getMatchIncrement();
  if (f != null) {
    writer.writeMessage(
      76,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxPriceLevels();
  if (f !== 0) {
    writer.writeSfixed64(
      77,
      f
    );
  }
  f = message.getOrderHandlingInstSource();
  if (f !== 0.0) {
    writer.writeEnum(
      78,
      f
    );
  }
  f = message.getParticipationRate();
  if (f != null) {
    writer.writeMessage(
      79,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPegInstructions();
  if (f != null) {
    writer.writeMessage(
      80,
      f,
      common_pb.PegInstructions.serializeBinaryToWriter
    );
  }
  f = message.getPreAllocGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      81,
      f,
      common_pb.PreAllocGrp.serializeBinaryToWriter
    );
  }
  f = message.getPreTradeAnonymity();
  if (f) {
    writer.writeBool(
      82,
      f
    );
  }
  f = message.getPriceProtectionScope();
  if (f !== 0.0) {
    writer.writeEnum(
      83,
      f
    );
  }
  f = message.getQtyType();
  if (f !== 0.0) {
    writer.writeEnum(
      84,
      f
    );
  }
  f = message.getReceivedDeptId();
  if (f.length > 0) {
    writer.writeString(
      85,
      f
    );
  }
  f = message.getStrategyParametersGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      86,
      f,
      common_pb.StrategyParametersGrp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getField(message, 87));
  if (f != null) {
    writer.writeEnum(
      87,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 89));
  if (f != null) {
    writer.writeFixed32(
      89,
      f
    );
  }
  f = message.getTargetStrategyParameters();
  if (f.length > 0) {
    writer.writeString(
      88,
      f
    );
  }
  f = message.getTradeDate();
  if (f !== 0) {
    writer.writeSfixed32(
      90,
      f
    );
  }
  f = message.getTrdRegTimestampsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      91,
      f,
      common_pb.TrdRegTimestamps.serializeBinaryToWriter
    );
  }
  f = message.getTrdgSesGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      92,
      f,
      common_pb.TrdgSesGrp.serializeBinaryToWriter
    );
  }
  f = message.getTriggeringInstruction();
  if (f != null) {
    writer.writeMessage(
      93,
      f,
      common_pb.TriggeringInstruction.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      94,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cl_ord_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ExecInstEnum exec_inst = 4;
 * @return {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getExecInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.ExecInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setExecInstList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addExecInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearExecInstList = function() {
  return this.setExecInstList([]);
};


/**
 * optional HandlInstEnum handl_inst = 5;
 * @return {!proto.SingleGeneralOrderHandling.HandlInstEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getHandlInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.HandlInstEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.HandlInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setHandlInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string list_id = 6;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setListId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional OrdTypeEnum ord_type = 7;
 * @return {!proto.SingleGeneralOrderHandling.OrdTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrdType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string order_id = 8;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string orig_cl_ord_id = 9;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrigClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrigClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional fix.Decimal64 price = 10;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 10));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional sfixed32 settl_date = 11;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSettlDate = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional SettlTypeEnum settl_type = 12;
 * @return {!proto.SingleGeneralOrderHandling.SettlTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SettlTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSettlType = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearSettlType = function() {
  return jspb.Message.setOneofField(this, 12, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasSettlType = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional fix.Tenor settl_type_tenor = 13;
 * @return {?proto.fix.Tenor}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlTypeTenor = function() {
  return /** @type{?proto.fix.Tenor} */ (
    jspb.Message.getWrapperField(this, fix_pb.Tenor, 13));
};


/**
 * @param {?proto.fix.Tenor|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSettlTypeTenor = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearSettlTypeTenor = function() {
  return this.setSettlTypeTenor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasSettlTypeTenor = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional SideEnum side = 14;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional Session.StandardHeader standard_header = 15;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 15));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 16;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 16));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional fix.Decimal64 stop_px = 17;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getStopPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 17));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setStopPx = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearStopPx = function() {
  return this.setStopPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasStopPx = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string text = 18;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional TimeInForceEnum time_in_force = 19;
 * @return {!proto.SingleGeneralOrderHandling.TimeInForceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTimeInForce = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TimeInForceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTimeInForce = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string ex_destination = 20;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getExDestination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setExDestination = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional fix.Decimal64 max_floor = 21;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMaxFloor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 21));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMaxFloor = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearMaxFloor = function() {
  return this.setMaxFloor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasMaxFloor = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional fix.Decimal64 min_qty = 22;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMinQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 22));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMinQty = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearMinQty = function() {
  return this.setMinQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasMinQty = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional fix.Timestamp expire_time = 23;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getExpireTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 23));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setExpireTime = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearExpireTime = function() {
  return this.setExpireTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasExpireTime = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool forex_req = 24;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getForexReq = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setForexReq = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string settl_currency = 25;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional CoveredOrUncoveredEnum covered_or_uncovered = 26;
 * @return {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCoveredOrUncovered = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCoveredOrUncovered = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional bool locate_reqd = 27;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getLocateReqd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setLocateReqd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional fix.Decimal64 max_show = 28;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMaxShow = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 28));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMaxShow = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearMaxShow = function() {
  return this.setMaxShow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasMaxShow = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional fix.Decimal64 order_qty2 = 29;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderQty2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 29));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderQty2 = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearOrderQty2 = function() {
  return this.setOrderQty2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasOrderQty2 = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional PositionEffectEnum position_effect = 30;
 * @return {!proto.SingleGeneralOrderHandling.PositionEffectEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPositionEffect = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PositionEffectEnum} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PositionEffectEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPositionEffect = function(value) {
  return jspb.Message.setProto3EnumField(this, 30, value);
};


/**
 * optional sfixed32 settl_date2 = 31;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSettlDate2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSettlDate2 = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional string compliance_id = 32;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getComplianceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setComplianceId = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional fix.Timestamp effective_time = 33;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getEffectiveTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 33));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setEffectiveTime = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearEffectiveTime = function() {
  return this.setEffectiveTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasEffectiveTime = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional string encoded_text = 34;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional sfixed64 encoded_text_len = 35;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional sfixed32 expire_date = 36;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getExpireDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional GTBookingInstEnum gt_booking_inst = 37;
 * @return {!proto.SingleGeneralOrderHandling.GTBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getGtBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.GTBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setGtBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 37, value);
};


/**
 * optional bool solicited_flag = 38;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSolicitedFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSolicitedFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional fix.Timestamp transact_time = 39;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 39));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional AccountTypeEnum account_type = 40;
 * @return {!proto.SingleGeneralOrderHandling.AccountTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAccountType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AccountTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AccountTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 40, value);
};


/**
 * optional BookingUnitEnum booking_unit = 41;
 * @return {!proto.SingleGeneralOrderHandling.BookingUnitEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getBookingUnit = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingUnitEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setBookingUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 41, value);
};


/**
 * optional CancellationRightsEnum cancellation_rights = 42;
 * @return {!proto.SingleGeneralOrderHandling.CancellationRightsEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCancellationRights = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CancellationRightsEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCancellationRights = function(value) {
  return jspb.Message.setProto3EnumField(this, 42, value);
};


/**
 * optional CashMarginEnum cash_margin = 43;
 * @return {!proto.SingleGeneralOrderHandling.CashMarginEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCashMargin = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CashMarginEnum} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CashMarginEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCashMargin = function(value) {
  return jspb.Message.setProto3EnumField(this, 43, value);
};


/**
 * optional string cl_ord_link_id = 44;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional ClearingFeeIndicatorEnum clearing_fee_indicator = 45;
 * @return {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getClearingFeeIndicator = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setClearingFeeIndicator = function(value) {
  return jspb.Message.setProto3EnumField(this, 45, value);
};


/**
 * optional Common.CommissionData commission_data = 46;
 * @return {?proto.Common.CommissionData}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCommissionData = function() {
  return /** @type{?proto.Common.CommissionData} */ (
    jspb.Message.getWrapperField(this, common_pb.CommissionData, 46));
};


/**
 * @param {?proto.Common.CommissionData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCommissionData = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearCommissionData = function() {
  return this.setCommissionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasCommissionData = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional CustOrderCapacityEnum cust_order_capacity = 47;
 * @return {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCustOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCustOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 47, value);
};


/**
 * optional DayBookingInstEnum day_booking_inst = 48;
 * @return {!proto.SingleGeneralOrderHandling.DayBookingInstEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getDayBookingInst = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.DayBookingInstEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setDayBookingInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 48, value);
};


/**
 * optional string designation = 49;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getDesignation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setDesignation = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional Common.Instrument instrument = 50;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 50));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional MoneyLaunderingStatusEnum money_laundering_status = 51;
 * @return {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMoneyLaunderingStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMoneyLaunderingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 51, value);
};


/**
 * optional OrderCapacityEnum order_capacity = 52;
 * @return {!proto.SingleGeneralOrderHandling.OrderCapacityEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderCapacity = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderCapacityEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderCapacity = function(value) {
  return jspb.Message.setProto3EnumField(this, 52, value);
};


/**
 * optional Common.OrderQtyData order_qty_data = 53;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 53));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 53, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * repeated OrderRestrictionsEnum order_restrictions = 54;
 * @return {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderRestrictionsList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (jspb.Message.getRepeatedField(this, 54));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderRestrictionsList = function(value) {
  return jspb.Message.setField(this, 54, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addOrderRestrictions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 54, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearOrderRestrictionsList = function() {
  return this.setOrderRestrictionsList([]);
};


/**
 * optional fix.Timestamp orig_ord_mod_time = 55;
 * @return {?proto.fix.Timestamp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrigOrdModTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 55));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrigOrdModTime = function(value) {
  return jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearOrigOrdModTime = function() {
  return this.setOrigOrdModTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasOrigOrdModTime = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * repeated Common.Parties parties = 56;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 56));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 56, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 56, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional PreallocMethodEnum prealloc_method = 57;
 * @return {!proto.SingleGeneralOrderHandling.PreallocMethodEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPreallocMethod = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 57, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PreallocMethodEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPreallocMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 57, value);
};


/**
 * optional fix.Decimal64 price2 = 58;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPrice2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 58));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPrice2 = function(value) {
  return jspb.Message.setWrapperField(this, 58, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearPrice2 = function() {
  return this.setPrice2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasPrice2 = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * optional PriceTypeEnum price_type = 59;
 * @return {!proto.SingleGeneralOrderHandling.PriceTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 59, value);
};


/**
 * optional string regist_id = 60;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getRegistId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setRegistId = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional string secondary_cl_ord_id = 61;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional Common.SpreadOrBenchmarkCurveData spread_or_benchmark_curve_data = 62;
 * @return {?proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getSpreadOrBenchmarkCurveData = function() {
  return /** @type{?proto.Common.SpreadOrBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, common_pb.SpreadOrBenchmarkCurveData, 62));
};


/**
 * @param {?proto.Common.SpreadOrBenchmarkCurveData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setSpreadOrBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 62, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearSpreadOrBenchmarkCurveData = function() {
  return this.setSpreadOrBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasSpreadOrBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 62) != null;
};


/**
 * optional sfixed32 trade_origination_date = 63;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTradeOriginationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTradeOriginationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional Common.YieldData yield_data = 64;
 * @return {?proto.Common.YieldData}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 64));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional AcctIDSourceEnum acct_id_source = 65;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 65, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 65, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 66;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 66, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional string alloc_id = 67;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * optional BookingTypeEnum booking_type = 68;
 * @return {!proto.SingleGeneralOrderHandling.BookingTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getBookingType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.BookingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 68, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.BookingTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setBookingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 68, value);
};


/**
 * optional bool cust_directed_order = 69;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCustDirectedOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 69, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCustDirectedOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 69, value);
};


/**
 * repeated CustOrderHandlingInstEnum cust_order_handling_inst = 70;
 * @return {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getCustOrderHandlingInstList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} */ (jspb.Message.getRepeatedField(this, 70));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setCustOrderHandlingInstList = function(value) {
  return jspb.Message.setField(this, 70, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addCustOrderHandlingInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 70, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearCustOrderHandlingInstList = function() {
  return this.setCustOrderHandlingInstList([]);
};


/**
 * optional Common.DiscretionInstructions discretion_instructions = 71;
 * @return {?proto.Common.DiscretionInstructions}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getDiscretionInstructions = function() {
  return /** @type{?proto.Common.DiscretionInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.DiscretionInstructions, 71));
};


/**
 * @param {?proto.Common.DiscretionInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setDiscretionInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 71, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearDiscretionInstructions = function() {
  return this.setDiscretionInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasDiscretionInstructions = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional Common.DisplayInstruction display_instruction = 72;
 * @return {?proto.Common.DisplayInstruction}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getDisplayInstruction = function() {
  return /** @type{?proto.Common.DisplayInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.DisplayInstruction, 72));
};


/**
 * @param {?proto.Common.DisplayInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setDisplayInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 72, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearDisplayInstruction = function() {
  return this.setDisplayInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasDisplayInstruction = function() {
  return jspb.Message.getField(this, 72) != null;
};


/**
 * optional ExDestinationIDSourceEnum ex_destination_id_source = 73;
 * @return {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getExDestinationIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 73, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setExDestinationIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 73, value);
};


/**
 * optional Common.FinancingDetails financing_details = 74;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 74));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 74, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 74) != null;
};


/**
 * optional bool manual_order_indicator = 75;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getManualOrderIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 75, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setManualOrderIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 75, value);
};


/**
 * optional fix.Decimal64 match_increment = 76;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMatchIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 76));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMatchIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 76, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearMatchIncrement = function() {
  return this.setMatchIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasMatchIncrement = function() {
  return jspb.Message.getField(this, 76) != null;
};


/**
 * optional sfixed64 max_price_levels = 77;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getMaxPriceLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 77, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setMaxPriceLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 77, value);
};


/**
 * optional OrderHandlingInstSourceEnum order_handling_inst_source = 78;
 * @return {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getOrderHandlingInstSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 78, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setOrderHandlingInstSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 78, value);
};


/**
 * optional fix.Decimal64 participation_rate = 79;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getParticipationRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 79));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setParticipationRate = function(value) {
  return jspb.Message.setWrapperField(this, 79, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearParticipationRate = function() {
  return this.setParticipationRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasParticipationRate = function() {
  return jspb.Message.getField(this, 79) != null;
};


/**
 * optional Common.PegInstructions peg_instructions = 80;
 * @return {?proto.Common.PegInstructions}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPegInstructions = function() {
  return /** @type{?proto.Common.PegInstructions} */ (
    jspb.Message.getWrapperField(this, common_pb.PegInstructions, 80));
};


/**
 * @param {?proto.Common.PegInstructions|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPegInstructions = function(value) {
  return jspb.Message.setWrapperField(this, 80, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearPegInstructions = function() {
  return this.setPegInstructions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasPegInstructions = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * repeated Common.PreAllocGrp pre_alloc_grp = 81;
 * @return {!Array<!proto.Common.PreAllocGrp>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPreAllocGrpList = function() {
  return /** @type{!Array<!proto.Common.PreAllocGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.PreAllocGrp, 81));
};


/**
 * @param {!Array<!proto.Common.PreAllocGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPreAllocGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 81, value);
};


/**
 * @param {!proto.Common.PreAllocGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.PreAllocGrp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addPreAllocGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 81, opt_value, proto.Common.PreAllocGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearPreAllocGrpList = function() {
  return this.setPreAllocGrpList([]);
};


/**
 * optional bool pre_trade_anonymity = 82;
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPreTradeAnonymity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 82, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPreTradeAnonymity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 82, value);
};


/**
 * optional PriceProtectionScopeEnum price_protection_scope = 83;
 * @return {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getPriceProtectionScope = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 83, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setPriceProtectionScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 83, value);
};


/**
 * optional QtyTypeEnum qty_type = 84;
 * @return {!proto.SingleGeneralOrderHandling.QtyTypeEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getQtyType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.QtyTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 84, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.QtyTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setQtyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 84, value);
};


/**
 * optional string received_dept_id = 85;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getReceivedDeptId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 85, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setReceivedDeptId = function(value) {
  return jspb.Message.setProto3StringField(this, 85, value);
};


/**
 * repeated Common.StrategyParametersGrp strategy_parameters_grp = 86;
 * @return {!Array<!proto.Common.StrategyParametersGrp>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getStrategyParametersGrpList = function() {
  return /** @type{!Array<!proto.Common.StrategyParametersGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.StrategyParametersGrp, 86));
};


/**
 * @param {!Array<!proto.Common.StrategyParametersGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setStrategyParametersGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 86, value);
};


/**
 * @param {!proto.Common.StrategyParametersGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrategyParametersGrp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addStrategyParametersGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 86, opt_value, proto.Common.StrategyParametersGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearStrategyParametersGrpList = function() {
  return this.setStrategyParametersGrpList([]);
};


/**
 * optional TargetStrategyEnum target_strategy = 87;
 * @return {!proto.SingleGeneralOrderHandling.TargetStrategyEnum}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTargetStrategy = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} */ (jspb.Message.getFieldWithDefault(this, 87, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TargetStrategyEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTargetStrategy = function(value) {
  return jspb.Message.setOneofField(this, 87, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTargetStrategy = function() {
  return jspb.Message.setOneofField(this, 87, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasTargetStrategy = function() {
  return jspb.Message.getField(this, 87) != null;
};


/**
 * optional fixed32 target_strategy_reserved1000plus = 89;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTargetStrategyReserved1000plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 89, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTargetStrategyReserved1000plus = function(value) {
  return jspb.Message.setOneofField(this, 89, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTargetStrategyReserved1000plus = function() {
  return jspb.Message.setOneofField(this, 89, proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasTargetStrategyReserved1000plus = function() {
  return jspb.Message.getField(this, 89) != null;
};


/**
 * optional string target_strategy_parameters = 88;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTargetStrategyParameters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 88, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTargetStrategyParameters = function(value) {
  return jspb.Message.setProto3StringField(this, 88, value);
};


/**
 * optional sfixed32 trade_date = 90;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTradeDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 90, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3IntField(this, 90, value);
};


/**
 * repeated Common.TrdRegTimestamps trd_reg_timestamps = 91;
 * @return {!Array<!proto.Common.TrdRegTimestamps>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTrdRegTimestampsList = function() {
  return /** @type{!Array<!proto.Common.TrdRegTimestamps>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.TrdRegTimestamps, 91));
};


/**
 * @param {!Array<!proto.Common.TrdRegTimestamps>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTrdRegTimestampsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 91, value);
};


/**
 * @param {!proto.Common.TrdRegTimestamps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdRegTimestamps}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addTrdRegTimestamps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 91, opt_value, proto.Common.TrdRegTimestamps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTrdRegTimestampsList = function() {
  return this.setTrdRegTimestampsList([]);
};


/**
 * repeated Common.TrdgSesGrp trdg_ses_grp = 92;
 * @return {!Array<!proto.Common.TrdgSesGrp>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTrdgSesGrpList = function() {
  return /** @type{!Array<!proto.Common.TrdgSesGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.TrdgSesGrp, 92));
};


/**
 * @param {!Array<!proto.Common.TrdgSesGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTrdgSesGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 92, value);
};


/**
 * @param {!proto.Common.TrdgSesGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdgSesGrp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addTrdgSesGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 92, opt_value, proto.Common.TrdgSesGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTrdgSesGrpList = function() {
  return this.setTrdgSesGrpList([]);
};


/**
 * optional Common.TriggeringInstruction triggering_instruction = 93;
 * @return {?proto.Common.TriggeringInstruction}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getTriggeringInstruction = function() {
  return /** @type{?proto.Common.TriggeringInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.TriggeringInstruction, 93));
};


/**
 * @param {?proto.Common.TriggeringInstruction|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setTriggeringInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 93, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearTriggeringInstruction = function() {
  return this.setTriggeringInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.hasTriggeringInstruction = function() {
  return jspb.Message.getField(this, 93) != null;
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 94;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 94));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 94, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 94, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderCancelReplaceRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.repeatedFields_ = [9,15];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_ = [[11,12]];

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.AcctIdSourceUnionCase = {
  ACCT_ID_SOURCE_UNION_NOT_SET: 0,
  ACCT_ID_SOURCE: 11,
  ACCT_ID_SOURCE_RESERVED100PLUS: 12
};

/**
 * @return {proto.SingleGeneralOrderHandling.OrderStatusRequest.AcctIdSourceUnionCase}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getAcctIdSourceUnionCase = function() {
  return /** @type {proto.SingleGeneralOrderHandling.OrderStatusRequest.AcctIdSourceUnionCase} */(jspb.Message.computeOneofCase(this, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.OrderStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.OrderStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    clOrdId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    side: jspb.Message.getFieldWithDefault(msg, 3, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    account: jspb.Message.getFieldWithDefault(msg, 6, ""),
    clOrdLinkId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    acctIdSource: jspb.Message.getFieldWithDefault(msg, 11, 0),
    acctIdSourceReserved100plus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    financingDetails: (f = msg.getFinancingDetails()) && common_pb.FinancingDetails.toObject(includeInstance, f),
    ordStatusReqId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.OrderStatusRequest;
  return proto.SingleGeneralOrderHandling.OrderStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.OrderStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 3:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 4:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 5:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdLinkId(value);
      break;
    case 8:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 9:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 11:
      var value = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (reader.readEnum());
      msg.setAcctIdSource(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAcctIdSourceReserved100plus(value);
      break;
    case 13:
      var value = new common_pb.FinancingDetails;
      reader.readMessage(value,common_pb.FinancingDetails.deserializeBinaryFromReader);
      msg.setFinancingDetails(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdStatusReqId(value);
      break;
    case 15:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.OrderStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.OrderStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFixed32(
      12,
      f
    );
  }
  f = message.getFinancingDetails();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.FinancingDetails.serializeBinaryToWriter
    );
  }
  f = message.getOrdStatusReqId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string cl_ord_id = 1;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SideEnum side = 3;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Session.StandardHeader standard_header = 4;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 4));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 5;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 5));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string account = 6;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cl_ord_link_id = 7;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getClOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setClOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Common.Instrument instrument = 8;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 8));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated Common.Parties parties = 9;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 9));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional string secondary_cl_ord_id = 10;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional AcctIDSourceEnum acct_id_source = 11;
 * @return {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getAcctIdSource = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.AcctIDSourceEnum} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setAcctIdSource = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearAcctIdSource = function() {
  return jspb.Message.setOneofField(this, 11, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasAcctIdSource = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fixed32 acct_id_source_reserved100plus = 12;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getAcctIdSourceReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setAcctIdSourceReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearAcctIdSourceReserved100plus = function() {
  return jspb.Message.setOneofField(this, 12, proto.SingleGeneralOrderHandling.OrderStatusRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasAcctIdSourceReserved100plus = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Common.FinancingDetails financing_details = 13;
 * @return {?proto.Common.FinancingDetails}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getFinancingDetails = function() {
  return /** @type{?proto.Common.FinancingDetails} */ (
    jspb.Message.getWrapperField(this, common_pb.FinancingDetails, 13));
};


/**
 * @param {?proto.Common.FinancingDetails|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setFinancingDetails = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearFinancingDetails = function() {
  return this.setFinancingDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.hasFinancingDetails = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string ord_status_req_id = 14;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getOrdStatusReqId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setOrdStatusReqId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 15;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 15));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
*/
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.OrderStatusRequest} returns this
 */
proto.SingleGeneralOrderHandling.OrderStatusRequest.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.repeatedFields_ = [14,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.DontKnowTrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.DontKnowTrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    dkreason: jspb.Message.getFieldWithDefault(msg, 1, 0),
    execId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastPx: (f = msg.getLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastQty: (f = msg.getLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    side: jspb.Message.getFieldWithDefault(msg, 6, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 9, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 10, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 11, 0),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    secondaryOrderId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.DontKnowTrade;
  return proto.SingleGeneralOrderHandling.DontKnowTrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.DontKnowTrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.SingleGeneralOrderHandling.DKReasonEnum} */ (reader.readEnum());
      msg.setDkreason(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecId(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastPx(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastQty(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 6:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 7:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 8:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 12:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 13:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 14:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrderId(value);
      break;
    case 16:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.DontKnowTrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.DontKnowTrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDkreason();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExecId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastPx();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastQty();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      11,
      f
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional DKReasonEnum dkreason = 1;
 * @return {!proto.SingleGeneralOrderHandling.DKReasonEnum}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getDkreason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.DKReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.DKReasonEnum} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setDkreason = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string exec_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fix.Decimal64 last_px = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearLastPx = function() {
  return this.setLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasLastPx = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Decimal64 last_qty = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearLastQty = function() {
  return this.setLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasLastQty = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string order_id = 5;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional SideEnum side = 6;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional Session.StandardHeader standard_header = 7;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 7));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 8;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 8));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string text = 9;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string encoded_text = 10;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional sfixed64 encoded_text_len = 11;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Common.Instrument instrument = 12;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 12));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Common.OrderQtyData order_qty_data = 13;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 13));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 14;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 14));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional string secondary_order_id = 15;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 16;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 16));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
*/
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.DontKnowTrade} returns this
 */
proto.SingleGeneralOrderHandling.DontKnowTrade.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.repeatedFields_ = [9,22];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.toObject = function(opt_includeInstance) {
  return proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.toObject = function(includeInstance, msg) {
  var f, obj = {
    avgPx: (f = msg.getAvgPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    clOrdId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cumQty: (f = msg.getCumQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    dkreason: jspb.Message.getFieldWithDefault(msg, 4, 0),
    encodedText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 6, 0),
    execAckStatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    execId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    common_pb.InstrmtLegGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && common_pb.Instrument.toObject(includeInstance, f),
    lastParPx: (f = msg.getLastParPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastPx: (f = msg.getLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lastQty: (f = msg.getLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    orderQtyData: (f = msg.getOrderQtyData()) && common_pb.OrderQtyData.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 16, 0),
    secondaryOrderId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    side: jspb.Message.getFieldWithDefault(msg, 18, 0),
    standardHeader: (f = msg.getStandardHeader()) && session_pb.StandardHeader.toObject(includeInstance, f),
    standardTrailer: (f = msg.getStandardTrailer()) && session_pb.StandardTrailer.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 21, ""),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    common_pb.UndInstrmtGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SingleGeneralOrderHandling.ExecutionAcknowledgement;
  return proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAvgPx(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCumQty(value);
      break;
    case 4:
      var value = /** @type {!proto.SingleGeneralOrderHandling.DKReasonEnum} */ (reader.readEnum());
      msg.setDkreason(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 7:
      var value = /** @type {!proto.SingleGeneralOrderHandling.ExecAckStatusEnum} */ (reader.readEnum());
      msg.setExecAckStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExecId(value);
      break;
    case 9:
      var value = new common_pb.InstrmtLegGrp;
      reader.readMessage(value,common_pb.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 10:
      var value = new common_pb.Instrument;
      reader.readMessage(value,common_pb.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastParPx(value);
      break;
    case 12:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastPx(value);
      break;
    case 13:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLastQty(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 15:
      var value = new common_pb.OrderQtyData;
      reader.readMessage(value,common_pb.OrderQtyData.deserializeBinaryFromReader);
      msg.setOrderQtyData(value);
      break;
    case 16:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrderId(value);
      break;
    case 18:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 19:
      var value = new session_pb.StandardHeader;
      reader.readMessage(value,session_pb.StandardHeader.deserializeBinaryFromReader);
      msg.setStandardHeader(value);
      break;
    case 20:
      var value = new session_pb.StandardTrailer;
      reader.readMessage(value,session_pb.StandardTrailer.deserializeBinaryFromReader);
      msg.setStandardTrailer(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 22:
      var value = new common_pb.UndInstrmtGrp;
      reader.readMessage(value,common_pb.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvgPx();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCumQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDkreason();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
  f = message.getExecAckStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getExecId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_pb.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getLastParPx();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastPx();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLastQty();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOrderQtyData();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      common_pb.OrderQtyData.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getStandardHeader();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      session_pb.StandardHeader.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrailer();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      session_pb.StandardTrailer.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      common_pb.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 avg_px = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getAvgPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setAvgPx = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearAvgPx = function() {
  return this.setAvgPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasAvgPx = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string cl_ord_id = 2;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fix.Decimal64 cum_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getCumQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setCumQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearCumQty = function() {
  return this.setCumQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasCumQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DKReasonEnum dkreason = 4;
 * @return {!proto.SingleGeneralOrderHandling.DKReasonEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getDkreason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.DKReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.DKReasonEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setDkreason = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string encoded_text = 5;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional sfixed64 encoded_text_len = 6;
 * @return {number}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ExecAckStatusEnum exec_ack_status = 7;
 * @return {!proto.SingleGeneralOrderHandling.ExecAckStatusEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getExecAckStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.ExecAckStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.ExecAckStatusEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setExecAckStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string exec_id = 8;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getExecId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setExecId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated Common.InstrmtLegGrp instrmt_leg_grp = 9;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.InstrmtLegGrp, 9));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Common.Instrument instrument = 10;
 * @return {?proto.Common.Instrument}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, common_pb.Instrument, 10));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional fix.Decimal64 last_par_px = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getLastParPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setLastParPx = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearLastParPx = function() {
  return this.setLastParPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasLastParPx = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fix.Decimal64 last_px = 12;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 12));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearLastPx = function() {
  return this.setLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasLastPx = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional fix.Decimal64 last_qty = 13;
 * @return {?proto.fix.Decimal64}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 13));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearLastQty = function() {
  return this.setLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasLastQty = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string order_id = 14;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Common.OrderQtyData order_qty_data = 15;
 * @return {?proto.Common.OrderQtyData}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getOrderQtyData = function() {
  return /** @type{?proto.Common.OrderQtyData} */ (
    jspb.Message.getWrapperField(this, common_pb.OrderQtyData, 15));
};


/**
 * @param {?proto.Common.OrderQtyData|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setOrderQtyData = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearOrderQtyData = function() {
  return this.setOrderQtyData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasOrderQtyData = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional PriceTypeEnum price_type = 16;
 * @return {!proto.SingleGeneralOrderHandling.PriceTypeEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceTypeEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional string secondary_order_id = 17;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional SideEnum side = 18;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional Session.StandardHeader standard_header = 19;
 * @return {?proto.Session.StandardHeader}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getStandardHeader = function() {
  return /** @type{?proto.Session.StandardHeader} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardHeader, 19));
};


/**
 * @param {?proto.Session.StandardHeader|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setStandardHeader = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearStandardHeader = function() {
  return this.setStandardHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasStandardHeader = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional Session.StandardTrailer standard_trailer = 20;
 * @return {?proto.Session.StandardTrailer}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getStandardTrailer = function() {
  return /** @type{?proto.Session.StandardTrailer} */ (
    jspb.Message.getWrapperField(this, session_pb.StandardTrailer, 20));
};


/**
 * @param {?proto.Session.StandardTrailer|undefined} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setStandardTrailer = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearStandardTrailer = function() {
  return this.setStandardTrailer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.hasStandardTrailer = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string text = 21;
 * @return {string}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * repeated Common.UndInstrmtGrp und_instrmt_grp = 22;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.UndInstrmtGrp, 22));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
*/
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SingleGeneralOrderHandling.ExecutionAcknowledgement} returns this
 */
proto.SingleGeneralOrderHandling.ExecutionAcknowledgement.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.FillLiquidityIndEnum = {
  FILL_LIQUIDITY_IND_UNSPECIFIED: 0,
  FILL_LIQUIDITY_IND_ADDED_LIQUIDITY: 1,
  FILL_LIQUIDITY_IND_LIQUIDITY_ROUTED_OUT: 2,
  FILL_LIQUIDITY_IND_REMOVED_LIQUIDITY: 3,
  FILL_LIQUIDITY_IND_AUCTION: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CrossTypeEnum = {
  CROSS_TYPE_UNSPECIFIED: 0,
  CROSS_TYPE_CROSS_AON: 1,
  CROSS_TYPE_CROSS_IOC: 2,
  CROSS_TYPE_CROSS_ONE_SIDE: 3,
  CROSS_TYPE_CROSS_SAME_PRICE: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecTypeEnum = {
  EXEC_TYPE_UNSPECIFIED: 0,
  EXEC_TYPE_CALCULATED: 1,
  EXEC_TYPE_CANCELED: 2,
  EXEC_TYPE_DONE_FOR_DAY: 3,
  EXEC_TYPE_EXPIRED: 4,
  EXEC_TYPE_NEW: 5,
  EXEC_TYPE_PENDING_CANCEL: 6,
  EXEC_TYPE_PENDING_NEW: 7,
  EXEC_TYPE_REJECTED: 8,
  EXEC_TYPE_REPLACED: 9,
  EXEC_TYPE_STOPPED: 10,
  EXEC_TYPE_SUSPENDED: 11,
  EXEC_TYPE_PENDING_REPLACE: 12,
  EXEC_TYPE_RESTATED: 13,
  EXEC_TYPE_ORDER_STATUS: 14,
  EXEC_TYPE_TRADE: 15,
  EXEC_TYPE_TRADE_CANCEL: 16,
  EXEC_TYPE_TRADE_CORRECT: 17,
  EXEC_TYPE_TRADE_HAS_BEEN_RELEASED_TO_CLEARING: 18,
  EXEC_TYPE_TRADE_IN_ACLEARING_HOLD: 19,
  EXEC_TYPE_TRIGGERED_OR_ACTIVATED_BY_SYSTEM: 20
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrdStatusEnum = {
  ORD_STATUS_UNSPECIFIED: 0,
  ORD_STATUS_CANCELED: 1,
  ORD_STATUS_DONE_FOR_DAY: 2,
  ORD_STATUS_FILLED: 3,
  ORD_STATUS_NEW: 4,
  ORD_STATUS_PARTIALLY_FILLED: 5,
  ORD_STATUS_PENDING_CANCEL: 6,
  ORD_STATUS_REJECTED: 7,
  ORD_STATUS_STOPPED: 8,
  ORD_STATUS_PENDING_NEW: 9,
  ORD_STATUS_SUSPENDED: 10,
  ORD_STATUS_CALCULATED: 11,
  ORD_STATUS_EXPIRED: 12,
  ORD_STATUS_ACCEPTED_FOR_BIDDING: 13,
  ORD_STATUS_PENDING_REPLACE: 14,
  ORD_STATUS_REPLACED: 15
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrdRejReasonEnum = {
  ORD_REJ_REASON_UNSPECIFIED: 0,
  ORD_REJ_REASON_BROKER_CREDIT: 1,
  ORD_REJ_REASON_EXCHANGE_CLOSED: 2,
  ORD_REJ_REASON_ORDER_EXCEEDS_LIMIT: 3,
  ORD_REJ_REASON_UNKNOWN_SYMBOL: 4,
  ORD_REJ_REASON_TOO_LATE_TO_ENTER: 5,
  ORD_REJ_REASON_DUPLICATE_ORDER: 6,
  ORD_REJ_REASON_UNKNOWN_ORDER: 7,
  ORD_REJ_REASON_DUPLICATE_OF_AVERBALLY_COMMUNICATED_ORDER: 8,
  ORD_REJ_REASON_STALE_ORDER: 9,
  ORD_REJ_REASON_INVALID_INVESTOR_ID: 10,
  ORD_REJ_REASON_SURVEILLENCE_OPTION: 11,
  ORD_REJ_REASON_TRADE_ALONG_REQUIRED: 12,
  ORD_REJ_REASON_UNSUPPORTED_ORDER_CHARACTERISTIC: 13,
  ORD_REJ_REASON_INCORRECT_ALLOCATED_QUANTITY: 14,
  ORD_REJ_REASON_INCORRECT_QUANTITY: 15,
  ORD_REJ_REASON_OTHER: 16,
  ORD_REJ_REASON_UNKNOWN_ACCOUNT: 17,
  ORD_REJ_REASON_INVALID_PRICE_INCREMENT: 18,
  ORD_REJ_REASON_PRICE_EXCEEDS_CURRENT_PRICE_BAND: 19
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecRestatementReasonEnum = {
  EXEC_RESTATEMENT_REASON_UNSPECIFIED: 0,
  EXEC_RESTATEMENT_REASON_BROKER_OPTION: 1,
  EXEC_RESTATEMENT_REASON_GT_CORPORATE_ACTION: 2,
  EXEC_RESTATEMENT_REASON_GT_RENEWAL: 3,
  EXEC_RESTATEMENT_REASON_PARTIAL_DECLINE_OF_ORDER_QTY: 4,
  EXEC_RESTATEMENT_REASON_REPRICING_OF_ORDER: 5,
  EXEC_RESTATEMENT_REASON_VERBAL_CHANGE: 6,
  EXEC_RESTATEMENT_REASON_CANCEL_ON_SYSTEM_FAILURE: 7,
  EXEC_RESTATEMENT_REASON_CANCEL_ON_TRADING_HALT: 8,
  EXEC_RESTATEMENT_REASON_MARKET: 9,
  EXEC_RESTATEMENT_REASON_CANCELED: 10,
  EXEC_RESTATEMENT_REASON_OTHER: 11,
  EXEC_RESTATEMENT_REASON_WAREHOUSE_RECAP: 12,
  EXEC_RESTATEMENT_REASON_PEG_REFRESH: 13
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.AcctIDSourceEnum = {
  ACCT_ID_SOURCE_UNSPECIFIED: 0,
  ACCT_ID_SOURCE_BIC: 1,
  ACCT_ID_SOURCE_DTCCCODE: 2,
  ACCT_ID_SOURCE_OMGEO: 3,
  ACCT_ID_SOURCE_OTHER: 4,
  ACCT_ID_SOURCE_SID_CODE: 5,
  ACCT_ID_SOURCE_TFM: 6
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.AccountTypeEnum = {
  ACCOUNT_TYPE_UNSPECIFIED: 0,
  ACCOUNT_TYPE_CARRIED_CUSTOMER_SIDE: 1,
  ACCOUNT_TYPE_CARRIED_NON_CUSTOMER_SIDE: 2,
  ACCOUNT_TYPE_CARRIED_NON_CUSTOMER_SIDE_CROSS_MARGINED: 3,
  ACCOUNT_TYPE_FLOOR_TRADER: 4,
  ACCOUNT_TYPE_HOUSE_TRADER: 5,
  ACCOUNT_TYPE_HOUSE_TRADER_CROSS_MARGINED: 6,
  ACCOUNT_TYPE_JOINT_BACK_OFFICE_ACCOUNT: 7
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.DayBookingInstEnum = {
  DAY_BOOKING_INST_UNSPECIFIED: 0,
  DAY_BOOKING_INST_AUTO: 1,
  DAY_BOOKING_INST_SPEAK_WITH_ORDER_INITIATOR_BEFORE_BOOKING: 2,
  DAY_BOOKING_INST_ACCUMULATE: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.BookingUnitEnum = {
  BOOKING_UNIT_UNSPECIFIED: 0,
  BOOKING_UNIT_AGGREGATE_EXECUTIONS_FOR_THIS_SYMBOL: 1,
  BOOKING_UNIT_AGGREGATE_PARTIAL_EXECUTIONS_ON_THIS_ORDER: 2,
  BOOKING_UNIT_EACH_PARTIAL_EXECUTION_IS_ABOOKABLE_UNIT: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.PreallocMethodEnum = {
  PREALLOC_METHOD_UNSPECIFIED: 0,
  PREALLOC_METHOD_DO_NOT_PRO_RATA: 1,
  PREALLOC_METHOD_PRO_RATA: 2
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.SettlTypeEnum = {
  SETTL_TYPE_UNSPECIFIED: 0,
  SETTL_TYPE_CASH: 1,
  SETTL_TYPE_FUTURE: 2,
  SETTL_TYPE_NEXT_DAY: 3,
  SETTL_TYPE_REGULAR: 4,
  SETTL_TYPE_SELLERS_OPTION: 5,
  SETTL_TYPE_TPLUS2: 6,
  SETTL_TYPE_TPLUS3: 7,
  SETTL_TYPE_TPLUS4: 8,
  SETTL_TYPE_WHEN_AND_IF_ISSUED: 9,
  SETTL_TYPE_TPLUS5: 10,
  SETTL_TYPE_FX_SPOT_NEXT_SETTLEMENT: 11,
  SETTL_TYPE_BROKEN_DATE: 12
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.MatchTypeEnum = {
  MATCH_TYPE_UNSPECIFIED: 0,
  MATCH_TYPE_A1EXACT_MATCH_SUMMARIZED_QUANTITY: 1,
  MATCH_TYPE_A2EXACT_MATCH_SUMMARIZED_QUANTITY: 2,
  MATCH_TYPE_A3EXACT_MATCH_SUMMARIZED_QUANTITY: 3,
  MATCH_TYPE_A4EXACT_MATCH_SUMMARIZED_QUANTITY: 4,
  MATCH_TYPE_A5EXACT_MATCH_SUMMARIZED_QUANTITY: 5,
  MATCH_TYPE_ACTACCEPTED_TRADE: 6,
  MATCH_TYPE_ACTDEFAULT_AFTER_M2: 7,
  MATCH_TYPE_ACTDEFAULT_TRADE: 8,
  MATCH_TYPE_ACTM6MATCH: 9,
  MATCH_TYPE_EXACT_MATCH_MINUS_BADGES_TIMES: 10,
  MATCH_TYPE_EXACT_MATCH_PLUS2BADGES: 11,
  MATCH_TYPE_EXACT_MATCH_PLUS2BADGES_EXEC_TIME: 12,
  MATCH_TYPE_EXACT_MATCH_PLUS4BADGES: 13,
  MATCH_TYPE_EXACT_MATCH_PLUS4BADGES_EXEC_TIME: 14,
  MATCH_TYPE_EXACT_MATCH_PLUS_EXEC_TIME: 15,
  MATCH_TYPE_OCSLOCKED_IN: 16,
  MATCH_TYPE_STAMPED_ADVISORIES_OR_SPECIALIST_ACCEPTS: 17,
  MATCH_TYPE_SUMMARIZED_MATCH_MINUS_BADGES_TIMES: 18,
  MATCH_TYPE_AUTO_MATCH: 19,
  MATCH_TYPE_CALL_AUCTION: 20,
  MATCH_TYPE_CONFIRMED_TRADE_REPORT: 21,
  MATCH_TYPE_COUNTER_ORDER_SELECTION: 22,
  MATCH_TYPE_CROSS_AUCTION: 23,
  MATCH_TYPE_ONE_PARTY_TRADE_REPORT: 24,
  MATCH_TYPE_TWO_PARTY_TRADE_REPORT: 25,
  MATCH_TYPE_ISSUING: 26
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCategoryEnum = {
  ORDER_CATEGORY_UNSPECIFIED: 0,
  ORDER_CATEGORY_CROSS_ORDER: 1,
  ORDER_CATEGORY_IMPLIED_ORDER: 2,
  ORDER_CATEGORY_LINKED_ORDER: 3,
  ORDER_CATEGORY_MULTILEG_ORDER: 4,
  ORDER_CATEGORY_ORDER: 5,
  ORDER_CATEGORY_PRIVATELY_NEGOTIATED_TRADE: 6,
  ORDER_CATEGORY_QUOTE: 7,
  ORDER_CATEGORY_QUOTE_REQUEST: 8,
  ORDER_CATEGORY_STREAMING_PRICE: 9
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CashMarginEnum = {
  CASH_MARGIN_UNSPECIFIED: 0,
  CASH_MARGIN_CASH: 1,
  CASH_MARGIN_MARGIN_CLOSE: 2,
  CASH_MARGIN_MARGIN_OPEN: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ClearingFeeIndicatorEnum = {
  CLEARING_FEE_INDICATOR_UNSPECIFIED: 0,
  CLEARING_FEE_INDICATOR_ALL_OTHER_OWNERSHIP_TYPES: 1,
  CLEARING_FEE_INDICATOR_CBOEMEMBER: 2,
  CLEARING_FEE_INDICATOR_EQUITY_MEMBER_AND_CLEARING_MEMBER: 3,
  CLEARING_FEE_INDICATOR_FIFTH_YEAR_DELEGATE: 4,
  CLEARING_FEE_INDICATOR_FIRMS106HAND106J: 5,
  CLEARING_FEE_INDICATOR_FIRST_YEAR_DELEGATE: 6,
  CLEARING_FEE_INDICATOR_FOURTH_YEAR_DELEGATE: 7,
  CLEARING_FEE_INDICATOR_FULL_AND_ASSOCIATE_MEMBER: 8,
  CLEARING_FEE_INDICATOR_GIM: 9,
  CLEARING_FEE_INDICATOR_LESSEE106FEMPLOYEES: 10,
  CLEARING_FEE_INDICATOR_NON_MEMBER_AND_CUSTOMER: 11,
  CLEARING_FEE_INDICATOR_SECOND_YEAR_DELEGATE: 12,
  CLEARING_FEE_INDICATOR_SIXTH_YEAR_DELEGATE: 13,
  CLEARING_FEE_INDICATOR_THIRD_YEAR_DELEGATE: 14
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.SideEnum = {
  SIDE_UNSPECIFIED: 0,
  SIDE_BUY: 1,
  SIDE_BUY_MINUS: 2,
  SIDE_SELL: 3,
  SIDE_SELL_PLUS: 4,
  SIDE_SELL_SHORT: 5,
  SIDE_SELL_SHORT_EXEMPT: 6,
  SIDE_CROSS: 7,
  SIDE_UNDISCLOSED: 8,
  SIDE_CROSS_SHORT: 9,
  SIDE_AS_DEFINED: 10,
  SIDE_CROSS_SHORT_EXEMPT: 11,
  SIDE_OPPOSITE: 12,
  SIDE_BORROW: 13,
  SIDE_LEND: 14,
  SIDE_REDEEM: 15,
  SIDE_SUBSCRIBE: 16
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.QtyTypeEnum = {
  QTY_TYPE_UNSPECIFIED: 0,
  QTY_TYPE_CONTRACTS: 1,
  QTY_TYPE_UNITS: 2,
  QTY_TYPE_UNITS_OF_MEASURE_PER_TIME_UNIT: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.LotTypeEnum = {
  LOT_TYPE_UNSPECIFIED: 0,
  LOT_TYPE_BLOCK_LOT: 1,
  LOT_TYPE_ODD_LOT: 2,
  LOT_TYPE_ROUND_LOT: 3,
  LOT_TYPE_ROUND_LOT_BASED_UPON: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrdTypeEnum = {
  ORD_TYPE_UNSPECIFIED: 0,
  ORD_TYPE_LIMIT: 1,
  ORD_TYPE_LIMIT_ON_CLOSE: 2,
  ORD_TYPE_LIMIT_OR_BETTER: 3,
  ORD_TYPE_LIMIT_WITH_OR_WITHOUT: 4,
  ORD_TYPE_MARKET: 5,
  ORD_TYPE_MARKET_ON_CLOSE: 6,
  ORD_TYPE_ON_BASIS: 7,
  ORD_TYPE_ON_CLOSE: 8,
  ORD_TYPE_STOP: 9,
  ORD_TYPE_STOP_LIMIT: 10,
  ORD_TYPE_WITH_OR_WITHOUT: 11,
  ORD_TYPE_PEGGED: 12,
  ORD_TYPE_FOREX_MARKET: 13,
  ORD_TYPE_PREVIOUSLY_INDICATED: 14,
  ORD_TYPE_PREVIOUSLY_QUOTED: 15,
  ORD_TYPE_FOREX_LIMIT: 16,
  ORD_TYPE_FOREX_PREVIOUSLY_QUOTED: 17,
  ORD_TYPE_FOREX_SWAP: 18,
  ORD_TYPE_FUNARI: 19,
  ORD_TYPE_MARKET_IF_TOUCHED: 20,
  ORD_TYPE_MARKET_WITH_LEFT_OVER_AS_LIMIT: 21,
  ORD_TYPE_NEXT_FUND_VALUATION_POINT: 22,
  ORD_TYPE_PREVIOUS_FUND_VALUATION_POINT: 23,
  ORD_TYPE_COUNTER_ORDER_SELECTION: 24
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.PriceTypeEnum = {
  PRICE_TYPE_UNSPECIFIED: 0,
  PRICE_TYPE_FIXED_AMOUNT: 1,
  PRICE_TYPE_PERCENTAGE: 2,
  PRICE_TYPE_PER_UNIT: 3,
  PRICE_TYPE_DISCOUNT: 4,
  PRICE_TYPE_PREMIUM: 5,
  PRICE_TYPE_SPREAD: 6,
  PRICE_TYPE_TEDPRICE: 7,
  PRICE_TYPE_TEDYIELD: 8,
  PRICE_TYPE_FIXED_CABINET_TRADE_PRICE: 9,
  PRICE_TYPE_VARIABLE_CABINET_TRADE_PRICE: 10,
  PRICE_TYPE_YIELD: 11,
  PRICE_TYPE_PRODUCT_TICKS_IN_EIGHTS: 12,
  PRICE_TYPE_PRODUCT_TICKS_IN_FOURTHS: 13,
  PRICE_TYPE_PRODUCT_TICKS_IN_HALFS: 14,
  PRICE_TYPE_PRODUCT_TICKS_IN_ONE_TWENTY_EIGHTS: 15,
  PRICE_TYPE_PRODUCT_TICKS_IN_SIXTEENTHS: 16,
  PRICE_TYPE_PRODUCT_TICKS_IN_SIXTY_FORTHS: 17,
  PRICE_TYPE_PRODUCT_TICKS_IN_THIRTY_SECONDS: 18
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.PriceProtectionScopeEnum = {
  PRICE_PROTECTION_SCOPE_UNSPECIFIED: 0,
  PRICE_PROTECTION_SCOPE_GLOBAL: 1,
  PRICE_PROTECTION_SCOPE_LOCAL: 2,
  PRICE_PROTECTION_SCOPE_NATIONAL: 3,
  PRICE_PROTECTION_SCOPE_NONE: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.TargetStrategyEnum = {
  TARGET_STRATEGY_UNSPECIFIED: 0,
  TARGET_STRATEGY_MININIZE_MARKET_IMPACT: 1,
  TARGET_STRATEGY_PARTICIPATE: 2,
  TARGET_STRATEGY_VWAP: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.TimeInForceEnum = {
  TIME_IN_FORCE_UNSPECIFIED: 0,
  TIME_IN_FORCE_AT_THE_OPENING: 1,
  TIME_IN_FORCE_DAY: 2,
  TIME_IN_FORCE_FILL_OR_KILL: 3,
  TIME_IN_FORCE_GOOD_TILL_CANCEL: 4,
  TIME_IN_FORCE_GOOD_TILL_CROSSING: 5,
  TIME_IN_FORCE_IMMEDIATE_OR_CANCEL: 6,
  TIME_IN_FORCE_GOOD_TILL_DATE: 7,
  TIME_IN_FORCE_AT_THE_CLOSE: 8,
  TIME_IN_FORCE_AT_CROSSING: 9,
  TIME_IN_FORCE_GOOD_THROUGH_CROSSING: 10
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecInstEnum = {
  EXEC_INST_UNSPECIFIED: 0,
  EXEC_INST_ALL_OR_NONE: 1,
  EXEC_INST_CALL_FIRST: 2,
  EXEC_INST_DO_NOT_INCREASE: 3,
  EXEC_INST_DO_NOT_REDUCE: 4,
  EXEC_INST_GO_ALONG: 5,
  EXEC_INST_HELD: 6,
  EXEC_INST_NOT_HELD: 7,
  EXEC_INST_NO_CROSS: 8,
  EXEC_INST_OKTO_CROSS: 9,
  EXEC_INST_OVER_THE_DAY: 10,
  EXEC_INST_PARTICIPATE_DO_NOT_INITIATE: 11,
  EXEC_INST_PERCENT_OF_VOLUME: 12,
  EXEC_INST_STAY_ON_BID_SIDE: 13,
  EXEC_INST_STAY_ON_OFFER_SIDE: 14,
  EXEC_INST_STRICT_SCALE: 15,
  EXEC_INST_TRY_TO_SCALE: 16,
  EXEC_INST_WORK: 17,
  EXEC_INST_INSTITUTIONS_ONLY: 18,
  EXEC_INST_LAST_PEG: 19,
  EXEC_INST_MARKET_PEG: 20,
  EXEC_INST_MID_PRICE_PEG: 21,
  EXEC_INST_NON_NEGOTIABLE: 22,
  EXEC_INST_OPENING_PEG: 23,
  EXEC_INST_PRIMARY_PEG: 24,
  EXEC_INST_SUSPEND: 25,
  EXEC_INST_CUSTOMER_DISPLAY_INSTRUCTION: 26,
  EXEC_INST_NETTING: 27,
  EXEC_INST_PEG_TO_VWAP: 28,
  EXEC_INST_CANCEL_ON_SYSTEM_FAILURE: 29,
  EXEC_INST_CANCEL_ON_TRADING_HALT: 30,
  EXEC_INST_REINSTATE_ON_SYSTEM_FAILURE: 31,
  EXEC_INST_REINSTATE_ON_TRADING_HALT: 32,
  EXEC_INST_TRADE_ALONG: 33,
  EXEC_INST_TRY_TO_STOP: 34,
  EXEC_INST_CANCEL_IF_NOT_BEST: 35,
  EXEC_INST_IGNORE_PRICE_VALIDITY_CHECKS: 36,
  EXEC_INST_PEG_TO_LIMIT_PRICE: 37,
  EXEC_INST_STRICT_LIMIT: 38,
  EXEC_INST_TRAILING_STOP_PEG: 39,
  EXEC_INST_WORK_TO_TARGET_STRATEGY: 40,
  EXEC_INST_INTERMARKET_SWEEP: 41,
  EXEC_INST_SINGLE_EXECUTION_REQUESTED_FOR_BLOCK_TRADE: 42,
  EXEC_INST_EXTERNAL_ROUTING_ALLOWED: 43,
  EXEC_INST_EXTERNAL_ROUTING_NOT_ALLOWED: 44,
  EXEC_INST_IMBALANCE_ONLY: 45,
  EXEC_INST_BEST_EXECUTION: 46,
  EXEC_INST_FIXED_PEG_TO_LOCAL_BEST_BID_OR_OFFER_AT_TIME_OF_ORDER: 47,
  EXEC_INST_CANCEL_ON_CONNECTION_LOSS: 48,
  EXEC_INST_REINSTATE_ON_CONNECTION_LOSS: 49,
  EXEC_INST_RELEASE_FROM_SUSPENSION: 50,
  EXEC_INST_SUSPEND_ON_CONNECTION_LOSS: 51,
  EXEC_INST_SUSPEND_ON_SYSTEM_FAILURE: 52,
  EXEC_INST_SUSPEND_ON_TRADING_HALT: 53,
  EXEC_INST_EXECUTE_AS_DELTA_NEUTRAL: 54,
  EXEC_INST_EXECUTE_AS_DURATION_NEUTRAL: 55,
  EXEC_INST_EXECUTE_AS_FX_NEUTRAL: 56
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderCapacityEnum = {
  ORDER_CAPACITY_UNSPECIFIED: 0,
  ORDER_CAPACITY_AGENCY: 1,
  ORDER_CAPACITY_AGENT_FOR_OTHER_MEMBER: 2,
  ORDER_CAPACITY_INDIVIDUAL: 3,
  ORDER_CAPACITY_PRINCIPAL: 4,
  ORDER_CAPACITY_PROPRIETARY: 5,
  ORDER_CAPACITY_RISKLESS_PRINCIPAL: 6
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderRestrictionsEnum = {
  ORDER_RESTRICTIONS_UNSPECIFIED: 0,
  ORDER_RESTRICTIONS_ACTING_AS_MARKET_MAKER_OR_SPECIALIST_IN_SECURITY: 1,
  ORDER_RESTRICTIONS_ACTING_AS_MARKET_MAKER_OR_SPECIALIST_IN_UNDERLYING: 2,
  ORDER_RESTRICTIONS_COMPETING_MARKET_MAKER: 3,
  ORDER_RESTRICTIONS_EXTERNAL_INTER_CONNECTED_MARKET_LINKAGE: 4,
  ORDER_RESTRICTIONS_EXTERNAL_MARKET_PARTICIPANT: 5,
  ORDER_RESTRICTIONS_FOREIGN_ENTITY: 6,
  ORDER_RESTRICTIONS_INDEX_ARBITRAGE: 7,
  ORDER_RESTRICTIONS_NON_INDEX_ARBITRAGE: 8,
  ORDER_RESTRICTIONS_PROGRAM_TRADE: 9,
  ORDER_RESTRICTIONS_RISKLESS_ARBITRAGE: 10,
  ORDER_RESTRICTIONS_ALGORITHMIC: 11,
  ORDER_RESTRICTIONS_NON_ALGORITHMIC: 12,
  ORDER_RESTRICTIONS_ISSUER_HOLDING: 13,
  ORDER_RESTRICTIONS_ISSUE_PRICE_STABILIZATION: 14,
  ORDER_RESTRICTIONS_CROSS: 15
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CustOrderCapacityEnum = {
  CUST_ORDER_CAPACITY_UNSPECIFIED: 0,
  CUST_ORDER_CAPACITY_ALL_OTHER: 1,
  CUST_ORDER_CAPACITY_CLEARING_FIRM_TRADING_FOR_ITS_PROPRIETARY_ACCOUNT: 2,
  CUST_ORDER_CAPACITY_MEMBER_TRADING_FOR_ANOTHER_MEMBER: 3,
  CUST_ORDER_CAPACITY_MEMBER_TRADING_FOR_THEIR_OWN_ACCOUNT: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.TradingSessionIDEnum = {
  TRADING_SESSION_ID_UNSPECIFIED: 0,
  TRADING_SESSION_ID_AFTERNOON: 1,
  TRADING_SESSION_ID_AFTER_HOURS: 2,
  TRADING_SESSION_ID_DAY: 3,
  TRADING_SESSION_ID_EVENING: 4,
  TRADING_SESSION_ID_HALF_DAY: 5,
  TRADING_SESSION_ID_MORNING: 6
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.TradingSessionSubIDEnum = {
  TRADING_SESSION_SUB_ID_UNSPECIFIED: 0,
  TRADING_SESSION_SUB_ID_CLOSING_OR_CLOSING_AUCTION: 1,
  TRADING_SESSION_SUB_ID_CONTINUOUS: 2,
  TRADING_SESSION_SUB_ID_INTRADAY_AUCTION: 3,
  TRADING_SESSION_SUB_ID_OPENING_OR_OPENING_AUCTION: 4,
  TRADING_SESSION_SUB_ID_POST_TRADING: 5,
  TRADING_SESSION_SUB_ID_PRE_TRADING: 6,
  TRADING_SESSION_SUB_ID_QUIESCENT: 7
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.LastCapacityEnum = {
  LAST_CAPACITY_UNSPECIFIED: 0,
  LAST_CAPACITY_AGENT: 1,
  LAST_CAPACITY_CROSS_AS_AGENT: 2,
  LAST_CAPACITY_CROSS_AS_PRINCIPAL: 3,
  LAST_CAPACITY_PRINCIPAL: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.GTBookingInstEnum = {
  GT_BOOKING_INST_UNSPECIFIED: 0,
  GT_BOOKING_INST_ACCUMULATE_UNTIL_FILLED_OR_EXPIRED: 1,
  GT_BOOKING_INST_ACCUMULATE_UNTIL_VERBALLLY_NOTIFIED_OTHERWISE: 2,
  GT_BOOKING_INST_BOOK_OUT_ALL_TRADES_ON_DAY_OF_EXECUTION: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.SettlCurrFxRateCalcEnum = {
  SETTL_CURR_FX_RATE_CALC_UNSPECIFIED: 0,
  SETTL_CURR_FX_RATE_CALC_DIVIDE: 1,
  SETTL_CURR_FX_RATE_CALC_MULTIPLY: 2
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.HandlInstEnum = {
  HANDL_INST_UNSPECIFIED: 0,
  HANDL_INST_AUTOMATED_EXECUTION_INTERVENTION_OK: 1,
  HANDL_INST_AUTOMATED_EXECUTION_NO_INTERVENTION: 2,
  HANDL_INST_MANUAL_ORDER: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.PositionEffectEnum = {
  POSITION_EFFECT_UNSPECIFIED: 0,
  POSITION_EFFECT_CLOSE: 1,
  POSITION_EFFECT_OPEN: 2,
  POSITION_EFFECT_FIFO: 3,
  POSITION_EFFECT_ROLLED: 4,
  POSITION_EFFECT_CLOSE_BUT_NOTIFY_ON_OPEN: 5,
  POSITION_EFFECT_DEFAULT: 6
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.BookingTypeEnum = {
  BOOKING_TYPE_UNSPECIFIED: 0,
  BOOKING_TYPE_CFD: 1,
  BOOKING_TYPE_REGULAR_BOOKING: 2,
  BOOKING_TYPE_TOTAL_RETURN_SWAP: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.MultiLegReportingTypeEnum = {
  MULTI_LEG_REPORTING_TYPE_UNSPECIFIED: 0,
  MULTI_LEG_REPORTING_TYPE_INDIVIDUAL_LEG_OF_AMULTI_LEG_SECURITY: 1,
  MULTI_LEG_REPORTING_TYPE_MULTI_LEG_SECURITY: 2,
  MULTI_LEG_REPORTING_TYPE_SINGLE_SECURITY: 3
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CancellationRightsEnum = {
  CANCELLATION_RIGHTS_UNSPECIFIED: 0,
  CANCELLATION_RIGHTS_NO_EXECUTION_ONLY: 1,
  CANCELLATION_RIGHTS_NO_INSTITUTIONAL: 2,
  CANCELLATION_RIGHTS_NO_WAIVER_AGREEMENT: 3,
  CANCELLATION_RIGHTS_YES: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.MoneyLaunderingStatusEnum = {
  MONEY_LAUNDERING_STATUS_UNSPECIFIED: 0,
  MONEY_LAUNDERING_STATUS_EXEMPT_AUTHORISED: 1,
  MONEY_LAUNDERING_STATUS_EXEMPT_BELOW_LIMIT: 2,
  MONEY_LAUNDERING_STATUS_EXEMPT_MONEY_TYPE: 3,
  MONEY_LAUNDERING_STATUS_NOT_CHECKED: 4,
  MONEY_LAUNDERING_STATUS_PASSED: 5
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecPriceTypeEnum = {
  EXEC_PRICE_TYPE_UNSPECIFIED: 0,
  EXEC_PRICE_TYPE_BID_PRICE: 1,
  EXEC_PRICE_TYPE_CREATION_PRICE: 2,
  EXEC_PRICE_TYPE_CREATION_PRICE_PLUS_ADJUSTMENT_AMOUNT: 3,
  EXEC_PRICE_TYPE_CREATION_PRICE_PLUS_ADJUSTMENT_PERCENT: 4,
  EXEC_PRICE_TYPE_OFFER_PRICE: 5,
  EXEC_PRICE_TYPE_OFFER_PRICE_MINUS_ADJUSTMENT_AMOUNT: 6,
  EXEC_PRICE_TYPE_OFFER_PRICE_MINUS_ADJUSTMENT_PERCENT: 7,
  EXEC_PRICE_TYPE_SINGLE_PRICE: 8
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.PriorityIndicatorEnum = {
  PRIORITY_INDICATOR_UNSPECIFIED: 0,
  PRIORITY_INDICATOR_LOST_PRIORITY_AS_RESULT_OF_ORDER_CHANGE: 1,
  PRIORITY_INDICATOR_PRIORITY_UNCHANGED: 2
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.LastLiquidityIndEnum = {
  LAST_LIQUIDITY_IND_UNSPECIFIED: 0,
  LAST_LIQUIDITY_IND_ADDED_LIQUIDITY: 1,
  LAST_LIQUIDITY_IND_LIQUIDITY_ROUTED_OUT: 2,
  LAST_LIQUIDITY_IND_REMOVED_LIQUIDITY: 3,
  LAST_LIQUIDITY_IND_AUCTION: 4
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CustOrderHandlingInstEnum = {
  CUST_ORDER_HANDLING_INST_UNSPECIFIED: 0,
  CUST_ORDER_HANDLING_INST_ADD_ON_ORDER: 1,
  CUST_ORDER_HANDLING_INST_ALL_OR_NONE: 2,
  CUST_ORDER_HANDLING_INST_CASH_NOT_HELD: 3,
  CUST_ORDER_HANDLING_INST_DIRECTED_ORDER: 4,
  CUST_ORDER_HANDLING_INST_EXCHANGE_FOR_PHYSICAL_TRANSACTION: 5,
  CUST_ORDER_HANDLING_INST_FILL_OR_KILL: 6,
  CUST_ORDER_HANDLING_INST_IMBALANCE_ONLY: 7,
  CUST_ORDER_HANDLING_INST_IMMEDIATE_OR_CANCEL: 8,
  CUST_ORDER_HANDLING_INST_LIMIT_ON_CLOSE: 9,
  CUST_ORDER_HANDLING_INST_LIMIT_ON_OPEN: 10,
  CUST_ORDER_HANDLING_INST_MARKET_AT_CLOSE: 11,
  CUST_ORDER_HANDLING_INST_MARKET_AT_OPEN: 12,
  CUST_ORDER_HANDLING_INST_MARKET_ON_CLOSE: 13,
  CUST_ORDER_HANDLING_INST_MARKET_ON_OPEN: 14,
  CUST_ORDER_HANDLING_INST_MINIMUM_QUANTITY: 15,
  CUST_ORDER_HANDLING_INST_NOT_HELD: 16,
  CUST_ORDER_HANDLING_INST_OVER_THE_DAY: 17,
  CUST_ORDER_HANDLING_INST_PEGGED: 18,
  CUST_ORDER_HANDLING_INST_RESERVE_SIZE_ORDER: 19,
  CUST_ORDER_HANDLING_INST_SCALE: 20,
  CUST_ORDER_HANDLING_INST_STOP_STOCK_TRANSACTION: 21,
  CUST_ORDER_HANDLING_INST_TIME_ORDER: 22,
  CUST_ORDER_HANDLING_INST_TRAILING_STOP: 23,
  CUST_ORDER_HANDLING_INST_WORK: 24
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.OrderHandlingInstSourceEnum = {
  ORDER_HANDLING_INST_SOURCE_UNSPECIFIED: 0,
  ORDER_HANDLING_INST_SOURCE_NASDOATS: 1
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CxlRejResponseToEnum = {
  CXL_REJ_RESPONSE_TO_UNSPECIFIED: 0,
  CXL_REJ_RESPONSE_TO_ORDER_CANCEL: 1,
  CXL_REJ_RESPONSE_TO_ORDER_CANCEL_REQUEST: 2
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CxlRejReasonEnum = {
  CXL_REJ_REASON_UNSPECIFIED: 0,
  CXL_REJ_REASON_TOO_LATE_TO_CANCEL: 1,
  CXL_REJ_REASON_UNKNOWN_ORDER: 2,
  CXL_REJ_REASON_BROKER_CREDIT: 3,
  CXL_REJ_REASON_ORDER_ALREADY_IN_PENDING_STATUS: 4,
  CXL_REJ_REASON_DUPLICATE_CL_ORD_ID: 5,
  CXL_REJ_REASON_ORIG_ORD_MOD_TIME: 6,
  CXL_REJ_REASON_UNABLE_TO_PROCESS_ORDER_MASS_CANCEL_REQUEST: 7,
  CXL_REJ_REASON_OTHER: 8,
  CXL_REJ_REASON_INVALID_PRICE_INCREMENT: 9,
  CXL_REJ_REASON_PRICE_EXCEEDS_CURRENT_PRICE: 10,
  CXL_REJ_REASON_PRICE_EXCEEDS_CURRENT_PRICE_BAND: 11
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExDestinationIDSourceEnum = {
  EX_DESTINATION_ID_SOURCE_UNSPECIFIED: 0,
  EX_DESTINATION_ID_SOURCE_BIC: 1,
  EX_DESTINATION_ID_SOURCE_GENERAL_IDENTIFIER: 2,
  EX_DESTINATION_ID_SOURCE_ISO_COUNTRY_CODE: 3,
  EX_DESTINATION_ID_SOURCE_MIC: 4,
  EX_DESTINATION_ID_SOURCE_PROPRIETARY: 5
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ProcessCodeEnum = {
  PROCESS_CODE_UNSPECIFIED: 0,
  PROCESS_CODE_REGULAR: 1,
  PROCESS_CODE_SOFT_DOLLAR: 2,
  PROCESS_CODE_SOFT_DOLLAR_STEP_IN: 3,
  PROCESS_CODE_SOFT_DOLLAR_STEP_OUT: 4,
  PROCESS_CODE_STEP_IN: 5,
  PROCESS_CODE_STEP_OUT: 6,
  PROCESS_CODE_PLAN_SPONSOR: 7
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.CoveredOrUncoveredEnum = {
  COVERED_OR_UNCOVERED_UNSPECIFIED: 0,
  COVERED_OR_UNCOVERED_COVERED: 1,
  COVERED_OR_UNCOVERED_UNCOVERED: 2
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.RefOrderIDSourceEnum = {
  REF_ORDER_ID_SOURCE_UNSPECIFIED: 0,
  REF_ORDER_ID_SOURCE_MD_ENTRY_ID: 1,
  REF_ORDER_ID_SOURCE_ORDER_ID: 2,
  REF_ORDER_ID_SOURCE_QUOTE_ENTRY_ID: 3,
  REF_ORDER_ID_SOURCE_SECONDARY_ORDER_ID: 4,
  REF_ORDER_ID_SOURCE_ORIGINAL_ORDER_ID: 5
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.DKReasonEnum = {
  DKREASON_UNSPECIFIED: 0,
  DKREASON_NO_MATCHING_ORDER: 1,
  DKREASON_OTHER: 2,
  DKREASON_PRICE_EXCEEDS_LIMIT: 3,
  DKREASON_QUANTITY_EXCEEDS_ORDER: 4,
  DKREASON_UNKNOWN_SYMBOL: 5,
  DKREASON_WRONG_SIDE: 6,
  DKREASON_CALCULATION_DIFFERENCE: 7
};

/**
 * @enum {number}
 */
proto.SingleGeneralOrderHandling.ExecAckStatusEnum = {
  EXEC_ACK_STATUS_UNSPECIFIED: 0,
  EXEC_ACK_STATUS_ACCEPTED: 1,
  EXEC_ACK_STATUS_DON: 2,
  EXEC_ACK_STATUS_RECEIVED: 3
};

goog.object.extend(exports, proto.SingleGeneralOrderHandling);
